import React__default, { forwardRef, createElement } from 'react';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/master/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    }
    return _assertThisInitialized(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Check if a string ends with something
 * @private
 */


function endsWith(string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @deprecated - stripUnit's unitReturn functionality has been marked for deprecation in polished 4.0. It's functionality has been been moved to getValueAndUnit.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value, unitReturn) {
  if (typeof value !== 'string') return unitReturn ? [value, undefined] : value;
  var matchedValue = value.match(cssRegex);

  if (unitReturn) {
    // eslint-disable-next-line no-console
    console.warn("stripUnit's unitReturn functionality has been marked for deprecation in polished 4.0. It's functionality has been been moved to getValueAndUnit.");
    if (matchedValue) return [parseFloat(value), matchedValue[2]];
    return [value, undefined];
  }

  if (matchedValue) return parseFloat(value);
  return value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */


var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return "" + newPxval / newBase + to;
  };
};
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */


var rem = /*#__PURE__*/pxtoFactory('rem');

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var changedArray = function changedArray(a, b) {
  if (a === void 0) {
    a = [];
  }

  if (b === void 0) {
    b = [];
  }

  return a.length !== b.length || a.some(function (item, index) {
    return !Object.is(item, b[index]);
  });
};

var initialState = {
  error: null,
  info: null
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = initialState;

    _this.resetErrorBoundary = function () {
      var _this$props;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

      _this.setState(initialState);
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;

    (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info == null ? void 0 : info.componentStack);
    this.setState({
      error: error,
      info: info
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var error = this.state.error;
    var resetKeys = this.props.resetKeys;

    if (error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
      var _this$props$onResetKe, _this$props3;

      (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
      this.setState(initialState);
    }
  };

  _proto.render = function render() {
    var _this$state = this.state,
        error = _this$state.error,
        info = _this$state.info;
    var _this$props4 = this.props,
        fallbackRender = _this$props4.fallbackRender,
        FallbackComponent = _this$props4.FallbackComponent,
        fallback = _this$props4.fallback;

    if (error !== null) {
      var props = {
        componentStack: info == null ? void 0 : info.componentStack,
        error: error,
        resetErrorBoundary: this.resetErrorBoundary
      };

      if ( /*#__PURE__*/React__default.isValidElement(fallback)) {
        return fallback;
      } else if (typeof fallbackRender === 'function') {
        return fallbackRender(props);
      } else if (typeof FallbackComponent === 'function') {
        return /*#__PURE__*/React__default.createElement(FallbackComponent, props);
      } else {
        throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
      }
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(React__default.Component); // Grey


var COLOR_GREY_100 = '#f6f6f6';
var COLOR_GREY_200 = '#f0f0f0';
var COLOR_GREY_300 = '#e1e1e1';
var COLOR_GREY_400 = '#d5d5d5';
var COLOR_GREY_500 = '#cacaca';
var COLOR_GREY_600 = '#adadad';
var COLOR_GREY_700 = '#9a9a9a';
var COLOR_GREY_800 = '#727272';
var COLOR_GREY_900 = '#464646';
var COLOR_GREY_1000 = '#282929'; // Blue

var COLOR_BLUE_100 = '#f5fafe';
var COLOR_BLUE_200 = '#e6f1ff';
var COLOR_BLUE_300 = '#b1d5ff';
var COLOR_BLUE_400 = '#88beff';
var COLOR_BLUE_500 = '#62a9fc';
var COLOR_BLUE_600 = '#4396f7';
var COLOR_BLUE_700 = '#0170ff';
var COLOR_BLUE_800 = '#015fd8';
var COLOR_BLUE_900 = '#004db0';
var COLOR_BLUE_1000 = '#003a85'; // Cyan

var COLOR_CYAN_100 = '#ebf8fa';
var COLOR_CYAN_200 = '#c9eaf3';
var COLOR_CYAN_300 = '#a0dce8';
var COLOR_CYAN_400 = '#7ccad9';
var COLOR_CYAN_500 = '#4db1cb';
var COLOR_CYAN_600 = '#1c9ecb';
var COLOR_CYAN_700 = '#0d8bb7';
var COLOR_CYAN_800 = '#0378a1';
var COLOR_CYAN_900 = '#006086';
var COLOR_CYAN_1000 = '#00435d'; // Omilia Blue

var COLOR_OMILIA_BLUE_100 = '#f2f6ff';
var COLOR_OMILIA_BLUE_200 = '#d3deff';
var COLOR_OMILIA_BLUE_300 = '#a8beff';
var COLOR_OMILIA_BLUE_400 = '#94afff';
var COLOR_OMILIA_BLUE_500 = '#889ee2';
var COLOR_OMILIA_BLUE_600 = '#7087cc';
var COLOR_OMILIA_BLUE_700 = '#5369ad';
var COLOR_OMILIA_BLUE_800 = '#46547e';
var COLOR_OMILIA_BLUE_900 = '#35467a';
var COLOR_OMILIA_BLUE_1000 = '#2e3c64'; // Omilia Purple

var COLOR_OMILIA_PURPLE_100 = '#fafaff';
var COLOR_OMILIA_PURPLE_200 = '#f0f0ff';
var COLOR_OMILIA_PURPLE_300 = '#dcdcff';
var COLOR_OMILIA_PURPLE_400 = '#c3c3ff';
var COLOR_OMILIA_PURPLE_500 = '#afaff5';
var COLOR_OMILIA_PURPLE_600 = '#9a9ae5';
var COLOR_OMILIA_PURPLE_700 = '#8888d0';
var COLOR_OMILIA_PURPLE_800 = '#7878b9';
var COLOR_OMILIA_PURPLE_900 = '#6363a0';
var COLOR_OMILIA_PURPLE_1000 = '#4d4d85'; // Deep Purple

var COLOR_DEEP_PURPLE_100 = '#f5f5ff';
var COLOR_DEEP_PURPLE_200 = '#e7e7ff';
var COLOR_DEEP_PURPLE_300 = '#d2d2ff';
var COLOR_DEEP_PURPLE_400 = '#b1b1ff';
var COLOR_DEEP_PURPLE_500 = '#9798ff';
var COLOR_DEEP_PURPLE_600 = '#8283fb';
var COLOR_DEEP_PURPLE_700 = '#7172ee';
var COLOR_DEEP_PURPLE_800 = '#5f60e2';
var COLOR_DEEP_PURPLE_900 = '#4a4bc9';
var COLOR_DEEP_PURPLE_1000 = '#3c3ca1'; // Purple

var COLOR_PURPLE_100 = '#fbf7ff';
var COLOR_PURPLE_200 = '#f9efff';
var COLOR_PURPLE_300 = '#ecd4fe';
var COLOR_PURPLE_400 = '#d9adff';
var COLOR_PURPLE_500 = '#c088f1';
var COLOR_PURPLE_600 = '#a96cdf';
var COLOR_PURPLE_700 = '#9b57d6';
var COLOR_PURPLE_800 = '#8547be';
var COLOR_PURPLE_900 = '#6c34a0';
var COLOR_PURPLE_1000 = '#48226e'; // Magenta

var COLOR_MAGENTA_100 = '#fff8ff';
var COLOR_MAGENTA_200 = '#f9ddff';
var COLOR_MAGENTA_300 = '#f4beff';
var COLOR_MAGENTA_400 = '#ee9cff';
var COLOR_MAGENTA_500 = '#e879ff';
var COLOR_MAGENTA_600 = '#e048ff';
var COLOR_MAGENTA_700 = '#d435f5';
var COLOR_MAGENTA_800 = '#bd10e0';
var COLOR_MAGENTA_900 = '#9911b7';
var COLOR_MAGENTA_1000 = '#64047a'; // Red

var COLOR_RED_100 = '#fff4f6';
var COLOR_RED_200 = '#ffdfe2';
var COLOR_RED_300 = '#ffcdd4';
var COLOR_RED_400 = '#f8afba';
var COLOR_RED_500 = '#ff8595';
var COLOR_RED_600 = '#f8586d';
var COLOR_RED_700 = '#ec324b';
var COLOR_RED_800 = '#cb2026';
var COLOR_RED_900 = '#af071a';
var COLOR_RED_1000 = '#810210'; // Pink

var COLOR_PINK_100 = '#fff3ff';
var COLOR_PINK_200 = '#ffe5f9';
var COLOR_PINK_300 = '#ffbfe7';
var COLOR_PINK_400 = '#ffa0d7';
var COLOR_PINK_500 = '#ff81c8';
var COLOR_PINK_600 = '#f662a7';
var COLOR_PINK_700 = '#e74e98';
var COLOR_PINK_800 = '#d64081';
var COLOR_PINK_900 = '#ba3a73';
var COLOR_PINK_1000 = '#9a235f'; // Orange

var COLOR_ORANGE_100 = '#fffbf2';
var COLOR_ORANGE_200 = '#ffd993';
var COLOR_ORANGE_300 = '#ffc253';
var COLOR_ORANGE_400 = '#fbac40';
var COLOR_ORANGE_500 = '#ef9923';
var COLOR_ORANGE_600 = '#e48708';
var COLOR_ORANGE_700 = '#d37a00';
var COLOR_ORANGE_800 = '#c46800';
var COLOR_ORANGE_900 = '#8c4206';
var COLOR_ORANGE_1000 = '#643212'; // Yellow

var COLOR_YELLOW_100 = '#ffffee';
var COLOR_YELLOW_200 = '#fff9c4';
var COLOR_YELLOW_300 = '#ffef7b';
var COLOR_YELLOW_400 = '#ffdd4b';
var COLOR_YELLOW_500 = '#ffcb2c';
var COLOR_YELLOW_600 = '#ffba1c';
var COLOR_YELLOW_700 = '#f4aa15';
var COLOR_YELLOW_800 = '#d9950a';
var COLOR_YELLOW_900 = '#b17e24';
var COLOR_YELLOW_1000 = '#946410'; // Green

var COLOR_GREEN_100 = '#e1fee4';
var COLOR_GREEN_200 = '#cdfbca';
var COLOR_GREEN_300 = '#a3ee9e';
var COLOR_GREEN_400 = '#80e678';
var COLOR_GREEN_500 = '#65d46b';
var COLOR_GREEN_600 = '#39be68';
var COLOR_GREEN_700 = '#1caf61';
var COLOR_GREEN_800 = '#0f9356';
var COLOR_GREEN_900 = '#0e734e';
var COLOR_GREEN_1000 = '#025838'; // Teal

var COLOR_TEAL_100 = '#d7fff5';
var COLOR_TEAL_200 = '#bdfde9';
var COLOR_TEAL_300 = '#89f5d3';
var COLOR_TEAL_400 = '#30ecba';
var COLOR_TEAL_500 = '#17d1a8';
var COLOR_TEAL_600 = '#1ebb97';
var COLOR_TEAL_700 = '#15a289';
var COLOR_TEAL_800 = '#0f8879';
var COLOR_TEAL_900 = '#0c7160';
var COLOR_TEAL_1000 = '#114a43'; // Black & White

var COLOR_BLACK = '#000000';
var COLOR_WHITE = '#ffffff'; // Brand

var COLOR_BRAND = COLOR_OMILIA_BLUE_600;
var COLOR_BRAND_PURPLE = COLOR_OMILIA_PURPLE_800; // Alerts

var COLOR_ALERT_SUCCESS = COLOR_TEAL_600;
var COLOR_ALERT_WARNING = COLOR_ORANGE_500;
var COLOR_ALERT_ERROR = COLOR_RED_600; // Disabled

var COLOR_DISABLED = COLOR_GREY_600;
var colors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  COLOR_GREY_100: COLOR_GREY_100,
  COLOR_GREY_200: COLOR_GREY_200,
  COLOR_GREY_300: COLOR_GREY_300,
  COLOR_GREY_400: COLOR_GREY_400,
  COLOR_GREY_500: COLOR_GREY_500,
  COLOR_GREY_600: COLOR_GREY_600,
  COLOR_GREY_700: COLOR_GREY_700,
  COLOR_GREY_800: COLOR_GREY_800,
  COLOR_GREY_900: COLOR_GREY_900,
  COLOR_GREY_1000: COLOR_GREY_1000,
  COLOR_BLUE_100: COLOR_BLUE_100,
  COLOR_BLUE_200: COLOR_BLUE_200,
  COLOR_BLUE_300: COLOR_BLUE_300,
  COLOR_BLUE_400: COLOR_BLUE_400,
  COLOR_BLUE_500: COLOR_BLUE_500,
  COLOR_BLUE_600: COLOR_BLUE_600,
  COLOR_BLUE_700: COLOR_BLUE_700,
  COLOR_BLUE_800: COLOR_BLUE_800,
  COLOR_BLUE_900: COLOR_BLUE_900,
  COLOR_BLUE_1000: COLOR_BLUE_1000,
  COLOR_CYAN_100: COLOR_CYAN_100,
  COLOR_CYAN_200: COLOR_CYAN_200,
  COLOR_CYAN_300: COLOR_CYAN_300,
  COLOR_CYAN_400: COLOR_CYAN_400,
  COLOR_CYAN_500: COLOR_CYAN_500,
  COLOR_CYAN_600: COLOR_CYAN_600,
  COLOR_CYAN_700: COLOR_CYAN_700,
  COLOR_CYAN_800: COLOR_CYAN_800,
  COLOR_CYAN_900: COLOR_CYAN_900,
  COLOR_CYAN_1000: COLOR_CYAN_1000,
  COLOR_OMILIA_BLUE_100: COLOR_OMILIA_BLUE_100,
  COLOR_OMILIA_BLUE_200: COLOR_OMILIA_BLUE_200,
  COLOR_OMILIA_BLUE_300: COLOR_OMILIA_BLUE_300,
  COLOR_OMILIA_BLUE_400: COLOR_OMILIA_BLUE_400,
  COLOR_OMILIA_BLUE_500: COLOR_OMILIA_BLUE_500,
  COLOR_OMILIA_BLUE_600: COLOR_OMILIA_BLUE_600,
  COLOR_OMILIA_BLUE_700: COLOR_OMILIA_BLUE_700,
  COLOR_OMILIA_BLUE_800: COLOR_OMILIA_BLUE_800,
  COLOR_OMILIA_BLUE_900: COLOR_OMILIA_BLUE_900,
  COLOR_OMILIA_BLUE_1000: COLOR_OMILIA_BLUE_1000,
  COLOR_OMILIA_PURPLE_100: COLOR_OMILIA_PURPLE_100,
  COLOR_OMILIA_PURPLE_200: COLOR_OMILIA_PURPLE_200,
  COLOR_OMILIA_PURPLE_300: COLOR_OMILIA_PURPLE_300,
  COLOR_OMILIA_PURPLE_400: COLOR_OMILIA_PURPLE_400,
  COLOR_OMILIA_PURPLE_500: COLOR_OMILIA_PURPLE_500,
  COLOR_OMILIA_PURPLE_600: COLOR_OMILIA_PURPLE_600,
  COLOR_OMILIA_PURPLE_700: COLOR_OMILIA_PURPLE_700,
  COLOR_OMILIA_PURPLE_800: COLOR_OMILIA_PURPLE_800,
  COLOR_OMILIA_PURPLE_900: COLOR_OMILIA_PURPLE_900,
  COLOR_OMILIA_PURPLE_1000: COLOR_OMILIA_PURPLE_1000,
  COLOR_DEEP_PURPLE_100: COLOR_DEEP_PURPLE_100,
  COLOR_DEEP_PURPLE_200: COLOR_DEEP_PURPLE_200,
  COLOR_DEEP_PURPLE_300: COLOR_DEEP_PURPLE_300,
  COLOR_DEEP_PURPLE_400: COLOR_DEEP_PURPLE_400,
  COLOR_DEEP_PURPLE_500: COLOR_DEEP_PURPLE_500,
  COLOR_DEEP_PURPLE_600: COLOR_DEEP_PURPLE_600,
  COLOR_DEEP_PURPLE_700: COLOR_DEEP_PURPLE_700,
  COLOR_DEEP_PURPLE_800: COLOR_DEEP_PURPLE_800,
  COLOR_DEEP_PURPLE_900: COLOR_DEEP_PURPLE_900,
  COLOR_DEEP_PURPLE_1000: COLOR_DEEP_PURPLE_1000,
  COLOR_PURPLE_100: COLOR_PURPLE_100,
  COLOR_PURPLE_200: COLOR_PURPLE_200,
  COLOR_PURPLE_300: COLOR_PURPLE_300,
  COLOR_PURPLE_400: COLOR_PURPLE_400,
  COLOR_PURPLE_500: COLOR_PURPLE_500,
  COLOR_PURPLE_600: COLOR_PURPLE_600,
  COLOR_PURPLE_700: COLOR_PURPLE_700,
  COLOR_PURPLE_800: COLOR_PURPLE_800,
  COLOR_PURPLE_900: COLOR_PURPLE_900,
  COLOR_PURPLE_1000: COLOR_PURPLE_1000,
  COLOR_MAGENTA_100: COLOR_MAGENTA_100,
  COLOR_MAGENTA_200: COLOR_MAGENTA_200,
  COLOR_MAGENTA_300: COLOR_MAGENTA_300,
  COLOR_MAGENTA_400: COLOR_MAGENTA_400,
  COLOR_MAGENTA_500: COLOR_MAGENTA_500,
  COLOR_MAGENTA_600: COLOR_MAGENTA_600,
  COLOR_MAGENTA_700: COLOR_MAGENTA_700,
  COLOR_MAGENTA_800: COLOR_MAGENTA_800,
  COLOR_MAGENTA_900: COLOR_MAGENTA_900,
  COLOR_MAGENTA_1000: COLOR_MAGENTA_1000,
  COLOR_RED_100: COLOR_RED_100,
  COLOR_RED_200: COLOR_RED_200,
  COLOR_RED_300: COLOR_RED_300,
  COLOR_RED_400: COLOR_RED_400,
  COLOR_RED_500: COLOR_RED_500,
  COLOR_RED_600: COLOR_RED_600,
  COLOR_RED_700: COLOR_RED_700,
  COLOR_RED_800: COLOR_RED_800,
  COLOR_RED_900: COLOR_RED_900,
  COLOR_RED_1000: COLOR_RED_1000,
  COLOR_PINK_100: COLOR_PINK_100,
  COLOR_PINK_200: COLOR_PINK_200,
  COLOR_PINK_300: COLOR_PINK_300,
  COLOR_PINK_400: COLOR_PINK_400,
  COLOR_PINK_500: COLOR_PINK_500,
  COLOR_PINK_600: COLOR_PINK_600,
  COLOR_PINK_700: COLOR_PINK_700,
  COLOR_PINK_800: COLOR_PINK_800,
  COLOR_PINK_900: COLOR_PINK_900,
  COLOR_PINK_1000: COLOR_PINK_1000,
  COLOR_ORANGE_100: COLOR_ORANGE_100,
  COLOR_ORANGE_200: COLOR_ORANGE_200,
  COLOR_ORANGE_300: COLOR_ORANGE_300,
  COLOR_ORANGE_400: COLOR_ORANGE_400,
  COLOR_ORANGE_500: COLOR_ORANGE_500,
  COLOR_ORANGE_600: COLOR_ORANGE_600,
  COLOR_ORANGE_700: COLOR_ORANGE_700,
  COLOR_ORANGE_800: COLOR_ORANGE_800,
  COLOR_ORANGE_900: COLOR_ORANGE_900,
  COLOR_ORANGE_1000: COLOR_ORANGE_1000,
  COLOR_YELLOW_100: COLOR_YELLOW_100,
  COLOR_YELLOW_200: COLOR_YELLOW_200,
  COLOR_YELLOW_300: COLOR_YELLOW_300,
  COLOR_YELLOW_400: COLOR_YELLOW_400,
  COLOR_YELLOW_500: COLOR_YELLOW_500,
  COLOR_YELLOW_600: COLOR_YELLOW_600,
  COLOR_YELLOW_700: COLOR_YELLOW_700,
  COLOR_YELLOW_800: COLOR_YELLOW_800,
  COLOR_YELLOW_900: COLOR_YELLOW_900,
  COLOR_YELLOW_1000: COLOR_YELLOW_1000,
  COLOR_GREEN_100: COLOR_GREEN_100,
  COLOR_GREEN_200: COLOR_GREEN_200,
  COLOR_GREEN_300: COLOR_GREEN_300,
  COLOR_GREEN_400: COLOR_GREEN_400,
  COLOR_GREEN_500: COLOR_GREEN_500,
  COLOR_GREEN_600: COLOR_GREEN_600,
  COLOR_GREEN_700: COLOR_GREEN_700,
  COLOR_GREEN_800: COLOR_GREEN_800,
  COLOR_GREEN_900: COLOR_GREEN_900,
  COLOR_GREEN_1000: COLOR_GREEN_1000,
  COLOR_TEAL_100: COLOR_TEAL_100,
  COLOR_TEAL_200: COLOR_TEAL_200,
  COLOR_TEAL_300: COLOR_TEAL_300,
  COLOR_TEAL_400: COLOR_TEAL_400,
  COLOR_TEAL_500: COLOR_TEAL_500,
  COLOR_TEAL_600: COLOR_TEAL_600,
  COLOR_TEAL_700: COLOR_TEAL_700,
  COLOR_TEAL_800: COLOR_TEAL_800,
  COLOR_TEAL_900: COLOR_TEAL_900,
  COLOR_TEAL_1000: COLOR_TEAL_1000,
  COLOR_BLACK: COLOR_BLACK,
  COLOR_WHITE: COLOR_WHITE,
  COLOR_BRAND: COLOR_BRAND,
  COLOR_BRAND_PURPLE: COLOR_BRAND_PURPLE,
  COLOR_ALERT_SUCCESS: COLOR_ALERT_SUCCESS,
  COLOR_ALERT_WARNING: COLOR_ALERT_WARNING,
  COLOR_ALERT_ERROR: COLOR_ALERT_ERROR,
  COLOR_DISABLED: COLOR_DISABLED
});

var Actions = function Actions(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.727 0L4 13.646h5.091L5.178 24l14.055-13.647H14.14z"
  })));
};

Actions.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AddField = function AddField(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.464 0L1 5.464V24h8.314v-1.846H2.846V6.769h4.923V1.846H18.23v8.392h1.847V0H6.464zM17.5 13a1 1 0 0 1 1 1v3.5H22a1 1 0 0 1 0 2h-3.5V23a1 1 0 0 1-2 0v-3.501L13 19.5a1 1 0 0 1 0-2l3.5-.001V14a1 1 0 0 1 1-1zM5.923 3.152v1.771H4.151l1.772-1.771z",
    fill: "currentColor"
  })));
};

AddField.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AddMapIntent = function AddMapIntent(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.571 11.203a6.857 6.857 0 1 1-10.252 5.254H9.236L3.75 20.571v-4.114H2.057A2.06 2.06 0 0 1 0 14.4V2.057C0 .922.923 0 2.057 0h16.457c1.135 0 2.057.922 2.057 2.057v9.146zm-2.165-.801V2.286H2.166V14.17h3.75v1.972l2.628-1.972h2.417a6.858 6.858 0 0 1 7.445-3.77zm3.144 5.617h-3.267v-3.24l-.124-.124h-1.944l-.125.124v3.24h-3.267l-.125.124v2.019l.125.125h3.267v3.22l.125.124h1.944l.124-.125v-3.22h3.267l.125-.124v-2.019l-.125-.124zm-6.767-6.417a1.31 1.31 0 1 1 0-2.618 1.31 1.31 0 0 1 0 2.618zm-4.572 0a1.31 1.31 0 1 1 0-2.618 1.31 1.31 0 0 1 0 2.618zm-4.571 0a1.31 1.31 0 1 1 0-2.618 1.31 1.31 0 0 1 0 2.618z",
    fill: "currentColor"
  })));
};

AddMapIntent.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AddProject = function AddProject(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16 16h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3zm-5.244 4.167A6.97 6.97 0 0 1 10 17a6.97 6.97 0 0 1 .799-3.25H1.833v6.417h8.923zM12.1 22H0V3.667h1.833V0h6.333v3.667h4.668V0h6.332v3.667H21v7.588A7 7 0 1 1 12.1 22zm7.065-11.658V5.5H1.834v6.417h10.353A6.976 6.976 0 0 1 17 10c.756 0 1.484.12 2.166.342zm-15.5-6.676h2.667V1.833H3.666v1.833zm11 0h2.668V1.833h-2.668v1.833z",
    fill: "currentColor"
  })));
};

AddProject.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleDown = function AngleDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.877 6L12 12.878 5.123 6 3 8.122l9 9 9-9z"
  })));
};

AngleDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleLeft = function AngleLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M15.001 3L6 12l9.001 9 2.123-2.123L10.246 12l6.878-6.878z"
  })));
};

AngleLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleRight = function AngleRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8.122 3L6 5.123l6.877 6.878L6 18.88l2.122 2.12 9-8.998z"
  })));
};

AngleRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleSquareDown = function AngleSquareDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.69 24C2.105 24 0 21.972 0 19.478V4.522C0 2.028 2.104 0 4.69 0h14.62C21.895 0 24 2.028 24 4.522v14.954C23.998 21.972 21.895 24 19.308 24H4.69zM16.586 9L12 13.328 7.415 9 6 10.336 12 16l6-5.664L16.585 9zM4.691 1.65c-1.642 0-2.979 1.29-2.979 2.872v14.954c0 1.582 1.337 2.871 2.979 2.871h14.616c1.642 0 2.979-1.289 2.979-2.871V4.522c0-1.582-1.337-2.871-2.979-2.871H4.691z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

AngleSquareDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleSquareUp = function AngleSquareUp(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.69 24C2.105 24 0 21.972 0 19.478V4.522C0 2.028 2.104 0 4.69 0h14.62C21.895 0 24 2.028 24 4.522v14.954C23.998 21.972 21.895 24 19.308 24H4.69zm2.725-9L12 10.672 16.585 15 18 13.664 12 8l-6 5.664L7.415 15zM4.691 1.65c-1.642 0-2.979 1.29-2.979 2.872v14.954c0 1.582 1.337 2.871 2.979 2.871h14.616c1.642 0 2.979-1.289 2.979-2.871V4.522c0-1.582-1.337-2.871-2.979-2.871H4.691z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

AngleSquareUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AngleUp = function AngleUp(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M3 15l2.123 2.123L12 10.245l6.878 6.878L21 15l-9-9z"
  })));
};

AngleUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Annotations = function Annotations(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2 5.956c-1.105 0-2-.886-2-1.978A1.99 1.99 0 0 1 2 2c1.105 0 2 .886 2 1.978a1.99 1.99 0 0 1-2 1.978zm8 0c-1.105 0-2-.886-2-1.978A1.99 1.99 0 0 1 10 2h12c1.105 0 2 .886 2 1.978a1.99 1.99 0 0 1-2 1.978H10zm-8 7.593c-1.105 0-2-.885-2-1.978a1.99 1.99 0 0 1 2-1.978c1.105 0 2 .886 2 1.978a1.99 1.99 0 0 1-2 1.978zm20-3.956c1.105 0 2 .886 2 1.978a1.99 1.99 0 0 1-2 1.978H10c-1.105 0-2-.885-2-1.978a1.99 1.99 0 0 1 2-1.978h12zM2 21.143c-1.105 0-2-.886-2-1.978a1.99 1.99 0 0 1 2-1.978c1.105 0 2 .885 2 1.978a1.99 1.99 0 0 1-2 1.978zm20-3.956c1.105 0 2 .885 2 1.978a1.99 1.99 0 0 1-2 1.978H10c-1.105 0-2-.886-2-1.978a1.99 1.99 0 0 1 2-1.978h12z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  })));
};

Annotations.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ApiInputFields = function ApiInputFields(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.035 14.044a.65.65 0 0 1 .384.124l.079.067 4.311 4.322a.652.652 0 0 1 .191.465.649.649 0 0 1-.124.386l-.067.079-4.311 4.322a.65.65 0 0 1-.463.191.65.65 0 0 1-.384-.124l-.078-.067-.391-.393a.652.652 0 0 1-.191-.465.66.66 0 0 1 .123-.387l.068-.08 2.515-2.526H1.653l.019.004a.67.67 0 0 1-.664-.552L1 19.314v-.556c0-.327.25-.615.566-.664l.097-.008h7.062l-2.543-2.541a.65.65 0 0 1-.067-.839l.067-.078.391-.393a.647.647 0 0 1 .462-.19zM17.536 0L23 5.44v18.454H12.685v-1.839h8.469V6.74H16.23V1.838H5.77v2.381H3.922V0h13.613zm-12.8 6.752l2.392 5.575H5.776l-.44-1.083H2.744l-.44 1.083H1l2.432-5.575h1.304zm9.664 0v5.575h-1.264V6.752H14.4zm-6.688 0h2.376c.715 0 1.267.168 1.656.505.389.337.584.814.584 1.43 0 .647-.196 1.151-.588 1.51-.348.318-.823.495-1.422.53l-.23.007H8.976v1.593H7.712V6.752h2.376-2.376zM4.048 8.066l-.888 2.166h1.768l-.88-2.166zm5.976-.27H8.976v1.887h1.048c.357 0 .631-.082.82-.243.19-.162.284-.4.284-.713 0-.309-.094-.54-.284-.697-.189-.156-.463-.235-.82-.235zm8.053-4.658v1.763h1.772l-1.772-1.763z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ApiInputFields.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ApiOutputFields = function ApiOutputFields(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.464 0L1 5.464V24h10.315v-1.846H2.846V6.77H7.77V1.846h10.461v2.392h1.846V0H6.464zm-.541 3.152v1.771H4.151l1.772-1.771zm6.73 16.788h7.044l-2.515 2.538a.659.659 0 0 0-.191.468c0 .176.067.343.191.467l.391.395a.65.65 0 0 0 .925 0l4.311-4.341A.655.655 0 0 0 23 19a.656.656 0 0 0-.191-.467l-4.311-4.341a.646.646 0 0 0-.463-.192.646.646 0 0 0-.462.192l-.391.394a.65.65 0 0 0 0 .921l2.543 2.553h-7.062a.68.68 0 0 0-.663.675v.558c0 .363.311.651.672.651l-.019-.004zM13.752 12l-.44-1.088H10.72L10.28 12H8.976l2.432-5.6h1.304l2.392 5.6h-1.352zm-2.616-2.104h1.768l-.88-2.176-.888 2.176zM18.064 6.4c.715 0 1.267.17 1.656.508.39.339.584.817.584 1.436 0 .65-.196 1.156-.588 1.516-.392.36-.943.54-1.652.54h-1.112V12h-1.264V6.4h2.376zM18 9.344c.357 0 .63-.081.82-.244.19-.163.284-.401.284-.716 0-.31-.095-.543-.284-.7-.19-.157-.463-.236-.82-.236h-1.048v1.896H18zM21.112 6.4h1.264V12h-1.264V6.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ApiOutputFields.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ApiUrl = function ApiUrl(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.72 9.664c0 .552-.092.951-.278 1.197-.186.245-.52.506-1 .782l-.535.345c.155.123.333.238.535.346.34.215.593.391.756.53.162.137.29.321.383.551.093.23.14.545.14.944v4.212c0 .598.174 1.028.523 1.289.349.26.934.39 1.756.39V22h-.814c-1.24 0-2.128-.215-2.663-.644-.535-.43-.802-1.151-.802-2.164v-4.971c0-.476-.085-.817-.256-1.024-.17-.207-.434-.31-.79-.31H0v-1.773h.674c.357 0 .62-.104.791-.31.17-.208.256-.55.256-1.025V4.808c0-.997.267-1.715.802-2.152C3.058 2.219 3.946 2 5.186 2H6v1.75c-.822 0-1.407.13-1.756.39-.349.261-.523.69-.523 1.29v4.234zM7.242 11c.36 0 .652.121.879.363.226.242.34.55.34.925s-.118.687-.352.937a1.14 1.14 0 0 1-.867.375c-.359 0-.655-.125-.89-.375-.234-.25-.351-.562-.351-.937 0-.374.117-.683.351-.925.235-.242.531-.363.89-.363zm4.427 0c.36 0 .652.121.879.363.226.242.34.55.34.925s-.118.687-.352.937a1.14 1.14 0 0 1-.867.375c-.359 0-.655-.125-.89-.375-.234-.25-.351-.562-.351-.937 0-.374.117-.683.351-.925.235-.242.531-.363.89-.363zm4.45 0c.36 0 .653.121.88.363.226.242.339.55.339.925s-.117.687-.351.937a1.14 1.14 0 0 1-.867.375c-.36 0-.656-.125-.89-.375-.234-.25-.352-.562-.352-.937 0-.374.118-.683.352-.925.234-.242.53-.363.89-.363zm7.882.114v1.772h-.674c-.357 0-.62.104-.791.31-.17.208-.256.55-.256 1.025v4.971c0 1.013-.267 1.734-.802 2.164-.535.43-1.423.644-2.663.644H18v-1.75c.822 0 1.407-.13 1.756-.39.349-.261.523-.69.523-1.29V14.36c0-.399.047-.713.14-.944.093-.23.22-.414.383-.552.163-.138.415-.314.756-.53.202-.107.38-.222.535-.345l-.535-.345c-.48-.276-.814-.537-1-.782-.186-.246-.279-.645-.279-1.197V5.429c0-.598-.174-1.028-.523-1.289-.349-.26-.934-.39-1.756-.39V2h.814c1.24 0 2.128.219 2.663.656.535.437.802 1.155.802 2.152v4.971c0 .476.085.817.256 1.024.17.207.434.31.79.31H24z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ApiUrl.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ApplicationSettings = function ApplicationSettings(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M1.76 5.795v13.532c0 .059.051.11.11.11h5.996a.882.882 0 1 1 0 1.765H1.87c-1.03 0-1.87-.838-1.87-1.413V2.327C0 .836.836 0 1.87 0h17.467c1.03 0 1.87.812 1.87 2.327v5.54c0 .031-.065.887-.882.887a.882.882 0 0 1-.883-.882V5.795H1.76zM19.442 1.87a.11.11 0 0 0-.115-.11H1.87a.112.112 0 0 0-.11.11v2.165h17.682V1.87zm2.784 14.953a.523.523 0 0 0 .328-.407c.005-.032.003-.04 0-.05a2.083 2.083 0 0 0-.116-.28.279.279 0 0 0-.148-.126 2.98 2.98 0 0 1-1.375-1.048 1.958 1.958 0 0 1-.339-1.148 2.937 2.937 0 0 1 .254-1.247.516.516 0 0 0-.012-.41.394.394 0 0 0-.249-.223.457.457 0 0 0-.34.006 3.041 3.041 0 0 1-1.534.245 2.018 2.018 0 0 1-1.31-.721 2.984 2.984 0 0 1-.588-.946.513.513 0 0 0-.328-.286.43.43 0 0 0-.406.108.433.433 0 0 0-.137.184A2.98 2.98 0 0 1 14.91 11.8a1.94 1.94 0 0 1-1.153.348 2.98 2.98 0 0 1-1.25-.254.513.513 0 0 0-.404.008.397.397 0 0 0-.223.262.45.45 0 0 0 .005.335c.23.51.31 1.075.23 1.64-.084.484-.34.922-.704 1.217-.281.258-.61.46-.95.59a.493.493 0 0 0-.28.326.433.433 0 0 0 .11.408.433.433 0 0 0 .178.132c.524.2.98.546 1.323 1.005.245.35.37.774.353 1.19a3.125 3.125 0 0 1-.26 1.238.464.464 0 0 0 .627.596 3.033 3.033 0 0 1 1.517-.234c.58.069 1.103.386 1.421.855.184.244.34.508.467.793a.54.54 0 0 0 .38.31l.1.016a.767.767 0 0 0 .281-.138.388.388 0 0 0 .1-.132c.197-.521.533-.977.98-1.328a1.926 1.926 0 0 1 1.218-.383 2.94 2.94 0 0 1 1.243.255.514.514 0 0 0 .438-.026.425.425 0 0 0 .208-.348.446.446 0 0 0-.035-.25 3.05 3.05 0 0 1-.239-1.51c.051-.468.27-.904.602-1.211.29-.298.639-.53 1.034-.687zm1.734-.816c.051.25.053.469.007.695l-.014.063c-.015.06-.031.11-.031.095a2.176 2.176 0 0 1-1.353 1.542 1.212 1.212 0 0 0-.412.287.151.151 0 0 0-.056.088c-.021.202.01.405.09.59.16.362.215.76.163 1.143a2.095 2.095 0 0 1-1.065 1.607 2.192 2.192 0 0 1-1.935.097 1.224 1.224 0 0 0-.515-.1.186.186 0 0 0-.091.014 1.236 1.236 0 0 0-.39.539 2.054 2.054 0 0 1-.562.787c-.31.26-.676.44-1.096.536l-.105.012-.565-.014-.212-.065a2.21 2.21 0 0 1-1.444-1.247 2.132 2.132 0 0 0-.247-.416c-.085-.113-.122-.14-.17-.141-.2-.02-.402.01-.585.09a2.154 2.154 0 0 1-2.86-2.817c.072-.16.109-.335.112-.541a.216.216 0 0 0-.01-.091 1.123 1.123 0 0 0-.512-.383 2.126 2.126 0 0 1-.865-.637 2.11 2.11 0 0 1-.426-1.91 2.18 2.18 0 0 1 1.297-1.458 1.28 1.28 0 0 0 .41-.261.37.37 0 0 0 .099-.11 1.135 1.135 0 0 0-.093-.627 2.133 2.133 0 0 1-.058-1.56 2.07 2.07 0 0 1 1.153-1.266 2.186 2.186 0 0 1 1.762.002c.148.067.309.099.5.094a.188.188 0 0 0 .086-.015 1.12 1.12 0 0 0 .382-.512c.137-.345.36-.65.644-.875a2.105 2.105 0 0 1 1.921-.421 2.205 2.205 0 0 1 1.453 1.299c.053.14.133.269.262.413a.26.26 0 0 0 .132.098c.202.02.406-.012.593-.096a2.127 2.127 0 0 1 1.58-.058 2.07 2.07 0 0 1 1.256 1.152c.246.56.245 1.196-.001 1.758-.067.152-.1.315-.098.514-.003.04.007.082.007.085.135.18.32.318.54.398.429.167.786.476 1.016.883.085.16.157.327.213.492l.018.049.03.08.045.119zm-7.59 2.11c.96 0 1.743-.783 1.743-1.744 0-.962-.783-1.744-1.744-1.744s-1.743.782-1.743 1.744c0 .961.782 1.743 1.743 1.743zm0-4.898a3.154 3.154 0 1 1 0 6.309 3.154 3.154 0 0 1 0-6.309z",
    fill: "currentColor"
  })));
};

ApplicationSettings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Applications = function Applications(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.18 15.422l6.4 3.526a.87.87 0 0 0 .841 0l6.4-3.526 2.414 1.48L12 21.986l-9.235-5.084 2.415-1.48zM2.846 7.058L12 2.018l9.154 5.04L12 12.096 2.846 7.058zm8.735 6.945a.864.864 0 0 0 .84-.001l6.4-3.525 2.414 1.48L12 17.042l-9.235-5.085 2.415-1.48 6.4 3.526zm11.97 2.124l-2.847-1.737 2.803-1.55a.95.95 0 0 0 .493-.816.952.952 0 0 0-.45-.841l-2.846-1.738 2.806-1.55a.948.948 0 0 0 .485-.837.947.947 0 0 0-.484-.837L12.425.114a.867.867 0 0 0-.537-.107h-.014a.888.888 0 0 0-.294.105L.489 6.22a.947.947 0 0 0-.484.837c0 .352.185.672.483.835l2.808 1.552L.45 11.182a.955.955 0 0 0-.45.842.947.947 0 0 0 .488.814l2.808 1.552L.45 16.127A.954.954 0 0 0 0 16.97c.009.346.198.66.489.814l11.092 6.109a.862.862 0 0 0 .84-.001l11.087-6.105A.955.955 0 0 0 24 16.97a.952.952 0 0 0-.45-.842z",
    fill: "currentColor"
  })));
};

Applications.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Archived = function Archived(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.93 13.46l-3.478-9.808C19.927 2.066 18.475 1 16.842 1H7.158c-1.633 0-3.085 1.066-3.61 2.652L.07 13.46c-.046.13-.07.27-.07.409v5.522C0 21.385 1.576 23 3.52 23h16.96c1.944 0 3.52-1.615 3.52-3.608V13.87c0-.14-.024-.278-.07-.41zM5.77 4.422a1.47 1.47 0 0 1 1.39-1.019h9.68c.63 0 1.188.41 1.39 1.02l2.96 7.201H2.809l2.962-7.202zm10.28 7.202c-.488 0-.908 1.45-1.003 2.012-.02.123-.54 3.006-3.045 3.006-2.432 0-2.992-2.705-3.046-3.006-.095-.562-.515-2.011-1.003-2.012h-.817 9.726-.812zm5.603 7.77c0 .663-.525 1.202-1.173 1.202H3.519c-.648 0-1.173-.539-1.173-1.203V14.03h4.147c.662 1.731 2.331 5.009 5.507 5.009 3.176 0 4.845-3.275 5.507-5.006h4.147v5.36zM8.25 5.208h7.5c.69 0 1.25.3 1.25.67 0 .37-.56.669-1.25.669h-7.5c-.69 0-1.25-.3-1.25-.67 0-.37.56-.67 1.25-.67zm-.75 2.87h9c.828 0 1.5.299 1.5.669 0 .37-.672.67-1.5.67h-9c-.828 0-1.5-.3-1.5-.67 0-.37.672-.67 1.5-.67z",
    fill: "currentColor"
  })));
};

Archived.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Arrange = function Arrange(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.515 6.261h-.773c-.94 0-1.637-.001-2.321-.004-.07 0-.083.007-.13.077l-2.429 3.66-.038.057a1656.908 1656.908 0 0 0-5.947 8.992c-.368.562-.783.787-1.417.777a173.07 173.07 0 0 0-2.7-.016 612.987 612.987 0 0 0-2.703.006c-.426.002-.755-.182-.945-.569a1.018 1.018 0 0 1 .058-1.027c.206-.327.515-.466.912-.464l1.877.001h.67c1.058 0 1.805.003 2.551.008.144.002.199-.03.288-.165 1.788-2.702 3.327-5.02 6.385-9.628l.652-.982 1.174-1.768.043-.062a.741.741 0 0 0 .107-.17c.18-.553.567-.79 1.144-.786 1.042.008 1.877.009 3.755.007l1.036-.001-.716-.772-.147-.157c-.244-.261-.352-.379-.482-.528-.373-.431-.38-1.016-.012-1.425.388-.431.973-.429 1.387.003.24.251.44.467.847.91l.05.053a134.902 134.902 0 0 0 .86.932l1.087 1.176c.473.514.482 1.117.015 1.624-.906.984-1.836 1.99-2.798 3.027-.427.46-1.033.506-1.433.081-.411-.436-.373-1.046.07-1.526.229-.25.43-.468.816-.885l.076-.082.345-.373h-1.214zm.12 10.306l-.062-.067a2.954 2.954 0 0 1-.191-.215c-.34-.43-.327-1.006.034-1.396a.923.923 0 0 1 1.341-.022c.153.15.27.274.523.553l.195.214 2.133 2.306c.516.559.524 1.138.016 1.69l-.56.606a544.77 544.77 0 0 1-2.24 2.42c-.57.61-1.466.376-1.658-.437-.09-.376.023-.711.292-1a473.004 473.004 0 0 0 1.303-1.41h-2.263c-1.012 0-1.806 0-2.574.004-.514.002-.855-.431-1.075-.723-.092-.123-2.149-3.228-2.344-3.517-.202-.3-.195-.572.015-.858.082-.113.166-.234.266-.382.059-.088.31-.47.38-.573l.23-.345c1.663 2.431 2.631 3.851 2.905 4.26.022.031.078.069.07.069.74.005 1.514.007 2.432.008H20.744l-1.108-1.185zM1.054 6.259c-.808 0-1.302-.805-.922-1.524.197-.374.525-.535.956-.534.35.001.63.002 1.259.006l.47.003c1.521.008 2.46.004 3.444-.02.795-.02 1.302.241 1.727.938.388.636 1.77 2.775 2.085 3.244.187.279.188.533-.009.802-.096.132-.193.272-.314.455l-.36.545-.242.362A5127.123 5127.123 0 0 1 6.434 6.37c-.062-.097-.094-.115-.197-.114a695.97 695.97 0 0 1-5.184.003z",
    fill: "currentColor"
  })));
};

Arrange.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrangeVertical = function ArrangeVertical(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8 0h2v24H8V0zm6 0h2v24h-2V0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ArrangeVertical.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 10.5H5.7l8.4-8.4L12 0 0 12l12 12 2.1-2.1-8.4-8.4H24z"
  })));
};

ArrowLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.899 2.1l8.401 8.4H0v3h18.3l-8.401 8.4L12 24l11.999-12L12 0z"
  })));
};

ArrowRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowTree = function ArrowTree(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M12.522 10.894l1.652-1.773L20 15.061 14.174 21l-1.652-1.773 2.956-2.925H4V3h2.435v10.82h9.043z"
  })));
};

ArrowTree.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AskForField = function AskForField(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.464 0h13.613v9.238H18.23V1.846H7.769v4.923H2.846v15.385h7.468V24H1V5.464L6.464 0zm-.541 3.152L4.151 4.923h1.772V3.152zM14.798 10c3.198 0 5.8 2.602 5.8 5.798 0 1.27-.41 2.444-1.105 3.4L23 22.705 21.705 24l-3.507-3.507a5.77 5.77 0 0 1-3.4 1.105A5.805 5.805 0 0 1 9 15.798C9 12.602 11.6 10 14.798 10zm0 9.766a3.971 3.971 0 0 0 3.968-3.968 3.972 3.972 0 0 0-3.968-3.967 3.973 3.973 0 0 0-3.967 3.967 3.972 3.972 0 0 0 3.967 3.968z",
    fill: "currentColor"
  })));
};

AskForField.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Banking = function Banking(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.909 20.455l-.551-1.366a1.112 1.112 0 0 0-1.013-.671h-.485V8.33h.947c.419 0 .771-.291.86-.694a.907.907 0 0 0-.485-1.008L12.917 2.22c-.572-.292-1.255-.292-1.872 0L.736 6.628a.894.894 0 0 0-.484 1.008c.088.425.44.716.859.716h.925V18.44h-.397c-.44 0-.837.269-1.013.672l-.55 1.343c-.133.358-.089.739.11 1.052.198.314.55.493.903.493h21.806c.353 0 .705-.18.904-.493.22-.29.264-.694.11-1.052zM1.133 7.435l10.286-4.41c.375-.18.771-.18 1.124 0l10.286 4.41h-1.41a.446.446 0 0 0-.44.448c0 .045 0 .067.022.09 0 .022-.022.067-.022.09v10.355h-2.863v-6.225c0-.985-.793-1.791-1.763-1.791-.969 0-1.762.806-1.762 1.791v6.247h-.88v-6.247c0-.985-.794-1.791-1.763-1.791-.97 0-1.762.806-1.762 1.791v6.247h-.881v-6.247c0-.985-.793-1.791-1.762-1.791-.97 0-1.762.806-1.762 1.791v6.247H2.917V8.33h9.714c.242 0 .44-.2.44-.447a.446.446 0 0 0-.44-.448H1.133zm16.102 4.758v6.247h-1.763v-6.247c0-.492.397-.895.881-.895.485 0 .882.403.882.895zm-4.406 0v6.247h-1.762v-6.247c0-.492.396-.895.881-.895s.881.403.881.895zm-4.405 0v6.247H6.662v-6.247c0-.492.396-.895.88-.895.485 0 .882.403.882.895zm14.648 8.822c-.022.022-.088.112-.177.112H1.09a.182.182 0 0 1-.176-.112c-.022-.023-.067-.112-.022-.224l.55-1.321a.242.242 0 0 1 .22-.134h20.706c.088 0 .176.044.22.134l.55 1.343c0 .09-.043.18-.065.202z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Banking.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var BarginOff = function BarginOff(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.767 16.163l-.978.979A6.435 6.435 0 0 0 12 18.69c3.476 0 6.304-2.71 6.304-6.04V9.453c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.953-3.138 7.216-7.152 7.623v2.102h2.657c.469 0 .848.364.848.812 0 .45-.38.813-.848.813h-7.01c-.469 0-.848-.364-.848-.813 0-.448.38-.812.848-.812h2.657v-2.102a8.136 8.136 0 0 1-4.537-1.958L3.91 21.021a.9.9 0 1 1-1.273-1.273l2.767-2.766A7.403 7.403 0 0 1 4 12.65V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 1.144.333 2.214.912 3.127l1.023-1.023a4.5 4.5 0 0 1-.521-2.104V4.686C7.11 2.102 9.303 0 12 0c2.697 0 4.89 2.102 4.89 4.686v.808l2.858-2.858a.9.9 0 1 1 1.273 1.273l-4.13 4.13v4.584c0 2.599-2.194 4.713-4.891 4.713a4.994 4.994 0 0 1-3.233-1.173zm6.427-3.54V4.686c0-1.688-1.433-3.06-3.194-3.06s-3.194 1.372-3.194 3.06v7.964c0 1.688 1.433 3.061 3.194 3.061s3.194-1.385 3.194-3.088z",
    fill: "currentColor"
  })));
};

BarginOff.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var BarginOffFilled = function BarginOffFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.767 16.163l-.978.979A6.435 6.435 0 0 0 12 18.69c3.476 0 6.304-2.71 6.304-6.04V9.453c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.953-3.138 7.216-7.152 7.623v2.102h2.657c.469 0 .848.364.848.812 0 .45-.38.813-.848.813h-7.01c-.469 0-.848-.364-.848-.813 0-.448.38-.812.848-.812h2.657v-2.102a8.136 8.136 0 0 1-4.537-1.958L3.91 21.021a.9.9 0 1 1-1.273-1.273l2.767-2.766A7.403 7.403 0 0 1 4 12.65V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 1.144.333 2.214.912 3.127l1.023-1.023a4.5 4.5 0 0 1-.521-2.104V4.686C7.11 2.102 9.303 0 12 0c2.697 0 4.89 2.102 4.89 4.686v.808l2.858-2.858a.9.9 0 1 1 1.273 1.273l-4.13 4.13v4.584c0 2.599-2.194 4.713-4.891 4.713a4.994 4.994 0 0 1-3.233-1.173z",
    fill: "currentColor"
  })));
};

BarginOffFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var BarginOn = function BarginOn(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.848 20.273v2.102h2.657c.469 0 .848.364.848.812 0 .45-.38.813-.848.813h-7.01c-.469 0-.848-.364-.848-.813 0-.448.38-.812.848-.812h2.657v-2.102C7.138 19.866 4 16.603 4 12.65V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.33 2.828 6.04 6.304 6.04 3.476 0 6.304-2.71 6.304-6.04V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.953-3.138 7.216-7.152 7.623zM12 0c2.697 0 4.89 2.102 4.89 4.686v7.937c0 2.599-2.193 4.713-4.89 4.713-2.697 0-4.89-2.102-4.89-4.686V4.686C7.11 2.102 9.303 0 12 0zm3.194 12.623V4.686c0-1.688-1.433-3.06-3.194-3.06s-3.194 1.372-3.194 3.06v7.964c0 1.688 1.433 3.061 3.194 3.061s3.194-1.385 3.194-3.088z",
    fill: "currentColor"
  })));
};

BarginOn.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var BarginOnFilled = function BarginOnFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.848 20.273v2.102h2.657c.469 0 .848.364.848.812 0 .45-.38.813-.848.813h-7.01c-.469 0-.848-.364-.848-.813 0-.448.38-.812.848-.812h2.657v-2.102C7.138 19.866 4 16.603 4 12.65V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.33 2.828 6.04 6.304 6.04 3.476 0 6.304-2.71 6.304-6.04V9.454c0-.45.38-.813.848-.813.468 0 .848.364.848.813v3.196c0 3.953-3.138 7.216-7.152 7.623zM12 0c2.697 0 4.89 2.102 4.89 4.686v7.937c0 2.599-2.193 4.713-4.89 4.713-2.697 0-4.89-2.102-4.89-4.686V4.686C7.11 2.102 9.303 0 12 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

BarginOnFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Booking = function Booking(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.216 6.687c-1.831 0-3.265.92-3.265 2.095 0 1.174 1.434 2.094 3.265 2.094 1.83 0 3.265-.92 3.265-2.094 0-1.175-1.434-2.095-3.265-2.095zm1.88 3.002c-.497.295-1.164.457-1.88.457s-1.384-.162-1.88-.457c-.252-.15-.675-.467-.675-.907s.423-.757.675-.907c.496-.295 1.164-.458 1.88-.458s1.383.163 1.88.458c.252.15.675.467.675.907s-.423.757-.675.907zm-1.293 8.015a.37.37 0 0 1-.169.487l-2.98 1.456a.345.345 0 0 1-.151.036.354.354 0 0 1-.321-.209L6.974 14.7a.374.374 0 0 1-.018-.266l.743-2.43a.362.362 0 0 1 .19-.222.346.346 0 0 1 .287-.005l2.236.974a.36.36 0 0 1 .183.179l2.208 4.774zM9.67 18.831l2.338-1.143-1.998-4.32-1.752-.762-.584 1.91 1.996 4.315zM21.689 4.648C22.963 4.648 24 5.751 24 7.106v11.778c0 1.355-1.037 2.457-2.311 2.457h-.643c-.117.935-.878 1.659-1.796 1.659-.919 0-1.68-.724-1.797-1.659h-7.032a.36.36 0 0 1-.355-.365.36.36 0 0 1 .355-.365h7.547v-3.147c-.095.016-.191.025-.287.025h-1.682c-.98 0-1.776-.82-1.776-1.826v-2.112c0-1.006.797-1.825 1.776-1.825h1.682c.096 0 .192.009.287.025V5.378H6.027v15.233h2.929a.36.36 0 0 1 .355.365.36.36 0 0 1-.355.365H6.54c-.118.922-.878 1.635-1.795 1.635-.917 0-1.677-.713-1.796-1.635h-.638C1.037 21.341 0 20.24 0 18.884V7.106c0-1.355 1.037-2.458 2.311-2.458h.381v-.805a.36.36 0 0 1 .355-.365h3.35a.36.36 0 0 1 .354.365v.805h.575v-1.19c0-.676.242-1.294.68-1.74C8.47 1.248 9.11 1 9.858 1a.36.36 0 0 1 .355.365.36.36 0 0 1-.355.365c-1.09 0-1.822.694-1.822 1.728v1.178h.852V3.458c0-.47.372-.852.828-.852h4.568c.457 0 .828.382.828.852v1.178h.852V3.458c0-.953-.754-1.728-1.68-1.728h-2.977a.36.36 0 0 1-.355-.365.36.36 0 0 1 .355-.365h2.977c1.318 0 2.39 1.103 2.39 2.458v1.19h.546v-.805a.36.36 0 0 1 .355-.365h3.349a.36.36 0 0 1 .355.365v.805h.41zM3.416 20.611V5.378H2.311c-.883 0-1.601.776-1.601 1.728v11.778c0 .952.718 1.727 1.601 1.727h1.105zm1.329 1.635c.521 0 .96-.382 1.073-.893H3.672c.114.511.552.893 1.073.893zm-.618-1.635h1.19V5.378h-1.19v15.233zM6.04 4.635v-.427H3.402v.427h2.639zm8.361.013v-1.19a.12.12 0 0 0-.118-.122H9.716a.12.12 0 0 0-.118.122v1.19h4.804zm3.566 12.07v-4.221a1.033 1.033 0 0 0-.287-.04h-1.682c-.588 0-1.066.49-1.066 1.094v2.112c0 .604.478 1.096 1.066 1.096h1.682c.098 0 .194-.014.287-.04zm1.282 5.552c.523 0 .963-.393 1.074-.917h-2.15c.112.524.552.917 1.076.917zm-.572-10.075a.37.37 0 0 1 .004.057v4.711a.37.37 0 0 1-.004.057v3.591h1.19V5.378h-1.19v6.817zm1.89-7.56v-.427H17.93v.427h2.639zm2.722 14.249V7.106c0-.952-.718-1.728-1.601-1.728h-1.11v15.233h1.11c.883 0 1.601-.775 1.601-1.727z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Booking.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.756.817a1.541 1.541 0 0 0-.656-.67A1.112 1.112 0 0 0 18.55 0H5.45a1.11 1.11 0 0 0-.55.147 1.54 1.54 0 0 0-.656.67A2.12 2.12 0 0 0 4 1.829v20.342c0 .37.081.707.244 1.013.162.305.381.528.656.67.175.097.358.146.55.146.392 0 .737-.18 1.037-.539L12 16.536l5.513 6.925c.291.348.637.523 1.037.523.208 0 .392-.044.55-.13a1.54 1.54 0 0 0 .656-.67c.163-.306.244-.643.244-1.013V1.829c0-.37-.081-.707-.244-1.012z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Bookmark.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Bot = function Bot(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.2 7.034h-6.08V3.178c.456-.323.758-.833.758-1.41C13.878.792 13.037 0 12.002 0s-1.876.792-1.876 1.768c0 .578.301 1.087.756 1.41v3.856H4.8c-.993 0-1.8.76-1.8 1.697v13.572C3 23.24 3.807 24 4.8 24h14.4c.995 0 1.8-.76 1.8-1.697V8.73c0-.937-.806-1.697-1.8-1.697zm-.438 14.859H5.238V9.144h13.524v12.749zm-9.456-7.866c.62 0 1.124-.474 1.124-1.059 0-.586-.504-1.06-1.124-1.06-.623 0-1.126.474-1.126 1.06 0 .585.503 1.06 1.126 1.06zm5.39 0c.62 0 1.124-.474 1.124-1.059 0-.586-.505-1.06-1.125-1.06-.622 0-1.125.474-1.125 1.06 0 .585.503 1.06 1.125 1.06zm0 3.83h-5.39c-.618 0-1.118.472-1.118 1.055 0 .581.5 1.052 1.118 1.052h5.39c.617 0 1.12-.471 1.12-1.052 0-.582-.503-1.056-1.12-1.056z",
    fill: "currentColor"
  })));
};

Bot.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var BotCircle = function BotCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 12C0 5.372 5.372 0 12 0s12 5.372 12 12-5.372 12-12 12S0 18.628 0 12zm16.18-3.657h-3.53v-2.24c.265-.187.44-.483.44-.819 0-.566-.488-1.026-1.089-1.026s-1.089.46-1.089 1.026c0 .336.175.632.44.82v2.239H7.818c-.576 0-1.045.44-1.045.985v7.88c0 .545.469.986 1.045.986h8.361c.578 0 1.046-.442 1.046-.986v-7.88c0-.544-.468-.985-1.046-.985zm-.254 8.627H8.074V9.568h7.852v7.402zm-5.49-4.567c.36 0 .653-.275.653-.615 0-.34-.293-.615-.653-.615-.362 0-.654.275-.654.615 0 .34.292.615.654.615zm3.129 0c.36 0 .653-.275.653-.615 0-.34-.293-.615-.653-.615-.362 0-.654.275-.654.615 0 .34.293.615.654.615zm0 2.223h-3.13c-.358 0-.648.275-.648.613 0 .338.29.611.649.611h3.129c.359 0 .65-.273.65-.61 0-.339-.291-.614-.65-.614z",
    fill: "currentColor"
  })));
};

BotCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Branch = function Branch(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.76 0C19.547 0 21 1.468 21 3.273a3.285 3.285 0 0 1-1.44 2.707v.202c0 4.033-3.588 5.845-6.756 7.444-2.964 1.497-4.764 2.526-4.764 4.192v.202a3.29 3.29 0 0 1 1.44 2.707C9.48 22.532 8.027 24 6.24 24 4.453 24 3 22.532 3 20.727c0-1.08.547-2.1 1.44-2.707v-.202c0-4.034 3.588-5.846 6.756-7.445 2.964-1.497 4.764-2.526 4.764-4.191V5.98a3.286 3.286 0 0 1-1.44-2.707C14.52 1.468 15.973 0 17.76 0zM6.24 19.636c-.595 0-1.08.49-1.08 1.091s.485 1.091 1.08 1.091c.595 0 1.08-.49 1.08-1.09 0-.602-.485-1.092-1.08-1.092zM6.24 0c1.787 0 3.24 1.468 3.24 3.273A3.29 3.29 0 0 1 8.04 5.98v4.318l-.167.107c-1.207.772-2.119 1.57-2.789 2.443l-.644.837V5.98A3.29 3.29 0 0 1 3 3.273C3 1.468 4.453 0 6.24 0zm11.52 2.182c-.595 0-1.08.49-1.08 1.09 0 .602.485 1.092 1.08 1.092.595 0 1.08-.49 1.08-1.091s-.485-1.091-1.08-1.091zm-11.52 0c-.595 0-1.08.49-1.08 1.09 0 .602.485 1.092 1.08 1.092.595 0 1.08-.49 1.08-1.091s-.485-1.091-1.08-1.091z",
    fill: "currentColor"
  })));
};

Branch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Canvas = function Canvas(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.188 0H2.813C1.262 0 0 1.369 0 3.05v17.9C0 22.63 1.262 24 2.813 24h18.375C22.738 24 24 22.631 24 20.95V3.05C24 1.37 22.738 0 21.187 0zM2.813 2.034h18.375c.516 0 .937.456.937 1.017V6.1H1.875v-3.05c0-.56.42-1.017.938-1.017zm18.375 19.932H2.813c-.517 0-.938-.456-.938-1.017V8.136h20.25v12.813c0 .56-.42 1.017-.938 1.017zM3.28 4.068c0-.562.42-1.017.938-1.017s.937.455.937 1.017c0 .562-.42 1.017-.937 1.017-.518 0-.938-.455-.938-1.017zm3.281 0c0-.562.42-1.017.938-1.017s.938.455.938 1.017c0 .562-.42 1.017-.938 1.017s-.938-.455-.938-1.017zm-.482 7.461h12.456v2.034H6.08V11.53zm0 4.835h7.313v2.034H6.08v-2.034z",
    fill: "currentColor"
  })));
};

Canvas.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CaretDown = function CaretDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.374 15.793l4.55-7.07a.476.476 0 0 0-.124-.645A.44.44 0 0 0 16.55 8H7.449A.457.457 0 0 0 7 8.465c0 .092.026.182.075.258l4.551 7.07a.44.44 0 0 0 .748 0",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CaretDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CaretLeft = function CaretLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.078 12.249c.034.049.078.092.13.124l7.068 4.552a.476.476 0 0 0 .646-.125.44.44 0 0 0 .078-.249V7.449A.457.457 0 0 0 15.535 7a.48.48 0 0 0-.259.075l-7.069 4.55a.44.44 0 0 0-.129.624",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CaretLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CaretRight = function CaretRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.922 11.751a.458.458 0 0 0-.13-.124L8.725 7.075a.476.476 0 0 0-.646.125A.438.438 0 0 0 8 7.45v9.102c0 .249.208.449.465.449a.48.48 0 0 0 .259-.075l7.069-4.55a.44.44 0 0 0 .129-.624",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CaretRight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CaretSquareDown = function CaretSquareDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.69 24C2.105 24 0 21.972 0 19.478V4.522C0 2.028 2.104 0 4.69 0h14.62C21.895 0 24 2.028 24 4.522v14.954C23.998 21.972 21.895 24 19.308 24H4.69zm0-22.35c-1.64 0-2.978 1.29-2.978 2.872v14.954c0 1.582 1.337 2.871 2.979 2.871h14.616c1.642 0 2.979-1.289 2.979-2.871V4.522c0-1.582-1.337-2.871-2.979-2.871H4.691zm7.684 15.143a.44.44 0 0 1-.747 0l-4.552-7.07A.478.478 0 0 1 7 9.465C7 9.208 7.2 9 7.45 9h9.101a.44.44 0 0 1 .249.078.476.476 0 0 1 .125.645l-4.551 7.07z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CaretSquareDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CaretUp = function CaretUp(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.626 8.207l-4.55 7.07a.476.476 0 0 0 .124.645.44.44 0 0 0 .25.078h9.1c.249 0 .45-.208.45-.465a.479.479 0 0 0-.075-.258l-4.551-7.07a.44.44 0 0 0-.748 0",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CaretUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Check = function Check(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.308 2L9.23 13.521l-5.538-5.76L0 11.602 9.23 21.2 24 5.842z"
  })));
};

Check.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm5.693-18l-6.924 7.2-3.462-3.599L5 12.001 10.769 18 20 8.401 17.693 6z",
    fill: "currentColor"
  })));
};

CheckCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CircleEmpty = function CircleEmpty(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CircleEmpty.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CircleFilled = function CircleFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0 6C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CircleFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ClearText = function ClearText(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.983 12l6.73-6.73a.98.98 0 0 0 .288-.697.977.977 0 0 0-.288-.696l-.59-.59A.976.976 0 0 0 19.428 3a.976.976 0 0 0-.696.287l-6.73 6.73-6.73-6.73A.976.976 0 0 0 4.573 3a.975.975 0 0 0-.696.287l-.59.59a.985.985 0 0 0 0 1.392l6.73 6.73-6.73 6.731a.979.979 0 0 0-.287.697c0 .263.102.51.287.696l.59.59a.976.976 0 0 0 .696.287.976.976 0 0 0 .696-.288l6.73-6.73 6.731 6.73a.977.977 0 0 0 .696.288c.264 0 .511-.102.697-.288l.59-.59a.978.978 0 0 0 .287-.695.979.979 0 0 0-.288-.697L13.983 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ClearText.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Clock = function Clock(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 21.447c-5.209 0-9.447-4.238-9.447-9.447 0-5.21 4.238-9.447 9.447-9.447 5.209 0 9.447 4.238 9.447 9.447 0 5.21-4.238 9.447-9.447 9.447zm6.254-9.818H12.86V5.145a.988.988 0 0 0-1.976 0v7.473c0 .545.442.988.988.988h6.38a.988.988 0 0 0 0-1.977z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Clock.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Clone = function Clone(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.479 24H1.067C.478 24 0 23.524 0 22.937V7.604C0 7.016.478 6.54 1.067 6.54H16.48c.589 0 1.067.476 1.067 1.063v15.333c0 .587-.478 1.063-1.067 1.063zm-1.068-2.127V8.667H2.134v13.206h13.277zM8.59 2.777c0 .588-.478 1.064-1.068 1.064-.589 0-1.067-.476-1.067-1.064V1.063C6.454.476 6.932 0 7.521 0h15.412C23.522 0 24 .476 24 1.063v15.333c0 .588-.478 1.064-1.067 1.064h-1.656c-.59 0-1.067-.476-1.067-1.064 0-.587.478-1.063 1.067-1.063h.589V2.127H8.589v.65z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Clone.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloneProject = function CloneProject(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.93 18.128l.73-1.147 3.24 2.133-.73 1.147-3.24-2.133zM0 14.882l.729-1.146 3.24 2.133-.73 1.146L0 14.882zm20.03-6.143l.73-1.146L24 9.726l-.73 1.146-3.24-2.133zm-.96-2.26l-.73 1.147-3.24-2.133.73-1.147 3.24 2.133zm-6.99-2.908v6c-.003.262-.141.378-.271.468l-5.49 3.033a.576.576 0 0 1-.555 0L.288 10.048A.54.54 0 0 1 0 9.572v-6c0-.198.108-.38.284-.476L5.764.07a.581.581 0 0 1 .555 0l5.477 3.026a.544.544 0 0 1 .285.475zm-1.12 5.068V4.504L6.603 6.89v4.77l3.776-2.086L7.34 7.913a.541.541 0 0 1-.21-.752.572.572 0 0 1 .76-.2l3.07 1.678zM6.042 5.945L10.38 3.57 6.041 1.172 1.703 3.57l4.338 2.376zM5.48 11.66V6.89L1.122 4.504V8.64l3.071-1.677a.571.571 0 0 1 .76.2.527.527 0 0 1 .058.412.542.542 0 0 1-.268.339L1.704 9.574 5.48 11.66zm12.758-.733l5.478 3.026a.544.544 0 0 1 .284.475v6c-.003.262-.142.378-.272.468l-5.49 3.033a.576.576 0 0 1-.554 0l-5.477-3.024a.54.54 0 0 1-.287-.476v-6c0-.198.108-.38.283-.476l5.48-3.026a.581.581 0 0 1 .555 0zm4.642 8.569v-4.135l-4.358 2.386v4.77l3.776-2.086-3.039-1.661a.541.541 0 0 1-.21-.751.572.572 0 0 1 .76-.2l3.071 1.677zm-4.92-2.694l4.339-2.376-4.338-2.397-4.338 2.397 4.338 2.376zm-.56 5.715v-4.77l-4.359-2.386v4.135l3.071-1.677a.571.571 0 0 1 .76.2.527.527 0 0 1 .058.412.542.542 0 0 1-.267.339l-3.04 1.661 3.776 2.086z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CloneProject.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloneProjectThin = function CloneProjectThin(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.619 5.243l.539-.531 1.568.938-.539.531-1.568-.938zm3.137 1.876l.539-.53 1.568.937-.539.532-1.568-.939zm3.137 1.877l.539-.532L24 9.403l-.539.53-1.568-.937zM0 13.874l.539-.53 1.568.937-.539.532L0 13.874zm3.137 1.877l.539-.532 1.568.939-.539.53-1.568-.937zm3.137 1.876l.539-.531 1.568.938-.539.531-1.568-.938zm5.96-14.61a.368.368 0 0 1 .187.318V9.224c-.002.157-.067.23-.188.315l-.002.001-5.202 2.965a.383.383 0 0 1-.374 0L1.45 9.54a.368.368 0 0 1-.19-.32V3.337v-.002c0-.131.072-.253.187-.318L6.655.05a.379.379 0 0 1 .374 0l5.205 2.967zm-5.766 8.532V6.49l-4.46-2.52v4.615l3.153-1.777a.377.377 0 0 1 .51.136c.103.176.041.4-.138.502L2.385 9.222l4.083 2.327zm.374-5.696l4.457-2.52L6.842.793l-4.457 2.54 4.457 2.52zm4.834 2.732V3.97l-4.46 2.52v5.059l4.083-2.327L8.15 7.446a.364.364 0 0 1-.138-.502.377.377 0 0 1 .51-.136l3.153 1.777zm11.245 4.707a.368.368 0 0 1 .186.318v5.89c-.002.157-.067.229-.187.314l-.003.002-5.201 2.965a.383.383 0 0 1-.375 0l-5.203-2.965a.368.368 0 0 1-.19-.32v-5.884-.002c0-.13.071-.252.186-.318l5.207-2.967a.379.379 0 0 1 .375 0l5.205 2.967zm-5.766 8.533v-5.06l-4.46-2.52v4.616l3.153-1.778a.377.377 0 0 1 .51.136c.103.176.04.401-.138.502l-3.148 1.776 4.083 2.328zm.374-5.696l4.457-2.52-4.457-2.54-4.458 2.54 4.458 2.52zm4.833 2.732v-4.615l-4.46 2.52v5.058l4.083-2.327-3.147-1.776a.364.364 0 0 1-.139-.502.377.377 0 0 1 .51-.136l3.153 1.778z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CloneProjectThin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Close = function Close(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.424 12l8.226-8.226c.226-.227.351-.529.352-.851 0-.322-.125-.625-.352-.851l-.72-.72A1.193 1.193 0 0 0 21.077 1c-.322 0-.624.124-.85.351L12 9.577 3.775 1.351A1.192 1.192 0 0 0 2.924 1c-.322 0-.624.124-.85.351l-.722.721c-.47.47-.47 1.233 0 1.702L9.578 12l-8.226 8.226a1.196 1.196 0 0 0-.351.851c0 .322.125.625.351.851l.721.72c.226.228.529.352.85.352.323 0 .625-.124.852-.351L12 14.423l8.226 8.226c.227.227.529.351.85.351h.001c.322 0 .624-.124.851-.351l.72-.72c.227-.227.352-.53.352-.852 0-.322-.125-.624-.351-.85L14.424 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Close.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseCircle = function CloseCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.6c5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4C6.256 1.6 1.6 6.256 1.6 12c0 5.744 4.656 10.4 10.4 10.4zm3.183-5.663L12 13.553l-3.183 3.184-1.554-1.554L10.447 12 7.263 8.817l1.554-1.554L12 10.447l3.183-3.184 1.554 1.554L13.553 12l3.184 3.183-1.554 1.554z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CloseCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Collapse = function Collapse(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.268 11.875a2.497 2.497 0 0 1-3.535 0A2.493 2.493 0 0 1 2 10.108V4.5A2.5 2.5 0 0 1 4.5 2h5.605a2.5 2.5 0 0 1 2.5 2.5c0 .663-.26 1.3-.73 1.768l-5.607 5.607zm.796 10.126C4.279 22 2 19.72 2 16.938v-.277a4.11 4.11 0 0 0 2.5.237v.04a2.566 2.566 0 0 0 2.563 2.563h9.872a2.567 2.567 0 0 0 2.565-2.563V7.063a2.567 2.567 0 0 0-2.565-2.562h-.035c.06-.285.1-.578.1-.875 0-.578-.12-1.125-.335-1.625h.27c2.785 0 5.065 2.28 5.065 5.062v9.875c0 2.783-2.28 5.063-5.065 5.063H7.064z",
    fill: "currentColor"
  })));
};

Collapse.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CollapseDoubleArrows = function CollapseDoubleArrows(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.763 4.24l-1.151-1.028a.888.888 0 0 0-1.152 0l-9.212 8.236a.678.678 0 0 0-.23.552c-.012.2.06.4.23.551l9.212 8.238a.89.89 0 0 0 1.152 0l1.15-1.03a.679.679 0 0 0 0-1.031L14.237 12l7.527-6.729a.679.679 0 0 0 0-1.03m-8.017 0l-1.151-1.029a.888.888 0 0 0-1.152 0L2.23 11.448a.677.677 0 0 0-.229.552c-.011.2.06.4.23.551l9.212 8.238a.89.89 0 0 0 1.152 0l1.151-1.03a.679.679 0 0 0 0-1.031L6.22 12l7.526-6.729a.679.679 0 0 0 0-1.03",
    fill: "currentColor"
  })));
};

CollapseDoubleArrows.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Commit = function Commit(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.275 24v-7.038A5.124 5.124 0 0 0 17.1 12a5.124 5.124 0 0 0-3.825-4.962V0h-2.55v7.038A5.125 5.125 0 0 0 6.9 12a5.125 5.125 0 0 0 3.825 4.962V24h2.55zM9.45 12c0-1.418 1.144-2.571 2.55-2.571s2.55 1.153 2.55 2.571c0 1.418-1.144 2.571-2.55 2.571S9.45 13.418 9.45 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Commit.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ConfigurationLocked = function ConfigurationLocked(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.5 0a2.503 2.503 0 0 1 2.494 2.336L24 2.5v19a2.503 2.503 0 0 1-2.336 2.494L21.5 24h-19a2.503 2.503 0 0 1-2.494-2.336L0 21.5v-19A2.503 2.503 0 0 1 2.336.006L2.5 0h19zm0 1h-19a1.5 1.5 0 0 0-1.493 1.356L1 2.5v19a1.5 1.5 0 0 0 1.356 1.493L2.5 23h19a1.5 1.5 0 0 0 1.493-1.356L23 21.5v-19A1.5 1.5 0 0 0 21.5 1zM11 6.5h2a1 1 0 0 1 .993.883L14 7.5v1.377l.104.042.104.045.974-.974a1 1 0 0 1 1.32-.084l.094.084 1.415 1.414a1 1 0 0 1 .083 1.32l-.084.094-.974.974.045.104.042.104H18.5a1 1 0 0 1 .993.883L19.5 13v2a1 1 0 0 1-.883.993L18.5 16h-1.377l-.042.104-.045.104.974.974a1 1 0 0 1 .084 1.32l-.084.094-1.414 1.414a1 1 0 0 1-1.32.084l-.094-.084-.974-.974-.104.045-.104.042V20.5a1 1 0 0 1-.883.993L13 21.5h-2a1 1 0 0 1-.993-.883L10 20.5v-1.377l-.104-.042-.104-.045-.974.974a1 1 0 0 1-1.32.084l-.094-.084-1.415-1.414a1 1 0 0 1-.083-1.32l.083-.094.975-.974-.045-.104L6.877 16H5.5a1 1 0 0 1-.993-.883L4.5 15v-2a1 1 0 0 1 .883-.993L5.5 12h1.377l.042-.104.045-.104-.974-.974a1 1 0 0 1-.084-1.32l.084-.094L7.404 7.99a1 1 0 0 1 1.32-.084l.094.084.974.974.104-.045.104-.042V7.5a1 1 0 0 1 .883-.993L11 6.5h2zm2 1h-2v1.73a.5.5 0 0 1-.35.476c-.252.08-.496.183-.73.305a.5.5 0 0 1-.514-.03l-.07-.059L8.11 8.697l-1.414 1.414 1.225 1.225a.5.5 0 0 1 .09.585 4.527 4.527 0 0 0-.305.73.5.5 0 0 1-.385.341L7.229 13h-1.73v2h1.73a.5.5 0 0 1 .477.35c.08.252.183.496.305.73a.5.5 0 0 1-.03.514l-.06.071-1.224 1.225 1.414 1.414 1.225-1.225a.5.5 0 0 1 .585-.09c.234.122.478.224.73.305a.5.5 0 0 1 .341.385l.008.092V20.5h2v-1.73a.5.5 0 0 1 .35-.476c.252-.08.496-.183.73-.305a.5.5 0 0 1 .514.03l.071.059 1.225 1.225 1.414-1.414-1.225-1.225a.5.5 0 0 1-.09-.585c.123-.234.225-.478.305-.73a.5.5 0 0 1 .386-.341l.091-.009H18.5V13h-1.73a.5.5 0 0 1-.477-.35 4.526 4.526 0 0 0-.305-.73.5.5 0 0 1 .031-.514l.059-.07 1.225-1.225-1.414-1.414-1.225 1.225a.5.5 0 0 1-.585.089 4.527 4.527 0 0 0-.73-.305.5.5 0 0 1-.341-.385l-.009-.092V7.5zm-3 3.99a2.5 2.5 0 1 1 3.5 3.5V17a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.01a2.5 2.5 0 0 1-.5-3.5zm2 .01a1.5 1.5 0 0 0-1.5 1.5c0 .534.286 1.027.75 1.29a.5.5 0 0 1 .25.433V16.5h1v-1.777a.5.5 0 0 1 .25-.433c.464-.263.75-.756.75-1.29a1.5 1.5 0 0 0-1.5-1.5zM22 4v1H2V4h20zM3.5 2v1h-1V2h1zm2 0v1h-1V2h1zm16 0v1h-1V2h1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ConfigurationLocked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ContextRuleType = function ContextRuleType(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.05 8.842c-.44-.658-.962-1.17-1.564-1.537-.602-.368-1.213-.551-1.833-.551-.775 0-1.485.237-2.128.711-.644.475-1.15 1.129-1.52 1.962-.37.834-.555 1.748-.555 2.743 0 .994.185 1.908.554 2.742.37.834.877 1.492 1.52 1.974a3.471 3.471 0 0 0 2.129.722c.596 0 1.195-.168 1.797-.504a5.32 5.32 0 0 0 1.6-1.4l1.413 2.02a7.663 7.663 0 0 1-2.289 2.03c-.87.497-1.752.746-2.646.746-1.205 0-2.307-.367-3.309-1.102-1.001-.734-1.788-1.732-2.36-2.994C.285 15.142 0 13.745 0 12.216c0-1.53.292-2.923.876-4.177.585-1.255 1.38-2.241 2.388-2.96A5.64 5.64 0 0 1 6.617 4c.894 0 1.77.23 2.629.688a6.645 6.645 0 0 1 2.2 1.905l-1.395 2.25zm11.214 11.429L19.1 15.52a3.117 3.117 0 0 1-.447.022h-2.826v4.728h-2.396V4.207h5.222c1.621 0 2.873.481 3.755 1.445.883.964 1.324 2.326 1.324 4.085 0 1.255-.212 2.326-.635 3.213-.423.887-1.04 1.553-1.851 1.996L24 20.271h-2.736zm-5.437-7.436h2.826c.906 0 1.597-.252 2.074-.757.477-.505.716-1.255.716-2.25 0-.978-.239-1.713-.716-2.202-.477-.49-1.168-.734-2.074-.734h-2.826v5.943z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ContextRuleType.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ContextRules = function ContextRules(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0C6.762 0 2.5 4.168 2.5 9.29c0 5.123 4.262 9.29 9.5 9.29s9.5-4.167 9.5-9.29C21.5 4.168 17.238 0 12 0zm1.188 16.154v-2.759l3.034-1.978-1.317-1.933L12 11.378 9.097 9.485 7.78 11.418l3.032 1.977v2.759c-3.364-.557-5.937-3.418-5.937-6.864 0-3.842 3.196-6.967 7.125-6.967 3.93 0 7.125 3.125 7.125 6.967 0 3.446-2.573 6.307-5.938 6.864zM8.041 22.71v-2.581h7.916v2.58H13.32V24h-2.638v-1.29H8.04z",
    fill: "currentColor"
  })));
};

ContextRules.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Contexts = function Contexts(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 2.602L3.298 7.327v9.346L12 21.398l8.702-4.725V7.327L12 2.602zM14.398 12h.16c.434 0 .825.145 1.172.436.347.291.52.654.52 1.09 0 .427-.173.78-.52 1.058-.347.277-.776.416-1.286.416-.557 0-1.02-.196-1.39-.587-.37-.391-.554-.948-.554-1.67 0-.663.162-1.283.486-1.862.324-.578.72-1.037 1.189-1.374.469-.338.886-.507 1.252-.507.244 0 .434.064.571.19a.64.64 0 0 1 .206.492c0 .295-.148.512-.446.652-.404.194-.724.422-.96.683-.236.26-.37.588-.4.983zm-5.227-.01h.148c.427 0 .814.145 1.16.435.348.29.521.652.521 1.085 0 .42-.173.773-.52 1.06-.347.287-.776.43-1.286.43-.564 0-1.03-.2-1.395-.6-.366-.4-.549-.957-.549-1.67 0-.513.095-.997.286-1.45.19-.453.436-.848.737-1.185.301-.337.625-.603.972-.8.347-.197.657-.295.932-.295.251 0 .444.062.577.185.134.123.2.288.2.495 0 .3-.148.517-.446.65-.419.207-.735.435-.949.685-.213.25-.343.575-.388.975zM23 5.973v12.054L12 24 1 18.027V5.973L12 0l11 5.973z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Contexts.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ConversationStudioLogo = function ConversationStudioLogo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.806 10.7l1.712-.867 1.684.854a.572.572 0 0 0 .624-.072l2.89-2.537c.113-.1.167-.24.146-.38a.457.457 0 0 0-.254-.334l-4.832-2.45a.572.572 0 0 0-.254-.06h-.008a.572.572 0 0 0-.255.06L6.11 8.031l.975.554 5.433-2.754 3.99 2.023-.688.604-3.044-1.543a.58.58 0 0 0-.517 0L7.971 9.09l.975.554 3.572-1.81 2.545 1.29-.688.604-1.599-.81a.58.58 0 0 0-.517 0l-2.427 1.23.974.554zm-.425 1l-1.034-.588v2.233c0 .163.098.312.258.393l2.654 1.346a.58.58 0 0 0 .517 0l1.6-.81.687.603-2.545 1.29-4.11-2.083v-3.506L7.372 9.99v4.356c0 .162.099.312.259.393l4.627 2.346a.572.572 0 0 0 .517 0l3.044-1.543.688.604-3.99 2.023-6.084-3.085V9.456L5.4 8.87v6.477c0 .163.099.312.258.393l6.601 3.347a.571.571 0 0 0 .517 0l4.832-2.45a.456.456 0 0 0 .259-.392.427.427 0 0 0-.152-.322l-2.89-2.537a.572.572 0 0 0-.623-.072l-1.684.854-2.137-1.084V11.7zm11.07 7.416l-7.884 4.472a3.19 3.19 0 0 1-3.137 0l-7.882-4.472A3.021 3.021 0 0 1 1 16.493V7.507c0-1.08.59-2.08 1.548-2.623L10.43.413a3.19 3.19 0 0 1 3.137 0l7.885 4.47A3.021 3.021 0 0 1 23 7.506v8.987c0 1.08-.59 2.08-1.548 2.623z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ConversationStudioLogo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Copy = function Copy(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M17.759 0H9.286C8.026 0 7 .962 7 2.144v15.005c0 1.182 1.025 2.143 2.286 2.143h11.428c1.26 0 2.286-.961 2.286-2.143V4.915L17.759 0zM16 6.646V1.108l5.833 5.538H16zM3.333 4.062v17.723h14V24h-14C2.046 24 1 23.006 1 21.785V4.062h2.333z",
    id: "a"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#a"
  })));
};

Copy.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var CreateProject = function CreateProject(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.977 20.024h-1.988v1.988h-1.326v-1.988h-1.988v-1.326h1.988V16.71h1.326v1.988h1.988v1.326zm-9.843 1.786v-9.014l8.152-4.89v6.918a4.639 4.639 0 0 0-5.506 5.459l-2.646 1.527zM2.911 6.474l8.428-4.867 8.53 4.925-8.43 5.059L2.91 6.474zm7.832 15.451L3.267 17.61l2.172-1.086-.622-1.245-2.424 1.212V7.786l8.35 5.01v9.13zm10.935-6.542V5.969L11.338 0 1 5.97v11.937l10.339 5.97 3.946-2.28C16.076 23.025 17.579 24 19.326 24a4.638 4.638 0 0 0 4.639-4.638c0-1.7-.924-3.172-2.287-3.98zm-5.104-.727l-2.905-1.452-.622 1.244 2.904 1.452.623-1.244zm-6.985-.208l-.623-1.245-2.904 1.453.622 1.244 2.905-1.452zm1.154-8.773h1.392V2.427h-1.392v3.248zm0 4.64h1.392V7.066h-1.392v3.247z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CreateProject.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CreateProjectThin = function CreateProjectThin(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.457 19.314h-1.543v1.543h-1.028v-1.543h-1.543v-1.028h1.543v-1.543h1.028v1.543h1.543v1.028zm-9.431 3.725V12.435a.366.366 0 0 0 .45-.148.344.344 0 0 0 .005-.341l9.134-5.161v9.18A3.58 3.58 0 0 0 19.4 15.2a3.6 3.6 0 0 0-3.6 3.6c0 .667.184 1.289.5 1.824l-4.274 2.415zm-.36-12.123a.355.355 0 0 0-.358.351v.124l-9.23-5.215L11.308.96v.463c0 .194.16.352.359.352.198 0 .359-.158.359-.352V.961l9.23 5.215-9.23 5.215v-.124a.355.355 0 0 0-.36-.351zm-.358 12.123L9.115 21.8l-7.397-4.179c.067.011.154.045.244.045a.361.361 0 0 0 .18-.048l.497-.28a.347.347 0 0 0 .131-.48.364.364 0 0 0-.49-.13l-.498.281a.343.343 0 0 0-.064.046V6.785l9.134 5.16a.343.343 0 0 0 .006.342.36.36 0 0 0 .45.148v10.604zm5.525-7.884a.365.365 0 0 0 .49-.129.347.347 0 0 0-.131-.48l-.986-.557a.363.363 0 0 0-.491.129.348.348 0 0 0 .132.48l.986.557zm-9.706-1.166l-.986.557a.348.348 0 0 0-.131.48.362.362 0 0 0 .49.129l.987-.557a.348.348 0 0 0 .131-.48.363.363 0 0 0-.49-.13zm-2.423 1.37l-.987.557a.348.348 0 0 0-.131.48.362.362 0 0 0 .49.129l.987-.558a.348.348 0 0 0 .131-.48.363.363 0 0 0-.49-.128zm4.847-2.74l-.986.557a.348.348 0 0 0-.131.48.36.36 0 0 0 .49.13l.987-.558a.348.348 0 0 0 .131-.48.364.364 0 0 0-.49-.129zm2.116-8.104c.198 0 .359-.157.359-.351V3.05a.355.355 0 0 0-.36-.352.355.355 0 0 0-.359.352v1.114c0 .194.161.351.36.351zm3.1 8.661l-.985-.557a.364.364 0 0 0-.49.129c-.1.168-.041.383.13.48l.987.557a.364.364 0 0 0 .49-.128.348.348 0 0 0-.131-.48zm-3.1-5.922c.198 0 .359-.157.359-.351V5.789a.356.356 0 0 0-.36-.352.356.356 0 0 0-.359.352v1.114c0 .194.161.351.36.351zm.359 1.274a.356.356 0 0 0-.36-.352.355.355 0 0 0-.358.352v1.115c0 .194.16.35.359.35.198 0 .359-.156.359-.35V8.528zm10.307 8.19V6.176a.35.35 0 0 0-.18-.305L11.847.047a.368.368 0 0 0-.359 0L1.18 5.87a.35.35 0 0 0-.18.305v11.648a.35.35 0 0 0 .18.305l7.575 4.28 2.732 1.543a.36.36 0 0 0 .36 0L16.72 21.2a3.586 3.586 0 0 0 2.68 1.2A3.6 3.6 0 0 0 23 18.8c0-.776-.249-1.493-.667-2.081z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

CreateProjectThin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CsvFiles = function CsvFiles(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.003 13.047v-5.1c0-1.035-.864-1.874-1.927-1.874H1.926C.863 6.073 0 6.912 0 7.947v5.1c0 1.035.862 1.874 1.927 1.874h16.147c1.065 0 1.93-.839 1.93-1.874zM6.2 9.496a2.09 2.09 0 0 0-.648-.548 1.55 1.55 0 0 0-.744-.204c-.283 0-.54.07-.772.212a1.502 1.502 0 0 0-.548.584 1.72 1.72 0 0 0-.2.828c0 .304.067.58.2.828s.316.443.548.584c.232.141.49.212.772.212.23 0 .47-.059.72-.176.25-.117.475-.277.672-.48l.856.92c-.304.32-.665.575-1.084.764a3 3 0 0 1-1.244.284 2.977 2.977 0 0 1-1.504-.384 2.806 2.806 0 0 1-1.056-1.048 2.918 2.918 0 0 1-.384-1.488c0-.544.13-1.035.392-1.472A2.8 2.8 0 0 1 3.252 7.88c.456-.25.967-.376 1.532-.376.416 0 .827.087 1.232.26.405.173.75.41 1.032.708L6.2 9.496zm5.344-.216a4.919 4.919 0 0 0-.956-.432c-.339-.112-.623-.168-.852-.168-.181 0-.324.033-.428.1a.325.325 0 0 0-.156.292.4.4 0 0 0 .136.308c.09.083.203.15.336.2.133.05.33.116.592.196.39.112.71.224.964.336.253.112.47.284.652.516.181.232.272.535.272.908s-.099.692-.296.956a1.795 1.795 0 0 1-.812.596c-.344.133-.727.2-1.148.2a4.15 4.15 0 0 1-1.388-.244 3.8 3.8 0 0 1-1.196-.668l.568-1.144c.283.25.617.456 1.004.616.387.16.73.24 1.028.24.219 0 .39-.04.516-.12a.392.392 0 0 0 .188-.352.416.416 0 0 0-.14-.32 1.029 1.029 0 0 0-.352-.204c-.141-.05-.34-.11-.596-.18a7.355 7.355 0 0 1-.952-.324 1.685 1.685 0 0 1-.644-.496c-.179-.221-.268-.516-.268-.884 0-.347.092-.65.276-.912.184-.261.445-.463.784-.604a3.046 3.046 0 0 1 1.18-.212c.405 0 .805.057 1.2.172a3.95 3.95 0 0 1 1.04.46l-.552 1.168zm.744-1.688h1.576l1.4 4.056 1.408-4.056h1.504L15.984 13.2h-1.52l-2.176-5.608zM23.442 0c.308 0 .56.25.558.56v18.724c0 .136-.05.27-.14.371l-3.715 4.159a.564.564 0 0 1-.417.186H6.832a.559.559 0 0 1-.56-.558v-6.14h1.679v5.219h10.347l-.012-4.172a.62.62 0 0 1 .62-.622l3.333.003V1.401H7.951v2.243H6.273V.56A.56.56 0 0 1 6.832 0h16.61z",
    fill: "currentColor"
  })));
};

CsvFiles.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Date$1 = function Date(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.188 1.875h-1.125V0h-1.875v1.875H5.813V0H3.938v1.875H2.812A2.816 2.816 0 0 0 0 4.688v16.5A2.816 2.816 0 0 0 2.813 24h18.375A2.816 2.816 0 0 0 24 21.187v-16.5a2.816 2.816 0 0 0-2.813-2.812zm.937 19.313c0 .516-.42.937-.938.937H2.813a.939.939 0 0 1-.937-.938V10.813h20.25v10.376zm0-12.25H1.875v-4.25c0-.517.42-.938.938-.938h1.124v1.875h1.876V3.75h12.375v1.875h1.875V3.75h1.125c.516 0 .937.42.937.938v4.25z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Date$1.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DebugLogs = function DebugLogs(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 22a1 1 0 0 0 1 .985c.555-.008 1-.46 1-1.015A2.972 2.972 0 0 1 4.968 19h.705c.206.42.45.822.727 1.2a7 7 0 0 0 11.2 0c.277-.378.52-.78.728-1.2h.702A2.98 2.98 0 0 1 22 22a1 1 0 0 0 1 .985c.555-.008 1-.46 1-1.015A4.975 4.975 0 0 0 19.033 17a8.43 8.43 0 0 0 .145-.9l.1-1.1H23a1 1 0 1 0 0-2h-3.54l.14-1.548a4.96 4.96 0 0 0 0-.5A4.968 4.968 0 0 0 24 6a1 1 0 0 0-1-.985 1.015 1.015 0 0 0-1 1.017A2.965 2.965 0 0 1 19.168 9 4.71 4.71 0 0 0 16 6.22V5a4 4 0 1 0-8 0v1.22A4.71 4.71 0 0 0 4.833 9 2.975 2.975 0 0 1 2 6a1 1 0 0 0-1-.985 1.015 1.015 0 0 0-1 1.017 4.958 4.958 0 0 0 4.408 4.91 4.96 4.96 0 0 0 0 .5L4.54 13H1a1 1 0 1 0 0 2h3.723l.1 1.1c.032.302.08.603.145.9A4.982 4.982 0 0 0 0 22zm17.608-10.728l-.423 4.645A6.065 6.065 0 0 1 16 19a5 5 0 0 1-3 1.89V8h1.62a3 3 0 0 1 3 3.272h-.012zM12 3a2 2 0 0 1 2 2v1h-4V5a2 2 0 0 1 2-2zM7.165 8.977A2.968 2.968 0 0 1 9.38 8H11v12.89A5 5 0 0 1 8 19a6.065 6.065 0 0 1-1.185-3.083l-.422-4.645c-.081-.84.2-1.674.772-2.295z",
    fill: "currentColor"
  })));
};

DebugLogs.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DefaultTarget = function DefaultTarget(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.28 2.567L13.8 0H3v24h2.4V12.834h6.72l.48 2.567H21V2.567z"
  })));
};

DefaultTarget.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Deployment = function Deployment(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.697.002c.345-.019.69.106.938.351.247.246.38.587.364.937l-.012.228a14.218 14.218 0 0 1-5.452 10.534l-1.018.797v2.49a8.084 8.084 0 0 1-2.362 5.734l-2.73 2.746a.615.615 0 0 1-.654.14.617.617 0 0 1-.392-.544l-.284-5.554-.094.072a.618.618 0 0 1-.667.055c-.11-.06-.217-.121-.323-.185l-.491.41-.127.108c-.33.277-.67.563-.967.804a.622.622 0 0 1-.647.079A6.235 6.235 0 0 1 6.01 17.95a6.284 6.284 0 0 1-1.21-1.74.622.622 0 0 1 .085-.66l1.303-1.556a9.916 9.916 0 0 1-.233-.41.614.614 0 0 1 .063-.681l.053-.067-5.49-.283a.617.617 0 0 1-.404-1.05L2.91 8.756a7.987 7.987 0 0 1 5.703-2.375l2.61.077.971-1.204A14.15 14.15 0 0 1 22.266.03zM.561 22.6a.562.562 0 1 1 0 1.125.562.562 0 0 1 0-1.125zm3.48-4.895a.627.627 0 0 1 .654 1.06l-.085.052-1.152.575c-.406.202-.694.59-.769 1.04l-.015.141-.046.654a.134.134 0 0 0 .04.104.128.128 0 0 0 .067.037l.056.002.642-.044a1.43 1.43 0 0 0 1.108-.666l.07-.124.564-1.135a.626.626 0 0 1 1.16.452l-.035.092-.574 1.154a2.67 2.67 0 0 1-2.02 1.455l-.182.018-.667.046a1.393 1.393 0 0 1-1.074-.402 1.377 1.377 0 0 1-.403-.925l.002-.14.045-.67c.06-.878.55-1.67 1.309-2.119l.16-.086zm12.25-3.9l-4.016 3.135.257 5.027 1.755-1.766a6.853 6.853 0 0 0 2.003-4.863v-1.533zm-9.385 1.246l-.818.978a4.982 4.982 0 0 0 1.875 1.884c.172-.142.352-.292.53-.442l.457-.383a10.798 10.798 0 0 1-1.129-.991l-.019-.018c-.318-.322-.619-.668-.896-1.028zM22.774 1.23l-.43.028a12.92 12.92 0 0 0-9.198 4.77l-5.912 7.323a9.88 9.88 0 0 0 1.019 1.405l2.343-2.358a.627.627 0 0 1 .868 0 .62.62 0 0 1 0 .87l-2.348 2.363c.453.405.942.766 1.458 1.076l7.21-5.628a13 13 0 0 0 4.98-9.622l.01-.228zm-10.36 9.794a.562.562 0 1 1-.002 1.123.562.562 0 0 1 .002-1.123zm-3.81-3.412a6.771 6.771 0 0 0-4.826 2.015l-1.759 1.767 5.009.26 3.224-3.993zm8.633-2.652c.555 0 1.078.216 1.47.608.81.81.81 2.128 0 2.94a2.065 2.065 0 0 1-1.47.607 2.063 2.063 0 0 1-1.47-.608 2.08 2.08 0 0 1 0-2.939 2.068 2.068 0 0 1 1.47-.608zm0 1.203a.874.874 0 1 0-.002 1.749.874.874 0 0 0 .002-1.75z",
    fill: "currentColor"
  })));
};

Deployment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DeploymentBold = function DeploymentBold(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23 0a1 1 0 0 1 1 1v2.04a15.89 15.89 0 0 1-1.203 6.078 16.04 16.04 0 0 1-4.902 6.452A1 1 0 0 1 18 16v.9a7.25 7.25 0 0 1-5.803 7.08 1 1 0 0 1-1.177-.775l-.94-4.705-4.58-4.58-4.697-.943a1 1 0 0 1-.783-1.174A7.25 7.25 0 0 1 7.1 6H8a1 1 0 0 1 .43.105A15.878 15.878 0 0 1 20.96 0zM3.683 15.052a1 1 0 1 1 .635 1.895A3.385 3.385 0 0 0 2 20.162V22h1.838a3.385 3.385 0 0 0 3.215-2.318 1 1 0 0 1 1.895.635A5.378 5.378 0 0 1 3.838 24H1a1 1 0 0 1-1-1v-2.838a5.378 5.378 0 0 1 3.683-5.11zM16 16.85c-.605.358-1.234.675-1.883.947l-1.975.815.623 3.115A5.235 5.235 0 0 0 16 16.9zM22 2h-1.04a13.888 13.888 0 0 0-5.315 1.053 14.037 14.037 0 0 0-7.592 7.592l-.875 2.12 4.057 4.057 2.12-.875a14.037 14.037 0 0 0 7.592-7.592A13.888 13.888 0 0 0 22 3.04V2zM11 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4-6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM7.15 8H7.1a5.235 5.235 0 0 0-4.827 3.235l3.115.623.815-1.975c.272-.649.589-1.278.947-1.883zM15 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

DeploymentBold.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DeploymentFilled = function DeploymentFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.548.003c.8-.05 1.5.65 1.45 1.45-.25 5.599-2.45 10.598-6.05 14.298.75 2.7.6 6.6-3.25 8.249-.35-1.25-1-2.75-2-4.25l-.3.15c-.5.3-1.15.2-1.6-.25L4.35 13.201c-.4-.4-.55-1.05-.25-1.6l.15-.3c-1.5-1-3-1.65-4.25-2 1.5-3.8 5.55-3.999 8.25-3.25C11.948 2.453 16.947.253 22.547.004zM4.722 16L9 20.278a9.484 9.484 0 0 1-5.409 2.704 1.366 1.366 0 0 1-1.573-1.573A9.484 9.484 0 0 1 4.722 16zm12.876-9.598a2.867 2.867 0 0 0-4.1 0c-1.1 1.1-1.15 2.95 0 4.1a2.867 2.867 0 0 0 4.1 0 2.867 2.867 0 0 0 0-4.1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

DeploymentFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DeploymentExport = function DeploymentExport(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.964 4.745a.678.678 0 0 1 0-.957L11.527.2c.13-.13.304-.2.473-.2.17 0 .343.065.473.2l3.563 3.588a.678.678 0 0 1 0 .957.667.667 0 0 1-.95 0l-2.414-2.43v11.614a.671.671 0 1 1-1.344 0V2.315l-2.413 2.43a.666.666 0 0 1-.95 0zm16.011 10.657c.02.055.025.115.025.18v3.538c0 2.69-2.175 4.88-4.847 4.88H4.847C2.175 24 0 21.81 0 19.12v-3.553c0-.06.01-.12.025-.18L2.364 7.87a.67.67 0 0 1 .368-.436l.065-.03a.68.68 0 0 1 .278-.06h4.22c.373 0 .672.3.672.677a.671.671 0 0 1-.672.676H3.533l-1.985 6.22h5.02c.373 0 .672.3.672.676v.612c0 .897.722 1.623 1.612 1.623h6.087c.89 0 1.612-.726 1.612-1.623v-.612c0-.375.299-.676.672-.676h5.224l-1.975-6.205H16.71a.671.671 0 0 1-.672-.676c0-.376.299-.677.672-.677h4.215c.094 0 .189.02.278.06l.065.03c.18.086.314.24.368.436l2.34 7.518zm-4.822 7.245c1.931 0 3.503-1.583 3.513-3.527v-2.851h-4.762a2.968 2.968 0 0 1-2.955 2.906H8.862a2.968 2.968 0 0 1-2.956-2.906H1.344v2.85c0 1.945 1.572 3.528 3.503 3.528h14.306z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

DeploymentExport.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var DialogError = function DialogError(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.029 5.502H1.674c-.47 0-.872.167-1.19.503A1.71 1.71 0 0 0 0 7.222v11.162c0 .462.162.87.484 1.203a1.6 1.6 0 0 0 1.19.49h6.944L13.82 23v-2.923h4.209a1.6 1.6 0 0 0 1.19-.49c.321-.332.484-.741.484-1.203V7.222c0-.476-.166-.881-.484-1.217a1.578 1.578 0 0 0-1.19-.503zm-.242 12.606h-5.489v2.104l-3.21-1.922-.347-.182H1.928c-.097 0-.138-.042-.138-.14V7.424c0-.126.041-.182.138-.182h15.859c.097 0 .138.056.138.182v10.544c0 .098-.041.14-.138.14zm-9.906-7.926c.26 0 .473.084.638.252a.894.894 0 0 1 .247.653.912.912 0 0 1-.247.657.843.843 0 0 1-.638.258.831.831 0 0 1-.627-.258.912.912 0 0 1-.247-.657c0-.267.08-.484.242-.653a.836.836 0 0 1 .632-.252zm0 3.124c.26 0 .473.084.638.252a.894.894 0 0 1 .247.653.912.912 0 0 1-.247.657.843.843 0 0 1-.638.258.831.831 0 0 1-.627-.258.912.912 0 0 1-.247-.657c0-.267.08-.484.242-.653a.836.836 0 0 1 .632-.252zm5.493-4.251a6.587 6.587 0 0 0-.719 1.678 7.033 7.033 0 0 0-.259 1.9c0 .65.087 1.284.259 1.901.172.618.412 1.177.72 1.678H12.08a5.652 5.652 0 0 1-.767-1.649 6.909 6.909 0 0 1-.267-1.93c0-.672.089-1.315.267-1.93a5.652 5.652 0 0 1 .767-1.648h1.293zm10.128-7.648c.329.325.498.434.498.91v10.451c0 .476-.17.878-.498 1.203-.322.318-.72.49-1.176.49h-1.73v-1.553h1.73c.097 0 .139-.042.139-.14V2.538c0-.097-.042 0-.139 0H7.33c-.097 0-.138-.097-.138 0v2.327H5.628V2.68c0-.951.76-1.679 1.7-1.679h14.998c.457 0 .854.089 1.176.407z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

DialogError.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Diamant = function Diamant(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 13.028a1.047 1.047 0 1 1 0-2.093 1.047 1.047 0 0 1 0 2.093zm-2.19-1.023c0 1.107.75 2.227 2.15 2.227 1.273 0 2.15-.929 2.15-2.278 0-.878-.432-2.163-2.15-2.163-1.272 0-2.15 1.043-2.15 2.214zM3.074 12c0-4.921 4.004-8.926 8.926-8.926.817 0 1.473.19 1.94.541.151.113.269.3.351.523h2.053v10.686h.805a6.713 6.713 0 0 0 .776-2.842c.166-3.21.054-4.715.054-5.331 0-.562.78-.565 1.095-.17.366.462.687 1.076.948 1.608A8.918 8.918 0 0 1 20.925 12c0 4.921-4.004 8.926-8.925 8.926-4.922 0-8.926-4.005-8.926-8.926zM0 12c0 6.617 5.383 12 12 12 6.616 0 12-5.383 12-12 0-6.616-5.384-12-12-12C5.383 0 0 5.384 0 12zm15.306 2.732c-.75 1.115-2 1.692-3.365 1.692-2.807 0-4.287-2.192-4.287-4.423 0-2.48 1.769-4.403 4.364-4.403 1.038 0 2.346.308 3.288 1.5V5.195h-.888c-.04.39-.178.73-.43.855-.515.258-1.03 0-1.988.015-3.268.048-5.917 2.649-5.917 5.917A5.917 5.917 0 0 0 12 17.899c1.798 0 3.355-.765 4.424-2.017h-1.118v-1.15z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Diamant.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Dictionaries = function Dictionaries(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.549 0C21.35 0 22 .669 22 1.494V20.41c0 .466-.211.906-.571 1.188l-2.654 2.082c-.14.11-.306.199-.42.228a1.435 1.435 0 0 1-.503.092h-14.4c-.801 0-1.45-.669-1.45-1.494v-1.292L2 21.129l.001-16.95c0-.3.088-.594.253-.842L4.034.65A1.44 1.44 0 0 1 5.235 0h15.315zm-.728 2.246H5.658L4.194 4.393c-.01 7.982-.016 16.506-.014 16.723v.638h13.426l2.215-1.718V2.246zm-4.136 4.37h-5.69c-.592 0-1.062-.527-1.062-1.168 0-.641.47-1.169 1.062-1.169h6.751c.592 0 1.062.528 1.062 1.169v10.251c0 .641-.47 1.169-1.062 1.169-.591 0-1.061-.528-1.061-1.169V6.617z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Dictionaries.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Dock = function Dock(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16 21.5v-19H2.5v19H16zM2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Dock.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Download = function Download(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.816 9.934l-5.259 5.776A.707.707 0 0 1 12 16a.707.707 0 0 1-.557-.29l-5.26-5.776a.941.941 0 0 1-.116-.908c.12-.302.383-.497.674-.497h3.037V.847c0-.468.332-.847.74-.847h2.964c.409 0 .74.38.74.847V8.53h3.037c.29 0 .555.194.675.497a.94.94 0 0 1-.118.908zm2.984 5.884H24v6.546c0 .905-.715 1.636-1.6 1.636H1.6C.717 24 0 23.269 0 22.364v-6.546h3.2v4.91h17.6v-4.91z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Download.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Edit = function Edit(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M.419 16.883l13.22-13.167 3.313-3.33c.548-.516 1.395-.516 1.92.008l4.741 4.78c.517.549.517 1.395-.007 1.918L7.08 23.582a1.321 1.321 0 0 1-.949.393L1.345 24c-.363 0-.693-.135-.951-.393A1.374 1.374 0 0 1 0 22.631l.025-4.799c0-.34.14-.66.394-.949zM16.36 4.556l3.083 3.084 1.53-1.53-3.083-3.083-1.53 1.53zM2.913 18.245l-.022 2.863 2.884-.02L17.64 9.227 14.778 6.36 2.913 18.245z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Edit.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var EditInfo = function EditInfo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.234 9.277l.13.148a2.457 2.457 0 0 1-.236 3.525l-2.174 1.856v6.757c0 1.331-1.105 2.437-2.476 2.437H3.46A2.45 2.45 0 0 1 1 21.563V2.386C1.008 1.074 2.11.016 3.46.023h10.673c.02 0 .04-.01.06-.009.019-.002.038-.014.058-.014.167 0 .326.066.442.182l.005.006 5.08 4.92a.585.585 0 0 1 .176.425v2.91c.167-.02.336-.025.504-.015a2.6 2.6 0 0 1 1.776.85zM19.04 14l.738-.631-1.904-2.112L12.08 16.2l-.487 2.236 2.392-.132 3.464-2.945 1.405-1.202a.61.61 0 0 1 .185-.16zM14.892 2.044v2.894h2.975l-2.975-2.894zm3.828 19.52v-5.701l-.537.463-3.543 3.016a.63.63 0 0 1-.372.148l-3.41.189h-.035a.625.625 0 0 1-.48-.221.586.586 0 0 1-.124-.502l.696-3.198a.596.596 0 0 1 .196-.326l6.315-5.391a.608.608 0 0 1 .192-.165l.97-.83a.722.722 0 0 1 .132-.108V6.137h-4.49a.582.582 0 0 1-.573-.591V1.222H3.43c-.67.009-1.204.542-1.195 1.192v19.15c0 .67.536 1.237 1.226 1.237h14.017c.69 0 1.242-.568 1.242-1.238zm2.596-9.513a1.28 1.28 0 0 0 .122-1.836l-.133-.148-.002-.002a1.371 1.371 0 0 0-1.895-.118l-.606.517 1.902 2.11.612-.523zM5.179 8.415a.609.609 0 0 1-.617-.6c0-.33.276-.6.617-.6h4.944c.341 0 .618.27.618.6 0 .331-.277.6-.618.6H5.18zm8.425 3.297c0 .33-.276.599-.617.599H5.18a.609.609 0 0 1-.617-.6c0-.33.276-.599.617-.599h7.808c.341 0 .617.269.617.6z",
    fill: "currentColor"
  })));
};

EditInfo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Effect = function Effect(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.554 8.118c.415-.12.85.118.97.533A11.98 11.98 0 0 1 24 12c0 6.617-5.383 12-12 12-3.22 0-6.275-1.292-8.509-3.535v.926c0 .432-.34.783-.772.783a.783.783 0 0 1-.783-.783v-2.964c-.103-.513.313-.944.783-.944h3.13c.433 0 .783.346.783.778 0 .432-.35.782-.782.782H4.308A10.424 10.424 0 0 0 12 22.435c5.754 0 10.435-4.681 10.435-10.435 0-.99-.14-1.97-.413-2.912a.783.783 0 0 1 .532-.97zM12.137 3.74c.428-.642 1.428-.338 1.428.434v5.478h3.918c.624 0 .998.697.651 1.217l-6.26 9.391c-.43.645-1.434.336-1.434-.434v-5.483H6.527a.78.78 0 0 1-.651-1.212zm-.132 3.019L7.99 12.783h3.233c.433 0 .778.35.778.782v3.676l4.021-6.029h-3.233a.778.778 0 0 1-.783-.777V6.759zM12 0c3.274 0 6.366 1.335 8.609 3.648v-1.04a.783.783 0 0 1 1.565 0V5.74c0 .432-.35.783-.783.783h-3.13a.783.783 0 0 1 0-1.565h1.43A10.422 10.422 0 0 0 12 1.565C6.246 1.565 1.565 6.246 1.565 12c0 .99.14 1.97.413 2.911a.783.783 0 0 1-1.502.438A11.98 11.98 0 0 1 0 12C0 5.383 5.383 0 12 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Effect.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Entities = function Entities(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.68 11.223l-3.14-3.144c-.41-.409-1.134-.409-1.543 0-.412.413-.96.64-1.543.64a2.185 2.185 0 0 1-1.542-3.726 1.09 1.09 0 0 0 0-1.544L12.772.308c-.41-.41-1.134-.41-1.543 0l-2.39 2.391a4.314 4.314 0 0 0-3.385-1.62 4.37 4.37 0 0 0-4.363 4.365A4.32 4.32 0 0 0 2.71 8.83L.32 11.223a1.093 1.093 0 0 0 0 1.543l3.14 3.142a1.087 1.087 0 0 0 1.543 0c.412-.413.96-.64 1.542-.64a2.185 2.185 0 0 1 1.543 3.726 1.09 1.09 0 0 0 0 1.544l3.14 3.142a1.088 1.088 0 0 0 1.543.001l2.391-2.391a4.316 4.316 0 0 0 3.383 1.618 4.37 4.37 0 0 0 4.364-4.366c0-1.352-.613-2.579-1.62-3.384l2.391-2.392a1.09 1.09 0 0 0 0-1.543zm-4.969 3.427a1.092 1.092 0 0 0 .458 1.818 2.16 2.16 0 0 1 1.558 2.074 2.185 2.185 0 0 1-2.182 2.183 2.16 2.16 0 0 1-2.075-1.557 1.093 1.093 0 0 0-1.815-.459L12 21.365l-1.694-1.695a4.37 4.37 0 0 0-5.978-5.981l-1.693-1.696L5.289 9.34a1.094 1.094 0 0 0-.456-1.819 2.162 2.162 0 0 1-1.56-2.076c0-1.204.978-2.183 2.181-2.183.962 0 1.795.628 2.075 1.56a1.09 1.09 0 0 0 1.816.458L12 2.622l1.694 1.695a4.37 4.37 0 0 0 5.978 5.981l1.694 1.695-2.655 2.657z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Entities.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Environment = function Environment(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0l11 6v12l-9.9 5.4-1.1.6-11-6V6l11-6zM2.482 7.826v8.75l2.581-1.219.661 1.252-2.31 1.091 7.952 4.339V12.86L2.481 7.826zm19.039.121l-8.674 4.914v9.063l2.074-1.132 5.668-3.092-2.311-1.091.662-1.252 2.58 1.219V13.81h.001V7.947zM9.475 13.272l.663 1.251-3.09 1.459-.662-1.25 3.09-1.46zm5.05 0l3.089 1.46-.662 1.25-3.09-1.459.663-1.251zM12.001 1.615L3.033 6.508l9.073 5.142 8.97-5.084-9.075-4.95zm.846 5.488v3.265h-1.48V7.103h1.48zm0-4.662v3.264h-1.48V2.44h1.48z",
    fill: "currentColor"
  })));
};

Environment.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var EntitiesFields = function EntitiesFields(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.077 0v9.238H18.23V1.846H7.769v4.923H2.846v15.385h6.468V24H1V5.464L6.464 0h13.613zM15.55 10.18a.653.653 0 0 1 .9 0l1.832 1.832a.636.636 0 0 1 0 .9 1.274 1.274 0 0 0 1.8 1.8.655.655 0 0 1 .9 0l1.831 1.835a.636.636 0 0 1 0 .9l-1.394 1.395c.587.47.944 1.186.944 1.974a2.549 2.549 0 0 1-2.545 2.547 2.518 2.518 0 0 1-1.973-.944l-1.395 1.395a.636.636 0 0 1-.9 0l-1.832-1.834a.634.634 0 0 1 0-.9 1.274 1.274 0 0 0-1.8-1.8.634.634 0 0 1-.9 0l-1.832-1.833a.638.638 0 0 1 0-.9l1.395-1.396a2.52 2.52 0 0 1-.945-1.975 2.549 2.549 0 0 1 2.546-2.547c.789 0 1.503.358 1.974.946zm.45 1.35l-1.549 1.55a.635.635 0 0 1-1.059-.268 1.261 1.261 0 0 0-1.21-.91c-.702 0-1.273.572-1.273 1.274 0 .56.365 1.047.91 1.21a.639.639 0 0 1 .266 1.062l-1.548 1.548.987.989a2.549 2.549 0 0 1 3.487 3.49l.989.988 1.549-1.55a.635.635 0 0 1 1.059.268c.163.544.65.909 1.21.909.702 0 1.273-.571 1.273-1.274a1.26 1.26 0 0 0-.909-1.21.635.635 0 0 1-.267-1.06l1.549-1.55-.989-.989a2.549 2.549 0 0 1-3.487-3.49v.001L16 11.53zM5.923 3.151v1.771H4.151l1.772-1.771z",
    fill: "currentColor"
  })));
};

EntitiesFields.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var EntityRuleType = function EntityRuleType(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 4h9.834v2.758H2.569v4.078h6.517v2.758H2.57v4.148h7.495V20.5H0V4zm21.067 16.5l-2.32-4.88a3.485 3.485 0 0 1-.479.024H15.24V20.5h-2.57V4h5.598c1.738 0 3.08.495 4.026 1.485.946.99 1.418 2.389 1.418 4.196 0 1.288-.226 2.388-.68 3.3-.454.911-1.115 1.595-1.984 2.05L24 20.5h-2.933zm-5.827-7.637h3.028c.972 0 1.713-.26 2.224-.778.511-.519.767-1.289.767-2.31 0-1.006-.256-1.76-.767-2.263-.511-.503-1.252-.754-2.224-.754H15.24v6.105z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

EntityRuleType.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Error403 = function Error403(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h114v114H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M59.983 28.068c-8.585 0-15.544 6.794-15.544 15.175v9.896h-2.332c-3.37.006-6.1 2.671-6.107 5.961v19.164c.006 3.29 2.737 5.956 6.107 5.962h35.786c3.37-.006 6.1-2.672 6.107-5.962V59.057c-.006-3.29-2.737-5.956-6.107-5.961h-2.387v-9.853c0-8.373-6.946-15.163-15.523-15.175zM47.92 42.555c0-3.915 2.287-7.533 6-9.491 3.712-1.958 8.287-1.958 12 0 3.712 1.958 6 5.576 6 9.491v10.1h-24v-10.1zm32.264 16.592v18.771c0 1.463-1.203 2.649-2.686 2.649H42.87c-1.484 0-2.686-1.186-2.686-2.649v-18.77c0-1.463 1.202-2.65 2.686-2.65h34.628c1.483 0 2.686 1.187 2.686 2.65zM60.924 4c22.295.006 42.21 13.919 49.855 34.828 7.645 20.908 1.389 44.358-15.66 58.701-17.05 14.343-41.258 16.522-60.602 5.456-19.344-11.067-29.7-33.021-25.926-54.958v-.1L2.607 53.46a1.664 1.664 0 0 1-2.175-.25 1.658 1.658 0 0 1-.042-2.185l9.077-8.387c.329-.292.756-.45 1.197-.442.424.029.82.219 1.108.53l8.379 9.085a1.658 1.658 0 0 1-.79 2.906 1.664 1.664 0 0 1-1.649-.693l-5.962-6.429c.142.304.189.643.133.974a50.054 50.054 0 0 0-.71 8.42c.014 23.693 16.788 44.077 40.065 48.69 23.278 4.613 46.578-7.831 55.654-29.723s1.401-47.135-18.332-60.296C68.826 2.498 42.53 5.085 25.747 21.837a1.664 1.664 0 0 1-2.308-.04 1.658 1.658 0 0 1-.041-2.306 52.778 52.778 0 0 1 37.526-15.49z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Error403.defaultProps = {
  width: "114",
  height: "114",
  viewBox: "0 0 114 114",
  xmlns: "http://www.w3.org/2000/svg"
};

var Error404 = function Error404(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h114v114H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M104.5 9c5.244.006 9.494 4.216 9.5 9.412v77.176c-.006 5.196-4.256 9.406-9.5 9.412h-95c-5.244-.006-9.494-4.216-9.5-9.412V18.412C.006 13.216 4.256 9.006 9.5 9zm5.7 18.823H3.8v67.765c0 3.12 2.552 5.647 5.7 5.647h95c3.148 0 5.7-2.528 5.7-5.647V27.823zM56.837 48c6.988 0 10.87 5.331 10.87 14.979 0 9.647-3.882 15.021-10.87 15.021-7.03 0-10.912-5.374-10.912-15.021C45.925 53.33 49.807 48 56.837 48zm-21.96.17l-9.114 17.77h7.928v-6.812h5.068l.04 6.813h4.088v4.866h-4.128v7.024H33.69v-7.024H20V66.66l9.604-18.49h5.272zm51.113 0l-9.114 17.77h7.928v-6.812h5.068l.041 6.813H94v4.866h-4.128v7.024h-5.068v-7.024h-13.69V66.66l9.604-18.49h5.272zm-29.153 4.188c-3.72 0-5.518 3.3-5.518 10.62 0 7.321 1.798 10.664 5.518 10.664 3.678 0 5.476-3.343 5.476-10.663s-1.798-10.62-5.476-10.62zM104.5 12.765h-95c-3.148 0-5.7 2.528-5.7 5.647v5.647h106.4v-5.647c0-3.119-2.552-5.647-5.7-5.647zm-79.244 3.778c1.024 0 1.854.767 1.854 1.714s-.83 1.714-1.854 1.714H12.28c-1.023 0-1.853-.767-1.853-1.714s.83-1.714 1.853-1.714zm76.428 0c1.043 0 1.89.767 1.89 1.714s-.847 1.714-1.89 1.714H31.779c-1.043 0-1.889-.767-1.889-1.714s.846-1.714 1.89-1.714z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Error404.defaultProps = {
  width: "114",
  height: "114",
  viewBox: "0 0 114 114",
  xmlns: "http://www.w3.org/2000/svg"
};

var ErrorGeneral = function ErrorGeneral(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h114v114H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M104.5 9c5.244.006 9.494 4.216 9.5 9.412v77.176c-.006 5.196-4.256 9.406-9.5 9.412h-95c-5.244-.006-9.494-4.216-9.5-9.412V18.412C.006 13.216 4.256 9.006 9.5 9zm5.7 18.823H3.8v67.765c0 3.12 2.552 5.647 5.7 5.647h95c3.148 0 5.7-2.528 5.7-5.647V27.823zM71 45c-1.518 2.439-2.704 5.21-3.558 8.314-.854 3.104-1.281 6.333-1.281 9.686 0 3.353.427 6.582 1.28 9.686C68.297 75.79 69.482 78.56 71 81h-4.798c-1.627-2.383-2.867-5.12-3.721-8.21C61.627 69.7 61.2 66.437 61.2 63c0-3.437.427-6.7 1.28-9.79.855-3.09 2.095-5.827 3.722-8.21H71zM46.451 69.23c1.037 0 1.888.33 2.552.986.665.657.997 1.49.997 2.502 0 .977-.34 1.794-1.02 2.45-.681.657-1.524.986-2.529.986-1.004 0-1.83-.329-2.479-.986-.648-.656-.972-1.473-.972-2.45 0-1.011.324-1.845.972-2.502.648-.657 1.475-.985 2.48-.985zm0-19.384c1.037 0 1.888.329 2.552.986.665.656.997 1.49.997 2.501 0 .977-.34 1.794-1.02 2.45-.681.658-1.524.986-2.529.986-1.004 0-1.83-.328-2.479-.985-.648-.657-.972-1.474-.972-2.451 0-1.01.324-1.845.972-2.501.648-.657 1.475-.986 2.48-.986zM104.5 12.765h-95c-3.148 0-5.7 2.528-5.7 5.647v5.647h106.4v-5.647c0-3.119-2.552-5.647-5.7-5.647zm-79.244 3.778c1.024 0 1.854.767 1.854 1.714s-.83 1.714-1.854 1.714H12.28c-1.023 0-1.853-.767-1.853-1.714s.83-1.714 1.853-1.714zm76.428 0c1.043 0 1.89.767 1.89 1.714s-.847 1.714-1.89 1.714H31.779c-1.043 0-1.889-.767-1.889-1.714s.846-1.714 1.89-1.714z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ErrorGeneral.defaultProps = {
  width: "114",
  height: "114",
  viewBox: "0 0 114 114",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExitAction = function ExitAction(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.725 6.857h2.548v12.486l2.924-2.79L18 18.272 11.998 24 6 18.273l1.803-1.72 2.922 2.79V6.857zm-7.489 9.049l-1.849 1.687A11.944 11.944 0 0 1 0 12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12 0 2.021-.505 3.922-1.387 5.593l-1.849-1.687A9.556 9.556 0 0 0 21.6 12 9.6 9.6 0 0 0 12 2.4 9.6 9.6 0 0 0 2.4 12c0 1.392.303 2.712.836 3.906z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ExitAction.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExitActionColor = function ExitActionColor(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#F8586D",
    fillRule: "nonzero",
    d: "M10.725 6.857h2.548v12.486l2.924-2.79L18 18.272 11.998 24 6 18.273l1.803-1.72 2.922 2.79z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.236 15.906l-1.849 1.687A11.944 11.944 0 0 1 0 12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12 0 2.021-.505 3.922-1.387 5.593l-1.849-1.687A9.556 9.556 0 0 0 21.6 12 9.6 9.6 0 0 0 12 2.4 9.6 9.6 0 0 0 2.4 12c0 1.392.303 2.712.836 3.906z",
    fill: "#4A90E2",
    fillRule: "nonzero"
  })));
};

ExitActionColor.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Expand = function Expand(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.734 12.126a2.497 2.497 0 0 1 3.535 0c.47.467.732 1.105.732 1.767v5.608a2.5 2.5 0 0 1-2.5 2.5h-5.605a2.5 2.5 0 0 1-2.5-2.5c0-.663.26-1.3.73-1.768l5.608-5.607zM16.938 2C19.723 2 22 4.28 22 7.063v.277a4.11 4.11 0 0 0-2.5-.237v-.04A2.566 2.566 0 0 0 16.938 4.5H7.065A2.567 2.567 0 0 0 4.5 7.063v9.875A2.567 2.567 0 0 0 7.065 19.5H7.1c-.06.285-.1.578-.1.875 0 .578.12 1.125.335 1.625h-.27C4.28 22 2 19.72 2 16.938V7.063C2 4.28 4.28 2 7.065 2h9.873z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Expand.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExpandDoubleArrows = function ExpandDoubleArrows(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.237 19.76l1.15 1.028a.888.888 0 0 0 1.152 0l9.213-8.236a.678.678 0 0 0 .23-.551c.012-.2-.061-.4-.23-.552L4.539 3.211a.89.89 0 0 0-1.151 0l-1.151 1.03a.679.679 0 0 0 0 1.031l7.527 6.729-7.527 6.728a.679.679 0 0 0 0 1.03m8.017 0l1.151 1.03a.888.888 0 0 0 1.152 0l9.212-8.237a.677.677 0 0 0 .23-.551c.011-.2-.06-.4-.23-.552l-9.212-8.238a.89.89 0 0 0-1.152 0l-1.151 1.03a.679.679 0 0 0 0 1.031l7.526 6.729-7.526 6.728a.679.679 0 0 0 0 1.03",
    fill: "currentColor"
  })));
};

ExpandDoubleArrows.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExpandElements = function ExpandElements(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.25 0c.415 0 .75.447.75 1v4c0 .553-.335 1-.75 1h-4.5c-.415 0-.75-.447-.75-1V1c0-.553.335-1 .75-1h4.5zm0 9c.415 0 .75.447.75 1v4c0 .553-.335 1-.75 1h-4.5c-.415 0-.75-.447-.75-1v-4c0-.553.335-1 .75-1h4.5zm0 9c.415 0 .75.447.75 1v4c0 .553-.335 1-.75 1h-4.5c-.415 0-.75-.447-.75-1v-4c0-.553.335-1 .75-1h4.5zm-7.373 1.812a.594.594 0 0 1 0 1.188h-2.385a.594.594 0 0 1-.595-.594v-7.804h-.303a.594.594 0 0 1 0-1.189h.303V3.594c0-.328.266-.594.595-.594h2.036a.594.594 0 0 1 0 1.188h-1.442v7.218h1.792a.594.594 0 0 1 0 1.188h-1.792v7.218h1.79zM9.187 7.5c.726 0 1.313.782 1.313 1.75v7c0 .968-.587 1.75-1.313 1.75H1.314C.587 18 0 17.218 0 16.25v-7C0 8.282.587 7.5 1.313 7.5h7.875z",
    fill: "currentColor"
  })));
};

ExpandElements.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExportResources = function ExportResources(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.211 13.646c1.541 0 2.789 1.215 2.789 2.714v3.927C24 21.78 22.752 23 21.211 23H2.79C1.248 23 0 21.781 0 20.287V16.36c0-1.5 1.248-2.714 2.789-2.714h5.078c.663 0 1.21.486 1.277 1.13.154 1.43 1.378 2.504 2.856 2.504.475 0 .864.378.864.84 0 .462-.389.84-.864.84a4.672 4.672 0 0 1-3.091-1.162 4.427 4.427 0 0 1-1.426-2.47H2.79c-.586 0-1.061.462-1.061 1.032v3.927c0 .57.475 1.032 1.06 1.032h18.423c.586 0 1.061-.462 1.061-1.032V16.36c0-.57-.475-1.032-1.06-1.032h-5.08a.855.855 0 0 1-.863-.841c0-.462.389-.84.864-.84h5.078zm-4.757-8.66a.83.83 0 0 1 0 1.19.874.874 0 0 1-1.219 0L12.864 3.87v9.644c0 .462-.389.84-.864.84a.855.855 0 0 1-.864-.84V3.87L8.77 6.172a.886.886 0 0 1-1.224 0 .82.82 0 0 1-.005-1.186l3.845-3.74a.886.886 0 0 1 1.224 0l3.844 3.74z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ExportResources.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.667 0H24v9.333h-2.667v-4.78L8.227 17.66 6.34 15.773 19.447 2.667h-4.78V0zm6.666 21.333V16H24v5.333A2.666 2.666 0 0 1 21.333 24H2.667A2.666 2.666 0 0 1 0 21.333V2.667A2.666 2.666 0 0 1 2.667 0H8v2.667H2.667v18.666h18.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ExternalLink.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Eye = function Eye(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.689 11.08C23.479 10.83 18.44 5 12 5S.522 10.83.31 11.08a1.293 1.293 0 0 0 .001 1.682c.211.249 5.249 6.079 11.69 6.079 6.44 0 11.477-5.83 11.688-6.08a1.293 1.293 0 0 0 0-1.682zM10.632 8.124c.387.307.374.969-.03 1.479-.404.51-1.045.675-1.432.368-.387-.305-.373-.968.03-1.478.405-.51 1.046-.675 1.432-.369zM12 16.728c-4.499 0-8.285-3.455-9.595-4.808.885-.913 2.9-2.785 5.5-3.904a4.9 4.9 0 1 0 8.19 0c2.6 1.12 4.615 2.99 5.5 3.904-1.31 1.354-5.096 4.808-9.595 4.808z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Eye.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var EyeSlash = function EyeSlash(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M12.055 6.21c3.068 0 5.48 2.316 5.48 5.264 0 .631-.11 1.368-.44 1.894l3.179 3.053c1.644-1.368 2.959-3.053 3.726-4.947-1.863-4.632-6.575-7.895-12.055-7.895-1.534 0-2.959.316-4.383.737l2.41 2.316c.658-.316 1.425-.421 2.083-.421zM.095 2.369L3.617 5.79l.439.422C2.192 7.579.767 9.368 0 11.474c1.863 4.631 6.575 7.894 12.055 7.894 1.644 0 3.287-.315 4.822-.842l.438.421L21.493 23l1.425-1.368L1.52 1 .096 2.368zm7.028 6.79l1.644 1.579v.737c0 1.79 1.425 3.158 3.288 3.158.219 0 .438 0 .767-.106l1.644 1.58a4.84 4.84 0 0 1-2.411.63c-3.069 0-5.48-2.315-5.48-5.262 0-.842.22-1.58.548-2.316zm4.713-.842l3.397 3.263v-.21c0-1.79-1.425-3.158-3.288-3.158 0 .105 0 .105-.11.105z",
    id: "a"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 24)",
    xlinkHref: "#a"
  })));
};

EyeSlash.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Favorite = function Favorite(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.945 8.9c-.066-.314-.352-.505-.665-.505h-7.97L12.702.506C12.588.163 12.362 0 12.01 0c-.352 0-.59.163-.704.506L8.698 8.395H.728c-.352 0-.574.164-.691.506-.091.369-.014.644.235.848l6.391 5.236-2.322 8.026c-.102.352 0 .642.261.847.287.178.588.2.86 0l6.548-4.785 6.535 4.785c.14.102.287.137.43.137.405 0 .718-.328.718-.752a1.11 1.11 0 0 0-.052-.314l-2.296-7.944 6.39-5.236c.258-.211.327-.493.21-.848zm-8.655 4.845a.657.657 0 0 0-.2.652l1.497 5.209-4.261-3.097a.509.509 0 0 0-.644 0l-4.261 3.097 1.498-5.209a.656.656 0 0 0-.2-.652L4.572 10.35h5.19c.263 0 .445-.131.538-.409L12.009 4.8l1.699 5.141c.091.278.274.41.548.41h5.18l-4.146 3.394z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Favorite.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FavoriteFilled = function FavoriteFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.945 8.9c-.066-.314-.352-.505-.665-.505h-7.97L12.702.506C12.588.163 12.362 0 12.01 0c-.352 0-.59.163-.704.506L8.698 8.395H.728c-.352 0-.574.164-.691.506-.091.369-.014.644.235.848l6.391 5.236-2.322 8.026c-.102.352 0 .642.261.847.287.178.588.2.86 0l6.548-4.785 6.535 4.785c.14.102.287.137.43.137.405 0 .718-.328.718-.752a1.11 1.11 0 0 0-.052-.314l-2.296-7.944 6.39-5.236c.258-.211.327-.493.21-.848z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

FavoriteFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Fetch = function Fetch(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M24 20.8v2.4H0v-2.4h24zM12 1.9c.403 0 .795.046 1.17.134l.105.004a5.12 5.12 0 0 1 2.338 1.348 5.13 5.13 0 0 1 1.349 2.339l.005.106a5.15 5.15 0 0 1 0 2.34l-.005.104a5.12 5.12 0 0 1-1.348 2.338 5.124 5.124 0 0 1-2.072 1.271l-.267.078V19h-2.55v-7.038a5.126 5.126 0 0 1-2.338-1.349 5.12 5.12 0 0 1-1.271-2.071l-.078-.267V8.19a5.16 5.16 0 0 1 0-2.38v-.085a5.126 5.126 0 0 1 1.349-2.338 5.125 5.125 0 0 1 2.338-1.349l.106-.005A5.15 5.15 0 0 1 12 1.9zm0 2.55c-.705 0-1.344.282-1.809.739A2.574 2.574 0 0 0 9.45 7c0 .68.264 1.3.693 1.76l.096.097c.46.43 1.08.693 1.761.693.68 0 1.3-.264 1.76-.693l.097-.096c.43-.46.693-1.08.693-1.761 0-.706-.283-1.346-.742-1.812A2.574 2.574 0 0 0 12 4.45z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Fetch.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var File = function File(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.756 0L2 5.464v18.535h20V0H7.756zM3.945 7.29h5.609V1.845h10.501v20.309H3.945V7.29zm3.763-4.702v2.856H4.73l2.978-2.856z",
    fill: "currentColor"
  })));
};

File.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Filter = function Filter(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.333 21h5.334v-2.667H9.333V21zM0 3v2.667h24V3H0zm4 10.333h16v-2.666H4v2.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Filter.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FirstPage = function FirstPage(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.09 12.708v8.917c0 .752-.557 1.375-1.231 1.375-.328 0-.636-.15-.867-.408l-8.626-9.625A1.449 1.449 0 0 1 1 12c0-.365.135-.709.366-.967l8.626-9.625c.231-.258.54-.408.867-.408.674 0 1.232.623 1.232 1.375v8.917c.051-.093.113-.18.184-.259L20.9 1.408c.231-.258.54-.408.867-.408C22.442 1 23 1.623 23 2.375v19.25c0 .752-.558 1.375-1.232 1.375-.328 0-.636-.15-.867-.408l-8.626-9.625a1.415 1.415 0 0 1-.184-.26z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

FirstPage.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Flow = function Flow(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.51.477A1.613 1.613 0 0 0 22.35 0H7.222c-.927 0-1.676.709-1.676 1.636v3.19h2.33l.049-2.74c0-.095.04-.136.136-.136h13.971c.095 0 .136.041.136.136V12c0 .095-.04.136-.136.136h-1.69l-.048 2.04h2.058c.45 0 .842-.167 1.158-.478.324-.317.491-.708.491-1.172V1.636c0-.464-.167-.842-.49-1.159zM18.175 5H1.786c-.501 0-.93.177-1.27.532C.178 5.886 0 6.314 0 6.816v11.783c0 .487.173.919.517 1.27.336.343.768.516 1.27.516h7.411L14.75 24v-3.615h3.426c.502 0 .934-.173 1.27-.516.343-.351.516-.783.516-1.27V6.816c0-.502-.177-.93-.517-1.285A1.694 1.694 0 0 0 18.175 5zm-.447 13.197h-4.677V20.752l-3.346-2.367-.36-.188H2.247c-.101 0-.144-.043-.144-.144V7.187c0-.13.043-.187.144-.187h15.482c.1 0 .144.058.144.187v10.866c0 .101-.043.144-.144.144zM13.922 9H6.098C5.49 9 5 9.45 5 10.009c0 .559.49.991 1.098.991h7.824c.607 0 1.078-.432 1.078-.991C15 9.451 14.53 9 13.922 9zm.323 4H8.77C8.343 13 8 13.45 8 14.009c0 .559.343.991.769.991h5.476c.426 0 .755-.432.755-.991 0-.558-.33-1.009-.755-1.009z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Flow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Folder = function Folder(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.715 4.672h-7.232a1.22 1.22 0 0 1-.735-.247l-2.364-1.8A3.08 3.08 0 0 0 6.528 2H3.049C1.368 2 0 3.358 0 5.027v13.946C0 20.643 1.368 22 3.05 22h16.448v-.014a3.074 3.074 0 0 0 1.627-.653c.54-.43.919-1.037 1.068-1.707l1.734-7.8c.2-.9-.018-1.83-.6-2.548a3.037 3.037 0 0 0-1.562-1.022V7.7c0-1.669-1.368-3.027-3.05-3.027zM3.05 3.827h3.479c.264 0 .525.088.735.248l2.365 1.8a3.08 3.08 0 0 0 1.855.625h7.232c.667 0 1.209.538 1.209 1.2v.447H6.56c-.692 0-1.37.237-1.91.667a3.034 3.034 0 0 0-1.067 1.707l-1.735 7.8-.008.04V5.028c0-.662.542-1.2 1.208-1.2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Folder.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FulfillIntentFilled = function FulfillIntentFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.8 24v-5.8H2.4A2.402 2.402 0 0 1 0 15.8V2.4C0 1.075 1.076 0 2.4 0h19.2C22.924 0 24 1.075 24 2.4v13.4c0 1.324-1.076 2.4-2.4 2.4h-7.4L4.8 24zm3.382-12.636a2.182 2.182 0 1 0 0-4.364 2.182 2.182 0 0 0 0 4.364zm7.636 0a2.182 2.182 0 1 0 0-4.364 2.182 2.182 0 0 0 0 4.364z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

FulfillIntentFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FulfillIntentOutline = function FulfillIntentOutline(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.8 24v-7.8H2.4A2.402 2.402 0 0 1 0 13.8V2.4C0 1.075 1.076 0 2.4 0h19.2C22.924 0 24 1.075 24 2.4v11.4c0 1.324-1.076 2.4-2.4 2.4h-7.4L4.8 24zM2.2 2.225v11.7h4.9v4.968l5.834-4.968H21.8v-11.7H2.2zM9 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

FulfillIntentOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GetStartedColored = function GetStartedColored(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.617 0c.211 0 .383.174.383.388V9.89a.386.386 0 0 1-.383.388.386.386 0 0 1-.383-.388V3.882H.766v19.342h22.468V18.47c0-.215.171-.389.383-.389.211 0 .383.174.383.389v5.14a.386.386 0 0 1-.383.389H.383A.386.386 0 0 1 0 23.612V.388C0 .174.171 0 .383 0h23.234zM.766 3.106h14.17V.776H.766v2.33zm14.936 0h7.532V.776h-7.532v2.33zm3.779-1.579c.225 0 .408.186.408.414a.412.412 0 0 1-.408.414.412.412 0 0 1-.409-.414c0-.228.183-.414.409-.414zm-2.094 0c.225 0 .409.186.409.414a.412.412 0 0 1-.409.414.412.412 0 0 1-.408-.414c0-.228.183-.414.408-.414zm4.188 0c.225 0 .408.186.408.414a.412.412 0 0 1-.408.414.412.412 0 0 1-.409-.414c0-.228.183-.414.409-.414zm-11.31 9.076c-1.006 0-1.824-.801-1.824-1.787v-.03C8.44 7.802 9.259 7 10.266 7c.18 0 .326.143.326.32 0 .176-.146.319-.326.319-.647 0-1.173.515-1.173 1.148v.03c0 .632.526 1.147 1.173 1.147h8.367c.646 0 1.172-.515 1.172-1.148v-.03c0-.632-.526-1.147-1.172-1.147h-6.657a.323.323 0 0 1-.325-.32c0-.176.145-.319.325-.319h6.657c1.006 0 1.825.801 1.825 1.787v.03c0 .985-.819 1.786-1.825 1.786h-8.367zm6.927 5.793c1.006 0 1.825.802 1.825 1.787v.03c0 .985-.819 1.787-1.825 1.787H8.825C7.82 20 7 19.198 7 18.213v-.03c0-.985.819-1.787 1.825-1.787h6.8c.18 0 .326.143.326.32 0 .176-.146.32-.326.32h-6.8c-.647 0-1.172.514-1.172 1.147v.03c0 .633.525 1.148 1.172 1.148h8.367c.647 0 1.173-.515 1.173-1.148v-.03c0-.633-.526-1.148-1.173-1.148a.323.323 0 0 1-.326-.32c0-.176.146-.319.326-.319zm4.983-4.66c1.006 0 1.825.801 1.825 1.787v.03c0 .984-.819 1.786-1.825 1.786h-8.367c-1.006 0-1.825-.802-1.825-1.787v-.03c0-.985.819-1.786 1.825-1.786h8.367zm1.172 1.816v-.03c0-.633-.525-1.148-1.172-1.148h-8.367c-.647 0-1.173.515-1.173 1.149v.03c0 .632.526 1.147 1.173 1.147h8.367c.647 0 1.172-.515 1.172-1.148zM12.161 7.96c.18 0 .326.143.326.32 0 .176-.146.319-.327.319H10.35a.323.323 0 0 1-.326-.32c0-.176.146-.319.326-.319h1.812zm-3.253 9.919h1.812c.18 0 .326.143.326.32 0 .176-.146.318-.326.318H8.908a.323.323 0 0 1-.326-.319c0-.176.146-.32.326-.32zm1.115-8.69c0-.176.146-.32.326-.32h8.008c.18 0 .327.144.327.32 0 .176-.146.32-.327.32H10.35a.323.323 0 0 1-.326-.32zm12.069 3.507c.18 0 .326.143.326.319 0 .177-.146.32-.326.32H20.28a.323.323 0 0 1-.326-.32c0-.176.146-.32.326-.32h1.812zm0 .91c.18 0 .326.142.326.319 0 .176-.146.32-.326.32h-8.009a.323.323 0 0 1-.326-.32c0-.177.146-.32.326-.32h8.009z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

GetStartedColored.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Git = function Git(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.578 10.931L13.111.46c-.61-.609-1.57-.609-2.18 0L8.484 2.906l1.833 1.833c.305-.131.61-.22.961-.22a2.28 2.28 0 0 1 2.269 2.268c0 .347-.09.699-.22.961l3.009 3.01c.305-.131.61-.22.96-.22a2.28 2.28 0 0 1 2.27 2.268 2.28 2.28 0 0 1-2.27 2.269 2.253 2.253 0 0 1-2.268-2.269c0-.347.09-.698.22-.96l-3.009-3.01-.22.042v6.24c.872.304 1.481 1.134 1.481 2.137a2.28 2.28 0 0 1-2.269 2.268 2.28 2.28 0 0 1-2.268-2.268c0-.961.609-1.833 1.48-2.138V8.883c-.871-.305-1.48-1.135-1.48-2.138 0-.347.089-.698.22-.96L7.35 3.951.46 10.889c-.61.61-.61 1.57 0 2.18L10.93 23.54c.61.609 1.57.609 2.18 0l10.425-10.425c.61-.572.61-1.575.042-2.185z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Git.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GitLogo = function GitLogo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M23.55 10.943L13.057.45c-.6-.6-1.592-.6-2.192 0L8.698 2.643l2.767 2.766c.652-.208 1.383-.078 1.88.444.521.522.652 1.253.443 1.906l2.662 2.662c.653-.209 1.384-.078 1.906.444.73.704.73 1.879 0 2.61-.731.73-1.88.73-2.61 0a1.813 1.813 0 0 1-.392-2.01l-2.48-2.506v6.526c.183.078.34.208.496.339.731.705.731 1.88 0 2.61-.73.705-1.879.705-2.61 0-.73-.73-.73-1.88 0-2.61a1.7 1.7 0 0 1 .6-.392V8.83c-.208-.079-.417-.235-.6-.392a1.813 1.813 0 0 1-.391-2.01l-2.74-2.714L.45 10.89c-.6.6-.6 1.592 0 2.192L10.917 23.55c.6.6 1.592.6 2.192 0l10.415-10.415c.626-.626.626-1.592.026-2.192z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

GitLogo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GitLabLogo = function GitLabLogo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M23.893 13.448l-1.255-3.856a.545.545 0 0 0-.03-.104l-2.519-7.75a1.001 1.001 0 0 0-.955-.683.984.984 0 0 0-.945.688l-2.4 7.386H8.214L5.811 1.743a.984.984 0 0 0-.94-.688h-.006c-.433 0-.817.278-.953.689l-2.52 7.76c0 .007-.006.012-.008.02L.107 13.449c-.193.59.017 1.238.52 1.603l11.038 8.02c.2.145.47.144.667-.003l11.041-8.017a1.432 1.432 0 0 0 .52-1.604m-16.5-3.185l3.077 9.47-7.387-9.47m10.45 9.472l2.951-9.08.128-.392h4.312l-6.682 8.56M19.144 2.47l2.162 6.659h-4.328m-1.555 1.13l-2.144 6.597L12 20.784 8.582 10.258M4.86 2.47L7.026 9.13H2.701m-1.41 5.01a.304.304 0 0 1-.11-.341l.949-2.916 6.958 8.92M22.71 14.14L14.912 19.8l.027-.033 6.931-8.885.95 2.914a.304.304 0 0 1-.11.342",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

GitLabLogo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GoToLine = function GoToLine(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.2 2.114c2.646 0 4.8 1.897 4.8 4.228v10.57c0 2.33-2.154 4.227-4.8 4.227h-1.903l1.551 1.366L17.152 24l-4.449-3.918 4.449-3.918 1.696 1.494-1.551 1.367H19.2c1.325 0 2.4-.947 2.4-2.114V6.341c0-1.165-1.075-2.113-2.4-2.113H12V2.114h7.2zM7.525 0C8.119 0 8.6.472 8.6 1.057v4.228c0 .584-.48 1.057-1.075 1.057h-6.45A1.065 1.065 0 0 1 0 5.285V1.057C0 .472.48 0 1.075 0h6.45zm0 8.456c.594 0 1.075.472 1.075 1.056v4.228c0 .585-.48 1.057-1.075 1.057h-6.45A1.065 1.065 0 0 1 0 13.74V9.512c0-.584.48-1.056 1.075-1.056h6.45zm0 8.455c.594 0 1.075.473 1.075 1.057v4.228c0 .584-.48 1.057-1.075 1.057h-6.45A1.065 1.065 0 0 1 0 22.196v-4.228c0-.584.48-1.057 1.075-1.057h6.45z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

GoToLine.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GridView = function GridView(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 10.21h10.213V0H0v10.21zM13.787 0v10.213H24V0H13.787zm0 24H24V13.787H13.787V24zM0 24h10.216V13.787H0V24z",
    fill: "currentColor"
  })));
};

GridView.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Handoff = function Handoff(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2 4.956C4.182 1.957 7.708 0 11.7 0c6.628 0 12 5.373 12 12s-5.372 12-12 12c-3.987 0-7.51-1.953-9.692-4.946l1.702-1.735A9.6 9.6 0 0 0 21.3 12 9.6 9.6 0 0 0 3.706 6.689L2 4.956zm-2 8.32v-2.549h12.486l-2.79-2.924L11.415 6l5.727 6.002L11.416 18l-1.72-1.803 2.79-2.922H0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Handoff.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var HandoffColor = function HandoffColor(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2 4.956C4.182 1.957 7.708 0 11.7 0c6.628 0 12 5.373 12 12s-5.372 12-12 12c-3.987 0-7.51-1.953-9.692-4.946l1.702-1.735A9.6 9.6 0 0 0 21.3 12 9.6 9.6 0 0 0 3.706 6.689L2 4.956z",
    fill: "#4A90E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#28C09E",
    fillRule: "nonzero",
    d: "M0 13.275v-2.548h12.486l-2.79-2.924L11.415 6l5.727 6.002L11.416 18l-1.72-1.803 2.79-2.922z"
  })));
};

HandoffColor.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Help = function Help(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.84.001C5.213.09-.087 5.534 0 12.161.09 18.787 5.534 24.088 12.161 24c6.625-.089 11.926-5.534 11.838-12.16C23.91 5.214 18.466-.087 11.839 0zm-.036 19.304l-.066-.002c-1.02-.03-1.74-.782-1.711-1.787.028-.988.765-1.706 1.752-1.706l.06.001c1.048.032 1.76.776 1.73 1.81-.029.991-.754 1.684-1.765 1.684zm4.293-8.52c-.24.34-.768.764-1.433 1.282l-.732.506c-.402.312-.645.606-.736.896-.072.227-.107.288-.113.75l-.001.119h-2.796l.008-.237c.034-.973.058-1.545.461-2.017.633-.743 2.027-1.641 2.087-1.68.2-.15.368-.321.494-.504.293-.405.423-.723.423-1.036a2.02 2.02 0 0 0-.384-1.194c-.245-.345-.71-.52-1.383-.52-.668 0-1.125.212-1.398.646a2.596 2.596 0 0 0-.424 1.396v.12H7.287l.006-.125c.074-1.766.704-3.037 1.872-3.78.734-.472 1.647-.711 2.713-.711 1.394 0 2.571.339 3.498 1.007.94.677 1.416 1.691 1.416 3.015 0 .74-.234 1.435-.695 2.067z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Help.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Home = function Home(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.597 10.942a1.34 1.34 0 0 1 0 1.915 1.383 1.383 0 0 1-.973.397c-.352 0-.703-.132-.973-.397l-9.095-8.954a.821.821 0 0 0-1.113.001l-9.094 8.953a1.39 1.39 0 0 1-1.946 0 1.34 1.34 0 0 1 0-1.915l9.094-8.953C10.833.672 13.161.67 14.5 1.987l2.709 2.666V3.225c0-.748.615-1.354 1.374-1.354.761 0 1.377.606 1.377 1.354v4.136l3.637 3.581zm-11.12-4.468l8 7.873a.659.659 0 0 1 .197.471v5.742c0 1.348-1.11 2.44-2.478 2.44h-3.96v-6.038H9.763V23h-3.96c-1.37 0-2.48-1.092-2.48-2.44v-5.742c0-.177.072-.347.199-.47l8-7.874a.683.683 0 0 1 .955 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Home.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ImportMerge = function ImportMerge(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11 11.832V5c0-1.93-2.973-3-6-3V0c2.83 0 5.578.677 7 2.286C13.422.676 16.17 0 19 0v2c-3.027 0-6 1.07-6 3v6.832l2.235-2.275a.854.854 0 0 1 .61-.26c.22 0 .441.089.61.26a.896.896 0 0 1 0 1.246l-3.845 3.913a.858.858 0 0 1-1.224 0L7.54 10.803a.885.885 0 0 1 .005-1.241.858.858 0 0 1 1.224 0l2.23 2.27zm-8.211 2.382h2.078c.475 0 .864.395.864.88 0 .483-.389.879-.864.879H2.79a1.07 1.07 0 0 0-1.061 1.08v4.108c0 .596.475 1.08 1.06 1.08h18.423a1.07 1.07 0 0 0 1.061-1.08v-4.109a1.07 1.07 0 0 0-1.06-1.08h-2.08a.874.874 0 0 1-.863-.879c0-.484.389-.88.864-.88h2.078c1.541 0 2.789 1.271 2.789 2.84v4.108C24 22.725 22.752 24 21.211 24H2.79C1.248 24 0 22.725 0 21.161v-4.109c0-1.568 1.248-2.838 2.789-2.838z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ImportMerge.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ImportProject = function ImportProject(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.499 8.448V.326c0-.18.137-.326.306-.326.168 0 .305.146.305.326v8.122L14.687 5.7a.307.307 0 0 1 .453 0 .358.358 0 0 1 0 .483l-3.054 3.258a.306.306 0 0 1-.281.198.306.306 0 0 1-.28-.195l-3.056-3.26a.358.358 0 0 1 0-.483.312.312 0 0 1 .227-.1c.082 0 .164.033.227.099L11.5 8.448zm10.043 7.917c.279.25.458.63.458 1.055v5.223c0 .748-.553 1.357-1.233 1.357H3.233C2.553 24 2 23.391 2 22.643V17.42c0-.426.179-.806.458-1.055l2.64-5.017c.292-.321.68-.498 1.093-.498h4.243c.163 0 .294.145.294.323 0 .178-.131.323-.294.323H6.191a.91.91 0 0 0-.678.31l-1.95 4.257H7.72c.577 0 1.082.441 1.2 1.049.307 1.588 1.603 2.741 3.081 2.741s2.774-1.153 3.082-2.741c.117-.608.622-1.05 1.2-1.05h4.155l-1.95-4.257a.91.91 0 0 0-.678-.309h-4.243c-.163 0-.294-.145-.294-.323 0-.178.131-.323.294-.323h4.243c.413 0 .8.177 1.093.498l2.64 5.017zm-.13 6.278V17.42a.752.752 0 0 0-.137-.437.315.315 0 0 1-.024-.024l-.098-.108a.604.604 0 0 0-.386-.142h-4.486a.65.65 0 0 0-.625.537 4.211 4.211 0 0 1-1.29 2.324c-.664.599-1.505.929-2.366.929-.861 0-1.702-.33-2.367-.93a4.21 4.21 0 0 1-1.289-2.323.65.65 0 0 0-.625-.537H3.233a.605.605 0 0 0-.386.142l-.098.108a.302.302 0 0 1-.024.024.753.753 0 0 0-.138.437v5.223c0 .392.29.711.646.711h17.534c.356 0 .646-.319.646-.71z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ImportProject.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ImportProjectSmall = function ImportProjectSmall(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.571 18.003v4.224c0 .97-.72 1.773-1.628 1.773H3.629C2.72 24 2 23.196 2 22.227v-4.224c0-.504.196-.977.532-1.31l2.575-4.955.06-.087a1.85 1.85 0 0 1 1.383-.634h4.19c.396 0 .701.34.701.74 0 .4-.305.739-.701.739H6.55a.475.475 0 0 0-.326.133l-1.628 3.6h3.462c.773 0 1.436.588 1.589 1.387.267 1.398 1.383 2.404 2.639 2.404 1.256 0 2.371-1.006 2.639-2.404.152-.799.816-1.386 1.588-1.386h3.462l-1.628-3.601a.475.475 0 0 0-.326-.133h-4.19c-.396 0-.7-.34-.7-.74 0-.4.304-.74.7-.74h4.19a1.85 1.85 0 0 1 1.384.635l.06.087 2.574 4.954c.337.334.532.807.532 1.31zm-19.343-.86l-.09.117a1 1 0 0 0-.315.743v4.224c0 .526.371.94.806.94h17.314c.434 0 .806-.414.806-.94v-4.224a1 1 0 0 0-.315-.743l-.09-.117-.387-.744.3.664h-4.744c-.368 0-.7.295-.78.711-.34 1.779-1.784 3.079-3.447 3.079-1.664 0-3.107-1.3-3.447-3.079-.08-.416-.413-.711-.78-.711H3.313l.3-.664-.386.744zm.175.86v4.224c0 .17.11.294.226.294h17.314c.115 0 .226-.124.226-.294v-4.224a.343.343 0 0 0-.045-.171 7.855 7.855 0 0 1-.062-.076.185.185 0 0 0-.12-.047h-4.429c-.097 0-.19.081-.213.2-.19.995-.687 1.901-1.402 2.554a3.88 3.88 0 0 1-2.612 1.036 3.88 3.88 0 0 1-2.613-1.036c-.714-.653-1.211-1.56-1.401-2.554-.023-.119-.116-.2-.214-.2h-4.43c-.04 0-.08.015-.076.006l-.096.107a.328.328 0 0 0-.053.18zm18.589 4.224c0 .613-.461 1.127-1.05 1.127H3.63c-.588 0-1.05-.514-1.05-1.127v-4.224c0-.247.076-.484.212-.678l.064-.071c-.002 0 .042-.046.13-.141a1 1 0 0 1 .644-.237h4.43c.498 0 .925.37 1.02.875.157.819.565 1.563 1.145 2.092a3.064 3.064 0 0 0 2.062.823c.747 0 1.48-.291 2.061-.823.58-.53.988-1.273 1.145-2.092.096-.504.522-.875 1.021-.875h4.43c.236 0 .46.085.685.278l.097.108.055.063c.137.194.212.431.212.678v4.224zM12.092 0c-.4 0-.713.377-.713.827v8.151c0 .45.314.828.714.828.4 0 .713-.377.713-.828V.828c0-.452-.313-.828-.713-.828zm0 8.954l-2.546-2.75a.708.708 0 0 0-1.047 0 .782.782 0 0 0 0 1.053l3.07 3.316a.714.714 0 0 0 .524.233.717.717 0 0 0 .525-.232l3.069-3.316a.783.783 0 0 0-.002-1.055.716.716 0 0 0-.523-.23.716.716 0 0 0-.524.23l-2.545 2.75z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ImportProjectSmall.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ImportResources = function ImportResources(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.789 14.214h2.078c.475 0 .864.395.864.88 0 .483-.389.879-.864.879H2.79a1.07 1.07 0 0 0-1.061 1.08v4.108c0 .596.475 1.08 1.06 1.08h18.423a1.07 1.07 0 0 0 1.061-1.08v-4.109a1.07 1.07 0 0 0-1.06-1.08h-2.08a.874.874 0 0 1-.863-.879c0-.484.389-.88.864-.88h2.078c1.541 0 2.789 1.271 2.789 2.84v4.108C24 22.725 22.752 24 21.211 24H2.79C1.248 24 0 22.725 0 21.161v-4.109c0-1.568 1.248-2.838 2.789-2.838zm13.665-3.411l-3.844 3.913a.858.858 0 0 1-1.224 0L7.54 10.803a.885.885 0 0 1 .005-1.241.858.858 0 0 1 1.224 0l2.366 2.408V.88c0-.484.389-.88.864-.88s.864.396.864.88v11.09l2.371-2.413a.854.854 0 0 1 .61-.26c.22 0 .441.089.61.26a.896.896 0 0 1 0 1.246z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ImportResources.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var InputFields = function InputFields(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.464 0L1 5.464V24h10.315v-1.846H2.846V6.77H7.77V1.846h10.461v7.392h1.846V0H6.464zm-.541 3.152v1.77H4.151l1.772-1.77zM22.347 16.06h-7.044l2.515-2.538a.659.659 0 0 0 .191-.468.656.656 0 0 0-.191-.467l-.391-.395a.65.65 0 0 0-.925 0l-4.311 4.34A.655.655 0 0 0 12 17a.656.656 0 0 0 .191.467l4.311 4.34a.646.646 0 0 0 .463.193.646.646 0 0 0 .462-.192l.391-.394a.65.65 0 0 0 0-.921l-2.543-2.553h7.062a.68.68 0 0 0 .663-.675v-.558a.666.666 0 0 0-.672-.651l.019.004z",
    fill: "currentColor"
  })));
};

InputFields.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Insurance = function Insurance(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.96 11.719a.467.467 0 0 0 .612-.045l2.291-2.297a.469.469 0 0 0-.052-.707L21.47 6.928V2.25A.469.469 0 0 0 21 1.781h-3a.469.469 0 0 0-.469.469v1.749L12.28.093a.469.469 0 0 0-.56 0L7.616 3.146a.469.469 0 1 0 .56.752L12 1.053l10.817 8.046-1.623 1.625-8.914-6.63a.469.469 0 0 0-.56 0l-8.914 6.63L1.184 9.1l4.203-3.127a.469.469 0 1 0-.56-.752L.19 8.67a.469.469 0 0 0-.052.707l2.292 2.297a.469.469 0 0 0 .611.045l.335-.25v3.719H.938a.939.939 0 0 0-.938.937v6.938c0 .516.42.937.938.937h3.187a.938.938 0 0 0 .925-.795l2.18.768c.05.018.103.027.156.027h6.694c.774 0 1.526-.275 2.117-.776l5.07-4.29c.402-.34.64-.817.67-1.343a1.884 1.884 0 0 0-.51-1.41 1.893 1.893 0 0 0-.802-.508v-4.204l.335.25zM20.53 6.23L18.47 4.696V2.72h2.062V6.23zM4.125 23.062H.938v-6.937h1.125v3.469a.469.469 0 0 0 .937 0v-3.469h1.125v6.937zm16.617-6.24a.955.955 0 0 1 .26.715.955.955 0 0 1-.34.68l-5.07 4.292a2.343 2.343 0 0 1-1.512.553H7.466l-2.403-.846v-5.247H8.5c.464 0 .912.136 1.298.393l3.136 2.09c.14.094.233.236.263.402a.612.612 0 0 1-.866.659L9.65 19.23a.469.469 0 1 0-.405.846l2.683 1.282a1.55 1.55 0 0 0 1.527-2.686l-3.136-2.091a3.268 3.268 0 0 0-1.818-.55H5.058a.94.94 0 0 0-.745-.826v-4.434L12 5.054l7.688 5.718v4.841a1.893 1.893 0 0 0-.872.413l-3.732 3.137a.469.469 0 1 0 .603.717l3.732-3.136a.964.964 0 0 1 1.323.078zM6.874 4.197a.472.472 0 0 1 0 .663.473.473 0 0 1-.663 0 .472.472 0 0 1 0-.663.472.472 0 0 1 .663 0zm-5.16 14.48a.472.472 0 0 1 0 .662.472.472 0 0 1-.663 0 .47.47 0 0 1 .332-.8c.123 0 .244.05.331.137zm12.069-8.761l-2.5 2.278-1.066-.972a.554.554 0 0 0-.732 0 .443.443 0 0 0 0 .667l1.433 1.306a.543.543 0 0 0 .366.138.543.543 0 0 0 .366-.138l2.865-2.611a.443.443 0 0 0 0-.668.554.554 0 0 0-.732 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Insurance.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Intents = function Intents(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.8 24v-4.8H2.4A2.402 2.402 0 0 1 0 16.8V2.4C0 1.075 1.076 0 2.4 0h19.2C22.924 0 24 1.075 24 2.4v14.4c0 1.324-1.076 2.4-2.4 2.4H11.2L4.8 24zM2.2 2.225v14.7h4.9v2.45l3.267-2.45H21.8v-14.7H2.2zM6 11.1a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm6 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Intents.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Keyboard = function Keyboard(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3 10.6c-.773 0-1.4.685-1.4 1.53v8.74c0 .845.627 1.53 1.4 1.53h18c.773 0 1.4-.685 1.4-1.53v-8.74c0-.845-.627-1.53-1.4-1.53H3zM10.959 9c.238-2.28 1.225-3.582 2.96-3.904 2.574-.138 2.966-3.208 2.574-4.096h1.706c.238 3.371-1.123 5.276-4.083 5.714-.73.108-1.206.87-1.432 2.286H21c1.657 0 3 1.44 3 3.214v8.572C24 22.56 22.657 24 21 24H3c-1.657 0-3-1.44-3-3.214v-8.572C0 10.44 1.343 9 3 9h7.959zM8.5 19.5a.5.5 0 0 0-.5.5v.6a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V20a.5.5 0 0 0-.5-.5h-7zM6 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Keyboard.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LastPage = function LastPage(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.91 12.708c-.052.093-.114.18-.185.259L3.1 22.592c-.231.258-.54.408-.867.408C1.558 23 1 22.377 1 21.625V2.375C1 1.623 1.558 1 2.232 1c.328 0 .636.15.867.408l8.626 9.625c.07.08.133.166.184.26V2.374c0-.752.558-1.375 1.232-1.375.328 0 .636.15.867.408l8.626 9.625c.231.258.366.602.366.967s-.135.709-.366.967l-8.626 9.625c-.231.258-.54.408-.867.408-.674 0-1.232-.623-1.232-1.375v-8.917z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LastPage.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Link = function Link(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M24 5.929c0 1.801-.904 3.644-2.591 5.333-.036.036-.036.036-.074.069l-.104.104c-.034.038-.034.038-.069.074-1.557 1.554-3.295 2.44-5.03 2.544-.04.002-.04.002-.083.002a1.38 1.38 0 0 1-.082-2.757c1.026-.062 2.144-.65 3.199-1.694l.091-.106c.044-.05.09-.097.14-.14l.08-.068C20.64 8.12 21.24 6.952 21.24 5.93c0-.745-.332-1.46-1.01-2.137a4.448 4.448 0 0 0-.435-.382l-.106-.081c-.544-.393-1.071-.569-1.618-.569-1.022 0-2.189.6-3.336 1.736l-.092.106a1.39 1.39 0 0 1-.141.141l-.08.067C13.26 5.982 12.66 7.148 12.66 8.17c0 .35.082.708.212 1.006l1.707-1.708a1.38 1.38 0 1 1 1.952 1.952l-3.368 3.368c.146.246.278.491.386.707.369.773.551 1.55.551 2.333 0 1.8-.904 3.644-2.591 5.333l-.074.07-.104.103c-.033.037-.033.037-.069.074C9.572 23.096 7.73 24 5.93 24c-1.168 0-2.27-.375-3.266-1.108a.693.693 0 0 1-.095-.079 7.42 7.42 0 0 1-.748-.652C.62 20.961 0 19.58 0 18.071c0-1.8.904-3.644 2.591-5.333.036-.035.036-.035.074-.069l.104-.104.069-.074c1.611-1.607 3.288-2.486 4.984-2.588a1.38 1.38 0 1 1 .166 2.755c-.96.057-2.065.66-3.154 1.739l-.091.105c-.044.05-.09.097-.14.14l-.08.068C3.36 15.88 2.76 17.048 2.76 18.07c0 .745.332 1.46 1.01 2.137.142.141.288.27.435.382l.106.081c.544.393 1.071.57 1.618.57 1.022 0 2.189-.6 3.336-1.737l.092-.106c.043-.05.09-.097.141-.141l.08-.067c1.162-1.171 1.762-2.338 1.762-3.361 0-.33-.073-.668-.216-1L9.42 16.53a1.377 1.377 0 0 1-1.952 0 1.38 1.38 0 0 1 0-1.952l3.415-3.415a17.514 17.514 0 0 1-.356-.527 1.382 1.382 0 0 1-.088-.157A5.332 5.332 0 0 1 9.9 8.17c0-1.8.904-3.644 2.591-5.333l.074-.07.104-.103c.033-.037.033-.037.069-.074C14.428.904 16.27 0 18.07 0c1.168 0 2.27.375 3.266 1.108a.693.693 0 0 1 .095.079c.285.218.522.427.748.652C23.38 3.04 24 4.421 24 5.93z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Link.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkHorizontal = function LinkHorizontal(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.156 10.923c.721 0 1.349-.006 1.976.002.73.009 1.176.425 1.172 1.079-.005.649-.453 1.054-1.193 1.058-1.144.006-2.29.008-3.433-.001-.308-.003-.498.049-.6.392-.644 2.127-2.29 3.065-4.392 3.406-1.417.23-2.84.18-4.207-.252C.975 15.817.02 14.345 0 11.933c-.02-2.46 1.523-4.19 3.968-4.69 1.805-.368 3.602-.362 5.337.323.484.191.941.48 1.36.79.548.407.605 1.036.208 1.523-.381.467-.991.563-1.526.197-1.692-1.16-3.542-1.029-5.38-.548-1.188.31-1.71 1.172-1.715 2.397-.005 1.338.492 2.16 1.694 2.538 1.458.459 2.95.446 4.413-.01.772-.24 1.188-.674 1.434-1.39-.71 0-1.386.012-2.061-.005-.528-.013-.955-.39-1.028-.862-.084-.54.18-1.032.684-1.202.198-.066.424-.068.638-.068 1.26-.006 2.52-.003 3.81-.003.274-1.322.957-2.337 2.128-3 1.47-.833 3.088-1.054 4.733-.848.977.122 1.987.354 2.868.767 1.826.856 2.537 2.596 2.423 4.558-.062 1.079-.431 2.06-1.125 2.842-.453.511-1.141.892-1.8 1.148-2.09.813-4.227.81-6.327.01-.537-.204-1.038-.55-1.488-.911-.486-.39-.49-.98-.113-1.443.34-.419 1.03-.555 1.487-.207 1.499 1.145 3.203 1.05 4.909.765 1.508-.253 2.217-1.16 2.217-2.604 0-1.45-.708-2.331-2.204-2.623-1.266-.246-2.548-.27-3.795.12-.688.215-1.271.592-1.593 1.426",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LinkHorizontal.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ListView = function ListView(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 19.5h24v3H0v-3zm0-9h24v3H0v-3zm0-9h24v3H0v-3z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ListView.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LockFilled = function LockFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.513 11.386a1.622 1.622 0 0 0-1.18-.477h-.555V7.636c0-2.09-.764-3.886-2.292-5.386C15.958.75 14.13 0 12 0S8.04.75 6.514 2.25c-1.528 1.5-2.292 3.295-2.292 5.386v3.273h-.555c-.463 0-.857.16-1.18.477A1.563 1.563 0 0 0 2 12.546v9.818c0 .454.162.84.486 1.159.324.318.718.477 1.18.477h16.667c.463 0 .857-.159 1.18-.477.325-.318.487-.705.487-1.16v-9.818c0-.454-.162-.84-.487-1.159zm-5.069-.477H7.555V7.636c0-1.204.435-2.233 1.303-3.085C9.726 3.7 10.773 3.273 12 3.273c1.227 0 2.274.426 3.142 1.278.868.852 1.302 1.88 1.302 3.085v3.273z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LockFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LockOutline = function LockOutline(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22 12.098v8.394C22 22.427 20.403 24 18.44 24H5.56C3.598 24 2 22.427 2 20.492V12.1c0-1.595 1.094-2.967 2.616-3.38V6.631C4.616 2.965 7.936 0 12 0c4.063 0 7.384 2.965 7.384 6.631V8.72C20.906 9.132 22 10.504 22 12.1zm-4.306-5.467c0-2.727-2.545-4.965-5.694-4.965S6.306 3.904 6.306 6.63v1.96h11.388V6.63zm2.615 13.86v-8.393c0-1.015-.84-1.842-1.87-1.842H5.561c-1.03 0-1.87.827-1.87 1.842v8.394c0 1.015.84 1.842 1.87 1.842h12.878c1.03 0 1.87-.827 1.87-1.842zM12 12.027c1.188 0 2.153.951 2.153 2.122v2.577c0 1.17-.965 2.12-2.153 2.12-1.188 0-2.153-.95-2.153-2.12v-2.577c0-1.17.965-2.122 2.153-2.122zm.462 4.699v-2.577a.46.46 0 0 0-.462-.456.46.46 0 0 0-.462.456v2.577a.46.46 0 0 0 .462.455.46.46 0 0 0 .462-.455z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LockOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LogEvent = function LogEvent(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M16.276 11.313c0 .517-.42.937-.937.937H5.682a.937.937 0 1 1 0-1.875h9.657c.517 0 .937.42.937.938zM5.682 15.124h5.865a.937.937 0 1 1 0 1.875H5.682a.937.937 0 1 1 0-1.875zm2.203 7a.937.937 0 1 1 0 1.875H4.75A3.754 3.754 0 0 1 1 20.25V3.75A3.754 3.754 0 0 1 4.75 0h11.526a3.754 3.754 0 0 1 3.75 3.75v5.766a.937.937 0 1 1-1.875 0V3.75a1.877 1.877 0 0 0-1.875-1.875H4.75A1.877 1.877 0 0 0 2.875 3.75v16.5c0 1.034.841 1.875 1.875 1.875h3.135zm14.635-8.551a2.816 2.816 0 0 1 0 3.977l-5.136 5.127a.937.937 0 0 1-.412.24l-3.784 1.048a.936.936 0 0 1-1.148-1.176l1.121-3.69a.938.938 0 0 1 .235-.391l5.147-5.136a2.815 2.815 0 0 1 3.977 0zm-6.286 7.603l3.452-3.446-1.326-1.326-3.473 3.465-.557 1.834 1.904-.527zm4.96-4.952a.938.938 0 0 0-1.326-1.325l-.18.18 1.325 1.326.182-.181zm-5.855-10.6a.937.937 0 1 1 0 1.875H5.682a.937.937 0 1 1 0-1.875h9.657z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LogEvent.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LogFiles = function LogFiles(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.003 13.048v-5.1c0-1.036-.864-1.875-1.927-1.875H1.926C.863 6.073 0 6.912 0 7.947v5.101c0 1.036.862 1.875 1.927 1.875h16.147c1.065 0 1.93-.84 1.93-1.875zM2.017 7.588h1.645v4.115h2.325v1.359h-3.97V7.588zm7.244-.102c.57 0 1.085.123 1.546.367.461.245.822.582 1.083 1.012.261.429.392.912.392 1.448a2.754 2.754 0 0 1-1.475 2.487 3.22 3.22 0 0 1-1.546.371 3.213 3.213 0 0 1-1.55-.37 2.761 2.761 0 0 1-1.08-1.024 2.79 2.79 0 0 1-.391-1.464c0-.536.13-1.019.391-1.448.261-.43.621-.767 1.08-1.012a3.241 3.241 0 0 1 1.55-.367zm.023 1.351c-.242 0-.467.065-.676.195-.208.13-.374.309-.498.535a1.544 1.544 0 0 0-.186.754c0 .276.062.528.186.757.124.23.29.41.498.543.209.133.434.2.676.2.238 0 .458-.067.66-.2.204-.133.363-.312.48-.539.115-.226.173-.48.173-.761 0-.276-.058-.527-.174-.754a1.365 1.365 0 0 0-.474-.535c-.2-.13-.422-.195-.665-.195zm7.236 1.39h1.416v2.226c-.3.208-.672.38-1.115.515a4.306 4.306 0 0 1-1.257.203 3.135 3.135 0 0 1-1.527-.37 2.756 2.756 0 0 1-1.067-1.02 2.79 2.79 0 0 1-.388-1.46 2.713 2.713 0 0 1 1.507-2.468c.472-.244 1-.367 1.585-.367.422 0 .844.076 1.266.227.421.15.78.356 1.075.617l-.933 1.109A2.208 2.208 0 0 0 16.414 9a1.894 1.894 0 0 0-.748-.164c-.263 0-.502.065-.715.195-.214.13-.381.309-.502.535a1.57 1.57 0 0 0-.182.754c0 .281.062.536.185.765a1.368 1.368 0 0 0 1.23.734c.237 0 .517-.075.838-.226v-1.367zM23.442 0c.308 0 .56.25.558.56v18.724c0 .136-.05.27-.14.371l-3.715 4.159a.564.564 0 0 1-.417.186H6.832a.559.559 0 0 1-.56-.558v-6.14h1.679v5.219h10.347l-.012-4.172a.62.62 0 0 1 .62-.622l3.333.003V1.401H7.951v2.243H6.273V.56A.56.56 0 0 1 6.832 0h16.61z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

LogFiles.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Logout = function Logout(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.51 24C5.162 24 0 18.994 0 12.842c0-4.3 2.478-8.145 6.47-10.035a1 1 0 0 1 .857 1.807C4.041 6.17 2.003 9.32 2.003 12.842c0 5.05 4.266 9.16 9.507 9.16s9.507-4.11 9.507-9.16c0-3.546-2.155-6.803-5.495-8.302a1.001 1.001 0 0 1-.505-1.322.995.995 0 0 1 1.323-.5c4.06 1.818 6.68 5.795 6.68 10.124C23.02 18.994 17.858 24 11.51 24zm-.999-11.437V1a1 1 0 0 1 1.998 0v11.564c0 .554-.445 1-.999 1-.553 0-.999-.446-.999-1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Logout.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MachineLearning = function MachineLearning(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.48 23.477l1.816-1.334c.554.092 1.123.14 1.704.14 5.678 0 10.282-4.603 10.282-10.281 0-3.035-1.315-5.762-3.406-7.644l.876-1.517A11.974 11.974 0 0 1 24 12.001c0 6.628-5.373 12-12 12-1.225 0-2.407-.183-3.52-.524zm-4.13-2.23A11.975 11.975 0 0 1 0 12.002c0-6.628 5.373-12 12-12 1.156 0 2.274.163 3.332.468l-1.847 1.357C13 1.757 12.505 1.72 12 1.72c-5.678 0-10.282 4.603-10.282 10.282 0 3.082 1.357 5.848 3.505 7.732l-.873 1.513zm15.625-8.134a.865.865 0 0 1-.352.739L6.03 23.837a.847.847 0 0 1-1.068-.05.855.855 0 0 1-.162-1.063l4.719-8.174-5.137-2.965a.845.845 0 0 1-.42-.694.865.865 0 0 1 .352-.738L17.907.167a.841.841 0 0 1 1.069.05.855.855 0 0 1 .162 1.063l-4.72 8.174 5.138 2.966a.84.84 0 0 1 .42.693z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

MachineLearning.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Merge = function Merge(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0l6.314 6.385h-4.91v9.102L4.984 24 3 21.992l7.597-7.683V6.385h-4.91L12 0zm4.209 17.147L21 21.992 19.015 24l-4.791-4.845 1.985-2.008z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Merge.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MethodsFlow = function MethodsFlow(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14 15H8v-2H3c-.551 0-1 .449-1 1v4c0 .552.449 1 1 1h9v-2l6 3-6 3v-2H3c-1.654 0-3-1.346-3-3v-4c0-1.654 1.346-3 3-3h5V9h6v6zm-4-4v2h2v-2h-2zm14 12h-6v-6h6v6zm-4-4v2h2v-2h-2zm0-6v2l-6-3 6-3v2h1c.552 0 1-.449 1-1V6c0-.551-.448-1-1-1H6v2H0V1h6v2h15c1.654 0 3 1.346 3 3v4c0 1.654-1.346 3-3 3h-1zM4 5V3H2v2h2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

MethodsFlow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Minus = function Minus(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24 20v2.88H0V20z"
  })));
};

Minus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MLTraining = function MLTraining(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.341 12.084l-.006-3.75c.017-.07.034-.142.034-.213 0-.373-.219-.711-.547-.836L12.113 3.053a.816.816 0 0 0-.58 0L.555 7.276A.893.893 0 0 0 0 8.121c0 .373.227.711.564.836l2.792 1.03v7.652c0 .392.244.738.598.854l7.621 2.471a.772.772 0 0 0 .496-.008l7.42-2.472a.882.882 0 0 0 .589-.845V9.988l1.573-.596.006 2.692a1.613 1.613 0 0 0-.665 1.325c0 .88.673 1.591 1.506 1.591s1.506-.711 1.506-1.591a1.591 1.591 0 0 0-.665-1.325zm-4.944 4.897l-6.586 2.188-6.78-2.196v-6.345l6.485 2.543a.825.825 0 0 0 .295.053.74.74 0 0 0 .302-.062l6.284-2.534v6.353zm.564-8.469l-7.142 2.88-7.327-2.871-1.144-.427 8.471-3.263 8.26 3.263-1.118.418z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

MLTraining.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Modified = function Modified(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M10.304 2a.998.998 0 0 1 1.002 1.003.998.998 0 0 1-1.002 1.002H3.676c-.919 0-1.67.752-1.67 1.67v14.65c0 .918.751 1.67 1.67 1.67h14.648c.919 0 1.67-.752 1.67-1.67v-6.629a.998.998 0 0 1 1.003-1.002A.998.998 0 0 1 22 13.696v6.628A3.672 3.672 0 0 1 18.324 24H3.676A3.672 3.672 0 0 1 0 20.324V5.676A3.672 3.672 0 0 1 3.676 2zM20.96.27l2.769 2.77c.36.36.36.945 0 1.305L20.975 7.1a.938.938 0 0 1-.014.015l-.016.012-9.216 9.217a.916.916 0 0 1-.651.272h-2.77a.923.923 0 0 1-.923-.923v-2.77a.93.93 0 0 1 .27-.653l12-12.001a.924.924 0 0 1 1.306 0zm-3.423 4.729l-8.307 8.307v1.465h1.464l8.307-8.309-1.464-1.463zm2.77-2.77l-1.465 1.464 1.464 1.464 1.466-1.464-1.464-1.464z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Modified.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MoveLineDown = function MoveLineDown(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.188 0h2.624v14.583l3.01-2.656 1.856 1.638-6.178 5.454-6.178-5.454 1.856-1.638 3.01 2.656V0zM0 21.6h24V24H0v-2.4z",
    fill: "currentColor"
  })));
};

MoveLineDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MoveLineUp = function MoveLineUp(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.813 24h-2.626V8.897l-3.01 2.751-1.855-1.696L12.5 4.303l6.178 5.649-1.856 1.696-3.01-2.751V24zM0 0h24v2.4H0V0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

MoveLineUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Multivalues = function Multivalues(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.5 1.5a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15zm0-1.5h15A4.5 4.5 0 0 1 24 4.5v15a4.5 4.5 0 0 1-4.5 4.5h-15A4.5 4.5 0 0 1 0 19.5v-15A4.5 4.5 0 0 1 4.5 0zm.75 6v12h2.442V9.891l3.44 6.892h1.754l3.422-6.892V18h2.442V6h-3.01l-3.714 7.371L8.276 6H5.25z",
    fill: "currentColor"
  })));
};

Multivalues.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NextPage = function NextPage(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.604 11.033L8.271 1.408A1.306 1.306 0 0 0 7.333 1C6.604 1 6 1.623 6 2.375v19.25C6 22.377 6.604 23 7.333 23c.354 0 .688-.15.938-.408l9.333-9.625c.25-.258.396-.602.396-.967s-.146-.709-.396-.967z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

NextPage.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NiceReactionFilled = function NiceReactionFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm2.954 10.708c.916 0 1.661-.746 1.661-1.662 0-.916-.745-1.661-1.661-1.661s-1.662.745-1.662 1.661.746 1.662 1.662 1.662zm-5.908 0c.916 0 1.662-.746 1.662-1.662 0-.916-.746-1.661-1.662-1.661-.916 0-1.661.745-1.661 1.661s.745 1.662 1.661 1.662zm8.25 3.73c-.868 2.022-3.045 3.433-5.295 3.433-2.384 0-4.46-1.346-5.294-3.428l-.072-.179-1.669.743.07.167c1.2 2.849 3.934 4.69 6.965 4.69 3.137 0 5.805-1.797 6.965-4.693l.065-.166-1.662-.738-.074.171z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

NiceReactionFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NiceReactionOutline = function NiceReactionOutline(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zm0 1.5C6.15 1.5 1.5 6.15 1.5 12S6.15 22.5 12 22.5 22.5 17.85 22.5 12 17.85 1.5 12 1.5zm0 18.3c-3 0-5.7-1.8-6.9-4.65l1.35-.6c.9 2.25 3.15 3.6 5.55 3.6s4.65-1.5 5.55-3.6l1.35.6c-1.2 3-3.9 4.65-6.9 4.65zM10.5 9a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 10.5 9zm6 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 16.5 9z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

NiceReactionOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Nlu = function Nlu(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M15.315 12.695l4.58 2.394.105.175v5.703l-.106.175L14.431 24h-.18l-5.073-2.652-5.072-2.65L4 18.523V3.028l.106-.175L9.57 0h.18l5.46 2.853.105.175v9.667zm1.724 2.976l-2.698-1.413-2.7 1.41 2.7 1.41 2.698-1.407zm-3.673-2.979v-7.71l-2.732 1.429a7495.63 7495.63 0 0 0 .002 7.71l2.73-1.429zM9.656 2.03L6.958 3.437l2.698 1.41 2.698-1.41L9.656 2.03zm3.707 19.435v-2.818L8.68 16l.002-9.587-2.73-1.428v12.602l4.378 2.285 3.033 1.592zm4.685-1.428v-2.819l-2.733 1.426v2.819l2.733-1.426z",
    fill: "currentColor"
  })));
};

Nlu.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NluExport = function NluExport(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.751 3.237l3.293 3.328h-2.119c-.647 0-1.174-.503-1.174-1.12V3.236zm4.195 16.822v-1.792h1.315v1.792c0 1.622-1.371 2.941-3.056 2.941H3.055C1.372 23 0 21.68 0 20.059V3.941C0 2.319 1.37 1 3.056 1h9.033a.67.67 0 0 1 .472.201l5.508 5.564a.666.666 0 0 1 .192.448v5.602h-1.315V7.839h-3.02c-1.373 0-2.49-1.074-2.49-2.395v-3.17h-8.38c-.944 0-1.741.763-1.741 1.667v16.118c0 .904.797 1.668 1.74 1.668h12.15c.96 0 1.741-.749 1.741-1.668zM8.144 8.28l2.447 1.26v4.064l1.974 1.017v2.545l-2.448 1.263-4.421-2.277V9.54l2.448-1.26zm2.97 6.598l-.998-.514-.997.513.998.514.997-.513zm.5 1.774v-1.026l-1.023.526v1.026l1.023-.526zm-1.973.527v-1.026l-1.635-.842c-.243-.041-.285-.278-.308-.517-.03-.324-.03-.9-.03-1.946v-1.775l-1.022-.526v5.088l1.873.963-.001.002 1.123.58zm0-6.634l-1.022.527v3.058l1.023-.527v-3.058zM8.144 9.286l-.997.513.997.514.997-.514-.997-.513zm15.647 5.776a.634.634 0 0 1 0 .943l-3.281 2.91a.64.64 0 0 1-.894-.052.628.628 0 0 1 .052-.89l2.03-1.8H16.19a.632.632 0 0 1-.63-.629c0-.345.283-.628.63-.628h5.537l-2.06-1.822a.628.628 0 0 1-.053-.89.634.634 0 0 1 .894-.052l3.28 2.91z",
    fill: "currentColor"
  })));
};

NluExport.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NoAvailable = function NoAvailable(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12-.007 6.624-5.376 11.993-12 12-6.627 0-12-5.373-12-12S5.373 0 12 0zm7.79 5.53L5.526 19.793A10.088 10.088 0 0 0 12 22.131c5.595 0 10.131-4.536 10.131-10.13a10.098 10.098 0 0 0-2.121-6.197l-.22-.274zM12 1.869l-.279.004C6.255 2.02 1.869 6.498 1.869 12c0 2.279.755 4.44 2.115 6.197l.22.274L18.468 4.208a10.096 10.096 0 0 0-6.11-2.332L12 1.869z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

NoAvailable.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NotificationBell = function NotificationBell(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.124 18.995c-3.411-2.16-3.229-9.179-3.225-9.284 0-3.276-2.123-6.053-5.031-6.963V2.12C13.868.951 12.94 0 11.8 0c-1.14 0-2.067.951-2.067 2.12v.628c-2.909.911-5.031 3.693-5.03 6.999.064 1.962-.387 7.45-3.227 9.248a1.04 1.04 0 0 0-.438 1.156c.123.442.516.748.965.748h6.005C8.404 22.672 9.952 24 11.8 24c1.848 0 3.396-1.328 3.793-3.101h6.004c.449 0 .843-.306.965-.748a1.042 1.042 0 0 0-.438-1.156M10.9 18.841H4.467c2.395-3.467 2.249-8.882 2.24-9.13 0-2.88 2.285-5.223 5.094-5.223 2.808 0 5.093 2.343 5.093 5.187-.009.278-.156 5.699 2.24 9.166H10.9",
    fill: "currentColor"
  })));
};

NotificationBell.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NotificationError = function NotificationError(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm.013-8.652c-.7 0-1.287.604-1.287 1.326 0 .721.587 1.326 1.287 1.326.674 0 1.287-.605 1.256-1.294.031-.759-.55-1.358-1.256-1.358zm-.32-9.31c-.612.18-.993.753-.993 1.448.03.419.057.843.088 1.262l.262 4.759c.031.54.438.933.963.933.525 0 .937-.419.963-.965 0-.329 0-.631.03-.966.057-1.023.119-2.047.176-3.071.03-.663.087-1.326.118-1.99 0-.238-.03-.45-.118-.663a1.28 1.28 0 0 0-1.488-.748z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

NotificationError.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NotificationInfo = function NotificationInfo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0C5.373 0 0 5.37 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.63-5.372-12-12-12zm0 22.043C6.45 22.043 1.957 17.548 1.957 12c0-5.549 4.495-10.046 10.045-10.046 5.545 0 10.043 4.498 10.043 10.046 0 5.548-4.498 10.043-10.043 10.043zm1.488-11.483h-2.787v.005H9.664v1.56H10.7v5.573H9.6v1.492h1.101v.01h2.787v-.01h.912v-1.492h-.912V10.56zm-1.765-1.92c1.219 0 1.957-.859 1.957-1.922-.024-1.085-.74-1.918-1.908-1.918-1.167 0-1.932.832-1.932 1.918 0 1.063.74 1.922 1.883 1.922z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

NotificationInfo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NotificationVerify = function NotificationVerify(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.98 10.534a.97.97 0 0 1 .97.97v.977a11.4 11.4 0 0 1-3.366 8.112 11.4 11.4 0 0 1-8.11 3.356h-.006a11.4 11.4 0 0 1-8.112-3.365A11.4 11.4 0 0 1 0 12.468a11.4 11.4 0 0 1 3.366-8.112A11.4 11.4 0 0 1 11.475 1h.006c1.618 0 3.187.335 4.664.993a.97.97 0 0 1-.79 1.771 9.476 9.476 0 0 0-3.875-.825h-.005c-2.545 0-4.938.99-6.74 2.789a9.473 9.473 0 0 0-2.796 6.741c-.003 5.258 4.272 9.538 9.53 9.541h.006c2.545 0 4.938-.99 6.739-2.789a9.473 9.473 0 0 0 2.797-6.74v-.977a.97.97 0 0 1 .969-.97zm1.736-8.194a.97.97 0 0 1 0 1.372L12.16 15.267a.966.966 0 0 1-1.37 0l-3.152-3.151a.97.97 0 0 1 1.37-1.371l2.467 2.466 10.87-10.87a.97.97 0 0 1 1.371 0z",
    fill: "currentColor"
  })));
};

NotificationVerify.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var NotificationWarning = function NotificationWarning(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 16.46c-.671 0-1.234.564-1.234 1.237 0 .672.563 1.236 1.234 1.236.646 0 1.233-.564 1.203-1.207A1.206 1.206 0 0 0 12 16.46zm-.306-8.682c-.587.168-.952.702-.952 1.35.03.391.054.787.084 1.178.083 1.489.167 2.948.251 4.437.03.505.42.87.923.87.503 0 .898-.39.922-.9 0-.306 0-.588.03-.9.054-.955.113-1.91.168-2.864.03-.619.083-1.237.113-1.855 0-.223-.03-.421-.113-.619a1.236 1.236 0 0 0-1.426-.697zm11.722 13.065c-.78 1.35-2.166 2.157-3.71 2.157H4.274a4.22 4.22 0 0 1-3.686-2.122 4.267 4.267 0 0 1-.014-4.3l7.735-13.43A4.21 4.21 0 0 1 12.005 1c1.549 0 2.93.801 3.695 2.152l7.726 13.417a4.233 4.233 0 0 1-.01 4.274zm-1.677-.97c.424-.737.429-1.607.014-2.33l-7.73-13.426a2.299 2.299 0 0 0-2.018-1.178c-.849 0-1.599.436-2.018 1.173L2.25 17.538a2.347 2.347 0 0 0 .005 2.36 2.298 2.298 0 0 0 2.013 1.158H19.7a2.33 2.33 0 0 0 2.038-1.183z",
    fill: "currentColor"
  })));
};

NotificationWarning.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Numbers = function Numbers(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.885 15.38c.024.677-.349 1.312-.97 1.651a2.04 2.04 0 0 1-1.996-.03c-.61-.357-.96-1.002-.915-1.678.066-.978.933-1.735 1.97-1.72 1.036.016 1.877.797 1.911 1.777zm10.219-.071c-.015.492.178.97.538 1.326.359.357.854.563 1.375.573 1.07-.02 1.936-.83 1.968-1.842-.016-1.001-.87-1.81-1.928-1.828-1.05-.006-1.913.78-1.948 1.77h-.005zm0-6.68c0 1.01.86 1.832 1.928 1.842 1.077-.005 1.952-.824 1.968-1.842-.01-1.003-.867-1.815-1.928-1.828-.52-.009-1.02.18-1.39.526-.37.345-.576.816-.573 1.307l-.005-.005zm-5.102-1.828a1.968 1.968 0 0 0-1.395.523c-.37.347-.573.822-.563 1.315-.037.677.325 1.32.94 1.668a2.04 2.04 0 0 0 2 0c.616-.349.978-.99.941-1.668.01-.487-.19-.957-.551-1.303a1.965 1.965 0 0 0-1.372-.535zm0-6.722a1.968 1.968 0 0 0-1.395.523c-.37.347-.573.822-.563 1.314-.037.678.325 1.32.94 1.669a2.04 2.04 0 0 0 2 0c.616-.35.978-.99.941-1.669.01-.486-.19-.956-.551-1.302A1.965 1.965 0 0 0 12.002.08zm-7.03 6.722a1.968 1.968 0 0 0-1.394.523c-.37.347-.574.822-.564 1.315-.036.677.325 1.32.94 1.668a2.04 2.04 0 0 0 2 0c.616-.349.978-.99.941-1.668.01-.487-.189-.957-.551-1.303a1.965 1.965 0 0 0-1.372-.535zm0-6.722a1.968 1.968 0 0 0-1.394.523c-.37.347-.574.822-.564 1.314-.036.678.325 1.32.94 1.669a2.04 2.04 0 0 0 2 0c.616-.35.978-.99.941-1.669.01-.486-.189-.956-.551-1.302A1.965 1.965 0 0 0 4.972.08zm12.142 1.852c.029.988.872 1.781 1.918 1.804 1.051-.024 1.906-.811 1.958-1.804.036-.678-.325-1.32-.94-1.67a2.04 2.04 0 0 0-2 0c-.616.35-.978.992-.941 1.67h.005zm-5.112 11.588a1.973 1.973 0 0 0-1.374.516c-.366.34-.573.803-.574 1.288-.046.676.306 1.321.915 1.679a2.04 2.04 0 0 0 1.997.029c.62-.34.993-.974.97-1.651a1.757 1.757 0 0 0-.548-1.32 1.97 1.97 0 0 0-1.386-.541zm0 6.722a1.973 1.973 0 0 0-1.374.517c-.366.339-.573.803-.574 1.287-.046.677.306 1.322.915 1.679a2.04 2.04 0 0 0 1.997.03c.62-.34.993-.974.97-1.652a1.757 1.757 0 0 0-.548-1.32 1.97 1.97 0 0 0-1.386-.54z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Numbers.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Options = function Options(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.066 14.033a2.033 2.033 0 1 1 0-4.066 2.033 2.033 0 0 1 0 4.066zm7.97 0a2.033 2.033 0 1 1 0-4.066 2.033 2.033 0 0 1 0 4.066zm7.964 0a2.033 2.033 0 1 1 0-4.066 2.033 2.033 0 0 1 0 4.066z",
    id: "a"
  })), /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "rotate(90 12.033 12)",
    xlinkHref: "#a"
  })));
};

Options.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Ordering = function Ordering(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.654 6.91c.005-.253-.168-.437-.414-.44a.444.444 0 0 0-.45.42.442.442 0 0 0 .429.438c.252.008.43-.163.435-.417zm7.858-.436a.435.435 0 0 0-.428.438c.007.23.214.424.449.42a.413.413 0 0 0 .417-.439.413.413 0 0 0-.438-.419zM3.883 3.612c.39.092 6.643.08 6.98-.013C10.69 2.388 9.24.931 7.435.93c-1.698 0-3.29 1.186-3.553 2.682zm-.152 1.01v.935c.794.56 1.041 1.1.822 1.773a1.397 1.397 0 0 1-1.387.96 1.366 1.366 0 0 1-1.274-1.046c-.176-.676.086-1.196.872-1.683v-.933c-.123-.011-.206-.025-.29-.025-.486-.002-.973-.001-1.49-.001v16.556h9.606v.925c-.097.011-.205.036-.314.036-3.208.002-6.417.003-9.625 0-.509 0-.65-.15-.65-.684-.002-3.225 0-6.45 0-9.676V4.63v-.259c.004-.58.123-.697.718-.7.532-.003 1.065-.001 1.597-.001h.488C3.581 1.235 5.176-.171 7.776.017c2.19.158 3.526 1.505 4.148 3.626.11.009.235.026.36.027.619.002 1.238-.004 1.856.002.446.005.622.155.624.583.008 1.599.002 3.197-.001 4.795 0 .04-.023.08-.044.148h-.894V4.624h-1.791v.946c.77.52 1.03 1.09.807 1.765-.19.577-.739.966-1.347.955a1.375 1.375 0 0 1-1.303-1.01c-.195-.69.067-1.224.84-1.705v-.952h-7.3zm9.387 7.406h9.975c.1 0 .202-.003.302 0 .493.02.667.236.586.729l-.855 5.148c-.083.493-.214.606-.714.606H14.138l.136.89h8.317v.917c-.115.01-.238.03-.36.03-2.705.002-5.41.003-8.115.001-.581 0-.665-.08-.755-.646-.403-2.57-.808-5.141-1.215-7.711-.02-.125-.06-.246-.097-.4h-1.406v-.923c.164-.01.317-.025.469-.026.388-.003.777-.003 1.165.003.482.008.605.112.695.58.048.252.092.506.146.802zm9.855.98h-9.712l.715 4.52h8.245l.752-4.52zm.103 9.61a1.382 1.382 0 0 1-1.362 1.422 1.406 1.406 0 0 1-1.416-1.38c-.008-.758.633-1.4 1.397-1.399a1.38 1.38 0 0 1 1.381 1.358zm-6.91.028a1.377 1.377 0 0 1-1.388 1.394c-.765-.004-1.402-.65-1.389-1.407a1.407 1.407 0 0 1 1.382-1.372 1.37 1.37 0 0 1 1.395 1.385zm-.958-.003c-.005-.253-.183-.428-.433-.423a.441.441 0 0 0-.43.436c.004.229.21.424.446.423.25-.002.421-.18.417-.436zm6.484.439c.249.002.43-.179.43-.43a.413.413 0 0 0-.428-.433.443.443 0 0 0-.441.43c-.001.233.2.43.439.433zM5.09 12.392v-.887c1.373-.04 2.728-.006 4.117-.017v.88c-.281.092-3.552.118-4.117.023zm4.133 1.413v.88c-.322.089-2.64.111-3.213.031v-.886c1.051-.05 2.115-.015 3.213-.025zm-2.29 2.336h2.274v.836c-.302.086-1.775.101-2.273.02v-.856zm-2.782-4.602v.868h-.91v-.866c.297-.084.597-.076.91-.002zm.023 3.193v-.906h.89v.906h-.89zm.923 2.288v-.879h.878v.88h-.878z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Ordering.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Original = function Original(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12.018 0c2.198 0 4.212.535 6.044 1.606a11.846 11.846 0 0 1 4.343 4.359C23.468 7.8 24 9.8 24 11.965c0 2.14-.532 4.135-1.595 5.982a12.035 12.035 0 0 1-4.36 4.412C16.2 23.453 14.167 24 11.946 24c-2.198 0-4.213-.541-6.044-1.624A11.845 11.845 0 0 1 1.578 18 11.794 11.794 0 0 1 0 12.035C0 9.895.532 7.9 1.595 6.053A12.078 12.078 0 0 1 5.938 1.64C7.77.547 9.796 0 12.018 0zm-.071 21.67c1.82 0 3.48-.435 4.98-1.305a9.564 9.564 0 0 0 3.546-3.547 9.54 9.54 0 0 0 1.294-4.853c0-1.741-.432-3.347-1.294-4.818a9.687 9.687 0 0 0-3.528-3.512c-1.489-.87-3.131-1.306-4.927-1.306-1.796 0-3.445.442-4.946 1.324A9.74 9.74 0 0 0 3.527 7.2a9.446 9.446 0 0 0-1.294 4.835c0 1.741.426 3.347 1.277 4.818a9.55 9.55 0 0 0 3.51 3.512c1.488.87 3.13 1.306 4.927 1.306zm5.176-11.858c0 .917-.207 1.7-.62 2.347-.414.647-1 1.135-1.756 1.465l2.624 3.882h-2.553l-2.091-3.459H9.678v3.459H7.445V5.788H12.3c1.537 0 2.724.347 3.563 1.041.84.695 1.259 1.689 1.259 2.983zm-7.445 2.364h2.623c.851 0 1.513-.205 1.986-.617.472-.412.709-.983.709-1.712 0-.73-.237-1.282-.71-1.659-.472-.376-1.134-.564-1.985-.564H9.678v4.552z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Original.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var OutputFields = function OutputFields(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.464 0L1 5.464V24h10.315v-1.846H2.846V6.77H7.77V1.846h10.461v7.392h1.846V0H6.464zm-.541 3.152v1.771H4.151l1.772-1.771zm6.73 12.908l.019-.004c-.36 0-.672.288-.672.651v.558a.68.68 0 0 0 .663.675h7.063l-2.544 2.553a.654.654 0 0 0 0 .921l.391.394a.646.646 0 0 0 .462.192.646.646 0 0 0 .462-.192l4.313-4.341A.66.66 0 0 0 23 17a.658.658 0 0 0-.19-.467l-4.313-4.341a.65.65 0 0 0-.924 0l-.391.395a.66.66 0 0 0-.191.467c0 .176.068.344.191.468l2.515 2.538h-7.044z",
    fill: "currentColor"
  })));
};

OutputFields.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Pause = function Pause(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12a12 12 0 0 1-12 12C5.373 24 0 18.627 0 12S5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM9.25 6c.69 0 1.25.448 1.25 1v10c0 .552-.56 1-1.25 1S8 17.552 8 17V7c0-.552.56-1 1.25-1zm5.143 0c.69 0 1.25.448 1.25 1v10c0 .552-.56 1-1.25 1s-1.25-.448-1.25-1V7c0-.552.56-1 1.25-1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Pause.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Plus = function Plus(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M21 13.286h-7.714V21h-2.572v-7.714H3v-2.572h7.714V3h2.572v7.714H21z"
  })));
};

Plus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PlusCircle = function PlusCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.6c5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4C6.256 1.6 1.6 6.256 1.6 12c0 5.744 4.656 10.4 10.4 10.4z",
    fill: "currentColor"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M18 12.857h-5.143V18h-1.714v-5.143H6v-1.714h5.143V6h1.714v5.143H18z"
  })));
};

PlusCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PlusSquare = function PlusSquare(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.69 24C2.105 24 0 21.972 0 19.478V4.522C0 2.028 2.104 0 4.69 0h14.62C21.895 0 24 2.028 24 4.522v14.954C23.998 21.972 21.895 24 19.308 24H4.69zM18 12.857v-1.714h-5.143V6h-1.714v5.143H6v1.714h5.143V18h1.714v-5.143H18zM4.69 1.651c-1.64 0-2.978 1.289-2.978 2.871v14.954c0 1.582 1.337 2.871 2.979 2.871h14.616c1.642 0 2.979-1.289 2.979-2.871V4.522c0-1.582-1.337-2.871-2.979-2.871H4.691z",
    fill: "currentColor"
  })));
};

PlusSquare.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PreviousPage = function PreviousPage(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.396 12.967l9.333 9.625c.25.258.583.408.938.408.729 0 1.333-.623 1.333-1.375V2.375C18 1.623 17.396 1 16.667 1c-.355 0-.688.15-.938.408l-9.333 9.625c-.25.258-.396.602-.396.967s.146.709.396.967z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

PreviousPage.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Private = function Private(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.09 1.612c-1.535.227-2.99.69-4.323 1.352-.4-.35-.977-.284-1.421-.046-.722.083-1.346.734-1.346 1.446 0 .087.006.219.034.37C8.829 6.547 7.2 9.001 6.454 11.8c-.122-.117-.23-.224-.32-.32C4.997 10.292 4.998 9.707 5 7.531v-.258c0-1.155-.047-1.92-.118-2.437C3.102 6.588 2 8.989 2 11.636c0 3.515 1.938 6.598 4.832 8.3.358.97.825 1.89 1.387 2.745C3.449 21.141 0 16.772 0 11.636 0 5.22 5.383 0 12 0c2.221 0 4.303.588 6.09 1.612zm4.846 11.549c.586 0 1.064.563 1.064 1.259v8.316c0 .695-.478 1.264-1.064 1.264H10.064C9.478 24 9 23.431 9 22.736V14.42c0-.696.478-1.26 1.064-1.26h.38v-1.657c0-3.067 2.613-5.629 5.878-5.684h.356c3.265.055 5.878 2.617 5.878 5.684v1.658h.38zm-5.23 5.409c.3-.275.474-.655.474-1.076 0-.797-.66-1.482-1.502-1.513a6.307 6.307 0 0 0-.356 0c-.841.031-1.502.716-1.502 1.513 0 .42.174.8.474 1.076v2.513c0 .287.259.53.568.53h1.276c.31 0 .568-.243.568-.53V18.57zm2.343-5.41v-1.657c0-1.827-1.593-3.338-3.549-3.338s-3.55 1.51-3.55 3.338v1.658h7.099z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Private.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Process = function Process(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.467 6.454a1.004 1.004 0 0 1 1.374.365c1.808 3.2 1.814 7.17.004 10.356-2.63 4.627-8.29 6.406-13 4.274l.32 1.29c.138.52-.183 1.088-.697 1.226a1.001 1.001 0 0 1-.752-.094 1.038 1.038 0 0 1-.457-.615l-.925-3.499a1.007 1.007 0 0 1 .094-.765.98.98 0 0 1 .604-.464l3.447-.937c.513-.139 1.071.188 1.21.71.136.521-.186 1.087-.699 1.227l-.99.27a8.197 8.197 0 0 0 10.111-3.608 8.464 8.464 0 0 0-.002-8.342c-.272-.505-.116-1.106.358-1.394zM16.514.032c.512-.14 1.071.187 1.21.71l.922 3.5c.07.26.042.527-.092.763a.973.973 0 0 1-.605.464l-3.446.937a1.01 1.01 0 0 1-.753-.095 1.036 1.036 0 0 1-.456-.614c-.138-.522.183-1.088.697-1.228l.99-.268a8.193 8.193 0 0 0-10.11 3.606c-1.463 2.573-1.482 5.771.002 8.342.284.481.115 1.106-.346 1.371a.98.98 0 0 1-.998.013 1.09 1.09 0 0 1-.35-.365 10.531 10.531 0 0 1-.015-10.393c2.63-4.627 8.267-6.419 12.977-4.287l-.326-1.229c-.137-.52.185-1.088.7-1.227zm-.589 10.594a1.374 1.374 0 1 1 .002 2.748 1.374 1.374 0 0 1-.002-2.748zm-3.925 0a1.375 1.375 0 1 1 .001 2.75 1.375 1.375 0 0 1 0-2.75zm-3.926 0a1.374 1.374 0 1 1 .002 2.748 1.374 1.374 0 0 1-.002-2.748z",
    fill: "currentColor"
  })));
};

Process.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Project = function Project(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0L1 5.989v12.023L12 24l11-5.988V5.99L12 0zM4.407 6.764L12 2.629l7.594 4.136L12 10.755 4.407 6.765zm8.88 6.032l7.34-3.846v6.479l-2.76-1.59-1.187 2.05 2.616 1.508-6.009 3.273v-7.874zM3.373 8.95l7.34 3.846v7.874l-6.01-3.273L7.32 15.89l-1.187-2.052-2.76 1.59V8.95z",
    fill: "currentColor"
  })));
};

Project.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Public = function Public(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm.346 3.01c.492-.273 1.149-.326 1.547.18a.501.501 0 0 1-.17.757c-.073.06-.137.419-.17.611-.093.527-.22 1.25-.932 1.427a1.52 1.52 0 0 1-.37.048c-.326 0-.561-.12-.713-.24C11.052 5.415 11 4.763 11 4.5c0-.733.624-1.405 1.346-1.49zm.4 18.952c-.248.019-.494.038-.746.038-5.514 0-10-4.486-10-10a9.965 9.965 0 0 1 2.882-7.013C4.952 5.52 5 6.309 5 7.5v.267c-.001 2.244-.002 2.847 1.133 4.073.994 1.073 3.951 3.604 5.172 4.12.122.052.168.092.176.092-.002.078-.101.28-.168.415-.14.284-.313.637-.313 1.033 0 .602.578 1.257 1.19 1.95.289.33.774.88.81 1.05 0 .277-.12.882-.255 1.462zm5.29-2.008c.575-.87.964-1.64.964-1.954 0-.953-.546-1.5-1.493-1.5-.306-.031-1.349-.82-1.972-1.291C14.375 14.332 13.9 14 13.5 14c-.441 0-.801.188-1.044.367-.402-.303-.956-.838-.956-1.367 0-1.098-.971-1.23-1.4-1.27.065-.109.156-.216.264-.259.246-.096.597.197.782.382A.5.5 0 1 0 12 11.5c0-1.638 1.886-2.472 3.263-3.082C16.271 7.973 17 7.65 17 7c0-.716-.667-1.27-1.255-1.76-.267-.221-.714-.593-.768-.73.02-.017.089-.05.14-.074C15.426 4.29 16 4.022 16 3c0-.059-.012-.11-.016-.167C19.52 4.376 22 7.902 22 12c0 3.246-1.561 6.126-3.964 7.954z",
    fill: "currentColor"
  })));
};

Public.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Quote = function Quote(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23 21h-9.007v-5.577c0-2.705.517-5.17 1.55-7.395 1.034-2.225 2.56-3.901 4.578-5.028l2.51 2.113a80.345 80.345 0 0 1-2.88 3.126c-1.033 1.353-1.55 2.79-1.55 4.31H23V21zm-12.993 0H1v-5.577c0-2.705.517-5.17 1.55-7.395C3.584 5.803 5.11 4.127 7.128 3l2.51 2.113c-.443.563-.91 1.098-1.403 1.605L6.758 8.24c-1.033 1.465-1.55 2.902-1.55 4.31h4.799V21z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Quote.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var RapidFlow = function RapidFlow(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.327 20.914v-8.041l2.08.009v8.402c0 .848-.748 1.534-1.674 1.534H5.346c-.923 0-1.672-.686-1.672-1.534v-8.449c.692 0 1.386-.003 2.08-.003v8.082h12.573zM9.536 19.17c-.575 0-1.04-.425-1.04-.95 0-.527.465-.955 1.04-.955h5.01c.574 0 1.04.428 1.04.955 0 .525-.466.95-1.04.95h-5.01zM18.5 9.297v-.46c0-2.308-1.422-4.31-3.5-5.312v3.928h-2v-4.53a6.875 6.875 0 0 0-1-.08c-.34 0-.674.032-1 .08v4.53H9V3.525C6.923 4.527 5.5 6.529 5.5 8.836v.461h13zm2 0H24v1.844H0V9.297h3.5v-.46C3.5 4.508 7.306 1 12 1s8.5 3.509 8.5 7.836v.461zm-5.954 3.585c.577 0 1.045.428 1.045.957 0 .529-.468.957-1.045.957-.58 0-1.047-.428-1.047-.957 0-.529.468-.957 1.047-.957zm-6.057.957c0-.53.468-.958 1.047-.958.576 0 1.045.429 1.045.958 0 .53-.469.958-1.045.958-.58 0-1.047-.43-1.047-.958z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

RapidFlow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var RapidFlowCircle = function RapidFlowCircle(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 12C0 5.372 5.372 0 12 0s12 5.372 12 12-5.372 12-12 12S0 18.628 0 12zm15.742 4.551H8.306v-4.78l-1.23.002v4.997c0 .501.443.907.989.907h7.917c.547 0 .99-.406.99-.907V11.8l-1.23-.005v4.755zm-5.2-1.031h2.964c.34 0 .615-.252.615-.562 0-.312-.276-.565-.615-.565h-2.963c-.34 0-.615.253-.615.565 0 .31.275.562.615.562zm5.302-5.839H8.156v-.273c0-1.364.841-2.548 2.07-3.14V8.59h1.183V5.91c.193-.028.39-.046.591-.046.202 0 .398.018.591.046v2.68h1.183V6.267c1.23.593 2.07 1.777 2.07 3.141v.273zm1.183 0v-.273c0-2.559-2.25-4.634-5.027-4.634-2.776 0-5.027 2.075-5.027 4.634v.273h-2.07v1.09h14.194v-1.09h-2.07zm-3.521 2.12c-.343 0-.62.253-.62.566 0 .313.277.566.62.566.34 0 .618-.253.618-.566 0-.313-.277-.566-.618-.566zm-3.582.566c0 .313.276.567.619.567.34 0 .618-.254.618-.567 0-.313-.277-.566-.618-.566-.343 0-.62.253-.62.566z",
    fill: "currentColor"
  })));
};

RapidFlowCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Reactions = function Reactions(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.838 12.576h-6.315c-1.204 0-2.162.961-2.162 2.114v6.196c0 1.177.982 2.114 2.162 2.114h6.315C23.042 23 24 22.04 24 20.886v-6.172a2.146 2.146 0 0 0-2.162-2.138zm-.05 8.262h-6.216v-6.1h6.241v6.1h-.024zM.24 18.341c-.32-.313-.32-.817 0-1.105l2.825-2.762a.97.97 0 0 1 1.475.144.963.963 0 0 1-.148 1.2l-1.056 1.034h6.904c.54 0 .958.432.958.936 0 .529-.442.937-.958.937H3.36l1.057 1.033c.32.312.417.816.147 1.2a.97.97 0 0 1-1.474.145L.24 18.34zm1.94-6.917h6.316c1.204 0 2.162-.961 2.162-2.114V3.114C10.658 1.937 9.675 1 8.496 1H2.18C.977 1 .018 1.96.018 3.114v6.172c0 1.177.959 2.138 2.163 2.138zm.05-8.262h6.24v6.1H2.23v-6.1zm18.699-.289l2.825 2.762c.32.313.32.817 0 1.105L20.93 9.526a.97.97 0 0 1-1.475-.144.963.963 0 0 1 .148-1.2l1.056-1.034h-6.904a.949.949 0 0 1-.959-.936c0-.529.443-.937.959-.937h6.904l-1.056-1.033c-.32-.312-.418-.816-.148-1.2a.958.958 0 0 1 1.475-.169z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Reactions.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Redo = function Redo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.496 1c4.707 0 8.7 3.167 10.027 7.511l1.66-2.919L24 6.659l-3.674 6.466-6.362-3.734 1.05-1.848 3.64 2.135c-.885-3.747-4.202-6.545-8.158-6.545-4.63 0-8.397 3.829-8.397 8.534S5.866 20.2 10.496 20.2v2.133C4.708 22.333 0 17.55 0 11.667 0 5.785 4.708 1 10.496 1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Redo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Referents = function Referents(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M8.814 15.186l-1.207 8.15-2.732-2.528L1.683 24 0 22.317l3.192-3.192-2.528-2.732 8.15-1.207zm6.372 0l8.15 1.207-2.528 2.732L24 22.317 22.317 24l-3.192-3.191-2.732 2.527-1.207-8.15zM12 8.815a3.186 3.186 0 1 1 .003 6.37 3.186 3.186 0 0 1-.003-6.37zM1.683 0l3.192 3.192L7.607.666l1.207 8.148-8.15-1.206 2.528-2.732L0 1.684 1.683 0zm20.634 0L24 1.684l-3.192 3.191 2.528 2.732-8.15 1.207L16.393.665l2.732 2.527L22.317 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

Referents.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Refresh = function Refresh(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.496 1c4.707 0 8.7 3.167 10.027 7.511l1.66-2.919L24 6.659l-3.674 6.466-6.362-3.734 1.05-1.848 3.64 2.135c-.885-3.747-4.202-6.545-8.158-6.545-4.63 0-8.397 3.829-8.397 8.534S5.866 20.2 10.496 20.2v2.133C4.708 22.333 0 17.55 0 11.667 0 5.785 4.708 1 10.496 1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Refresh.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Repeat = function Repeat(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.941 16.91a.738.738 0 0 1-.086.729l-3.125 4.114a.601.601 0 0 1-.48.247.601.601 0 0 1-.48-.247l-3.125-4.114a.738.738 0 0 1-.086-.73.625.625 0 0 1 .566-.395H19V4.743H9.964L7.88 2H19c1.379 0 2.5 1.23 2.5 2.743v11.771h1.875c.242 0 .462.154.566.395zm-9.905 2.347L16.12 22H5c-1.379 0-2.5-1.23-2.5-2.743V7.486H.625A.625.625 0 0 1 .06 7.09a.738.738 0 0 1 .086-.73L3.27 2.247A.6.6 0 0 1 3.75 2a.6.6 0 0 1 .48.247L7.355 6.36a.738.738 0 0 1 .086.73.625.625 0 0 1-.566.395H5v11.771h9.036z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Repeat.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ResizeWindow = function ResizeWindow(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M0 0h24L0 24z"
  })));
};

ResizeWindow.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Resources = function Resources(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.004 22.995c-.014.002-.441.004-1.28.005H2.689C1.204 23 0 21.727 0 20.167V3.831C0 2.27 1.204 1 2.689 1l5.12.041L10.207 3.4h8.747c1.484 0 2.688 1.272 2.688 2.83v2.228h2.212l.145.177-2.403 11.683c-.072 1.462-1.2 2.63-2.593 2.678zm.52-16.765c0-.338-.258-.61-.57-.61l-9.553-.04L7 3.22H2.69c-.312 0-.57.272-.57.61v16.337c0 .339.258.61.57.61h.43L5.456 8.58l.146-.121h13.921V6.23zm-.61 14.549c.313 0 .57-.272.57-.61.002-.036.002-.036.005-.058a1.28 1.28 0 0 1 .018-.168l1.925-9.264H7.228l-1.95 10.1h13.637z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Resources.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ResponseType = function ResponseType(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.52 0a5.453 5.453 0 0 1 5.446 5.447v8.715a5.453 5.453 0 0 1-5.447 5.447h-6.206l-6.262 4.174a1.096 1.096 0 0 1-1.118.054 1.09 1.09 0 0 1-.576-.96v-3.379A5.457 5.457 0 0 1 0 14.162V5.447A5.453 5.453 0 0 1 5.447 0zm0 2.179H5.446a3.272 3.272 0 0 0-3.268 3.268v8.715a3.272 3.272 0 0 0 3.268 3.268c.601 0 1.09.488 1.09 1.09v2.32l4.841-3.227a1.04 1.04 0 0 1 .605-.183h6.536a3.272 3.272 0 0 0 3.268-3.268V5.447a3.272 3.272 0 0 0-3.268-3.268zm-2.18 8.715a1.09 1.09 0 0 1 0 2.178H7.626a1.09 1.09 0 0 1 0-2.178zm2.18-4.358a1.09 1.09 0 0 1 0 2.179H5.446a1.09 1.09 0 0 1 0-2.179z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ResponseType.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Resume = function Resume(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 0c6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm3.826 2.761A10 10 0 1 0 12 22c5.52-.008 9.992-4.48 9.999-10a10 10 0 0 0-6.173-9.239zM9.163 7.775a1.488 1.488 0 0 1 1.52-.026l5.926 2.963a1.388 1.388 0 0 1-.004 2.575l-5.926 2.963a1.71 1.71 0 0 1-.761.188 1.44 1.44 0 0 1-.759-.214 1.532 1.532 0 0 1-.7-1.348V9.122c-.03-.544.24-1.06.704-1.347z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Resume.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Rollback = function Rollback(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.576 21.773c.198.049.4.093.6.13a.966.966 0 0 1-.352 1.897 12.03 12.03 0 0 1-.715-.155.965.965 0 1 1 .467-1.872zM2.44 8.84a.962.962 0 0 1-1.22.612.965.965 0 0 1-.612-1.219c.076-.23.16-.462.251-.687a.965.965 0 1 1 1.792.716c-.076.19-.147.384-.211.578zm4 11.554c.17.113.345.221.522.323A.965.965 0 0 1 6 22.39c-.21-.122-.42-.25-.622-.385a.965.965 0 0 1 1.064-1.61zm-6.432-8.86a.965.965 0 0 1 1.928.076c-.008.204-.01.41-.005.613a.964.964 0 1 1-1.93.043c-.004-.243-.002-.489.007-.732zm2.59 6.322a.964.964 0 0 1 1.35.193c.123.163.252.324.384.48a.965.965 0 0 1-1.47 1.25 11.988 11.988 0 0 1-.457-.572.965.965 0 0 1 .192-1.351zM1.18 14.369a.965.965 0 0 1 1.21.632c.06.195.128.39.2.58a.965.965 0 0 1-1.802.688 12.4 12.4 0 0 1-.24-.69.965.965 0 0 1 .632-1.21zm12.605 7.542a9.962 9.962 0 0 0 2.475-.786l.027-.015c.185-.087.37-.18.549-.278l.002-.001c.329-.18.649-.381.96-.6 4.539-3.197 5.63-9.49 2.433-14.03a10.026 10.026 0 0 0-2.475-2.461l-.034-.024c-3.306-2.278-7.794-2.431-11.303-.09l.753 1.088c.21.304.081.524-.286.491l-3.274-.293a.54.54 0 0 1-.488-.705l.879-3.168c.098-.355.35-.398.56-.095l.756 1.092a11.915 11.915 0 0 1 8.73-1.857c.31.054.614.12.914.195l.006.001.035.01a11.897 11.897 0 0 1 6.597 4.422c.014.016.028.032.041.05a11.364 11.364 0 0 1 .417.602c.01.015.018.03.027.046a11.895 11.895 0 0 1 1.902 7.016v.025c-.011.242-.03.487-.056.728l-.008.046a11.907 11.907 0 0 1-3.46 7.187l-.013.013-.004.004c-.472.465-.985.895-1.537 1.284a11.896 11.896 0 0 1-4.784 2.003.964.964 0 1 1-.34-1.9zM11.408 4.205c.43 0 .78.35.78.78v6.827l6.269 3.241a.78.78 0 1 1-.717 1.387l-7.113-3.677V4.986c0-.431.35-.78.78-.78z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Rollback.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var RuleGroup = function RuleGroup(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.636 20.25v-7.5h3.325v-1.5h-3.325v-7.5h3.325v-1.5H9.974v9H6.649V7.5H0v9h6.65v-3.75h3.324v9h4.987v-1.5h-3.325zM4.987 15H1.662V9h3.325v6zM24 15h-6.65V9H24v6zm-4.987-1.5h3.325v-3h-3.325v3zM17.351 6V0H24v6h-6.65zm4.987-4.5h-3.325v3h3.325v-3zM24 24h-6.65v-6H24v6zm-4.987-1.5h3.325v-3h-3.325v3z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

RuleGroup.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Run = function Run(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.28 13.495L6.883 20.823c-.642.413-1.423.078-1.745-.748A2.073 2.073 0 0 1 5 19.327V4.672C5 3.75 5.582 3 6.3 3c.203 0 .402.06.582.177l11.399 7.327c.642.413.903 1.418.581 2.244a1.54 1.54 0 0 1-.581.747z",
    fill: "currentColor"
  })));
};

Run.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Save = function Save(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.688 6.625c-.209-.5-.459-.896-.75-1.188l-4.376-4.375c-.291-.291-.687-.541-1.187-.75C16.875.104 16.417 0 16 0H1.5C1.083 0 .73.146.437.437A1.446 1.446 0 0 0 0 1.5v21c0 .417.146.771.437 1.063.292.291.646.437 1.063.437h21c.417 0 .771-.146 1.063-.437.291-.292.437-.646.437-1.063V8c0-.417-.104-.875-.312-1.375zM10 2.5a.48.48 0 0 1 .149-.352A.481.481 0 0 1 10.5 2h3a.48.48 0 0 1 .352.148c.099.1.148.216.148.352v5c0 .136-.05.253-.148.352A.481.481 0 0 1 13.5 8h-3a.48.48 0 0 1-.351-.148A.48.48 0 0 1 10 7.5v-5zM18 22H6v-6h12v6zm4 0h-2v-6.5c0-.417-.146-.77-.437-1.063A1.447 1.447 0 0 0 18.5 14h-13c-.417 0-.771.146-1.063.437A1.447 1.447 0 0 0 4 15.5V22H2V2h2v6.5c0 .417.146.77.437 1.063.292.291.646.437 1.063.437h9c.417 0 .771-.146 1.063-.437.291-.292.437-.646.437-1.063V2c.156 0 .36.052.61.156.25.104.427.208.53.312l4.392 4.391c.104.104.208.284.312.54.105.255.157.455.157.601v14z",
    fill: "currentColor"
  })));
};

Save.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SaveThin = function SaveThin(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.83 4.523L19.21.16a.595.595 0 0 0-.408-.16H2.31C1.037 0 0 .978 0 2.182v19.636C0 23.021 1.037 24 2.31 24h19.38c1.273 0 2.31-.978 2.31-2.182V4.91a.53.53 0 0 0-.17-.386zM5.776 1.091H17.07v6.545c0 .602-.518 1.091-1.156 1.091H6.93c-.637 0-1.155-.49-1.155-1.09V1.09zM19.38 22.909H4.62v-9.818h14.76v9.818zm3.465-1.09c0 .6-.518 1.09-1.155 1.09h-1.155V12.545c0-.301-.259-.545-.578-.545H4.043c-.32 0-.578.244-.578.545V22.91H2.31c-.637 0-1.155-.49-1.155-1.09V2.181c0-.602.518-1.091 1.155-1.091h2.31v6.545c0 1.204 1.037 2.182 2.31 2.182h8.984c1.274 0 2.31-.978 2.31-2.182V1.091h.339l4.282 4.044v16.683zM13.027 7.635c-.32 0-.578-.244-.578-.545V2.727c0-.301.259-.545.578-.545h2.31c.32 0 .577.244.577.545v4.364c0 .301-.258.545-.577.545h-2.31zm1.732-4.363h-1.155v3.272h1.155V3.273z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

SaveThin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Search = function Search(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.706 22.296l-5.77-5.77a10.079 10.079 0 0 0 2.293-6.412C20.229 4.531 15.698 0 10.114 0 4.526 0 0 4.53 0 10.114 0 15.698 4.526 20.23 10.114 20.23a10.06 10.06 0 0 0 6.407-2.288l5.77 5.765a1 1 0 0 0 1.415-1.41zm-13.592-4.08c-4.472 0-8.106-3.635-8.106-8.102 0-4.467 3.634-8.106 8.106-8.106 4.467 0 8.106 3.64 8.106 8.106 0 4.467-3.639 8.102-8.106 8.102z",
    fill: "currentColor"
  })));
};

Search.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SearchResources = function SearchResources(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.121 22.5V22h1.007v.5c0 .828-.676 1.5-1.51 1.5H2.51c-.834 0-1.51-.672-1.51-1.5v-17a.498.498 0 0 1 .15-.375l5.036-5a.503.503 0 0 1 .146-.1h.045A.506.506 0 0 1 6.51 0h11.109c.834 0 1.51.672 1.51 1.5v4h-1.007v-4c0-.276-.225-.5-.503-.5H7.043v3.5c0 .828-.676 1.5-1.51 1.5H4.021V5h1.51a.502.502 0 0 0 .504-.5V1.705l-4.029 4V22.5c0 .276.226.5.504.5h15.107a.502.502 0 0 0 .503-.5zm-15.106-1v-2h1.007V21h1.51v1H3.518a.502.502 0 0 1-.503-.5zm0-4h1.007v1H3.015v-1zm20.798 3.424v.091l-.584.58h-.09l-3.204-3.18a6.355 6.355 0 0 1-7.997-.804 6.247 6.247 0 0 1 .04-8.878 6.354 6.354 0 0 1 8.94.039 6.246 6.246 0 0 1-.038 8.877 2.11 2.11 0 0 1-.161.149l-.02.017-.007.006 3.12 3.103zm-3.595-3.946a5.252 5.252 0 0 0-.001-7.465 5.343 5.343 0 0 0-7.519.002 5.251 5.251 0 0 0 .002 7.464 5.343 5.343 0 0 0 7.517 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

SearchResources.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SearchSettings = function SearchSettings(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm.707 9a5.502 5.502 0 0 1 10.627.155c.201-.1.427-.155.666-.155h1a1.5 1.5 0 1 1 0 3h-1c-.239 0-.465-.056-.666-.155A5.502 5.502 0 0 1 10.207 20H1.5a1.5 1.5 0 0 1 0-3h8.707zm4.586-10A5.502 5.502 0 0 1 4.207 7H1.5a1.5 1.5 0 0 1 0-3h2.707a5.502 5.502 0 0 1 10.586 0H22.5a1.5 1.5 0 1 1 0 3h-7.707zm.707 14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    fill: "currentColor"
  })));
};

SearchSettings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Send = function Send(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.144 1.012L.528 6.605c-.283.049-.472.29-.52.627a.684.684 0 0 0 .379.723l8.404 4.822 2.077 9.644c.047.29.283.53.567.579h.094c.236 0 .472-.145.614-.338L23.899 2.17a.743.743 0 0 0-.047-.82c-.142-.289-.425-.385-.708-.337z",
    fill: "currentColor"
  })));
};

Send.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Settings = function Settings(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.346 19.37a1.07 1.07 0 0 1-.417 2.058H10.988a3.645 3.645 0 0 1-5.181 2.151 3.66 3.66 0 0 1-1.781-2.15H1.08a1.07 1.07 0 1 1 0-2.143h2.945a3.636 3.636 0 0 1 5.664-1.844 3.657 3.657 0 0 1 1.298 1.844h11.94c.149 0 .29.03.418.084zm-15.84 2.487c.827 0 1.5-.673 1.5-1.5s-.672-1.5-1.5-1.5c-.825 0-1.5.673-1.5 1.5s.674 1.5 1.5 1.5zM22.93 10.93a1.071 1.071 0 1 1 0 2.143h-.803a3.644 3.644 0 0 1-3.481 2.57 3.645 3.645 0 0 1-3.481-2.57H1.071a1.072 1.072 0 0 1 0-2.143h14.093a3.646 3.646 0 0 1 3.481-2.572 3.646 3.646 0 0 1 3.481 2.572h.803zm-4.22 2.57a1.501 1.501 0 0 0 0-3 1.501 1.501 0 0 0 0 3zM2.324 6.559a3.651 3.651 0 0 1-1.297-1.845 1.071 1.071 0 0 1 0-2.14A3.645 3.645 0 0 1 4.508 0 3.645 3.645 0 0 1 7.99 2.572h14.94a1.071 1.071 0 1 1 0 2.142H7.99a3.638 3.638 0 0 1-5.665 1.844zm2.184-4.415c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5a1.501 1.501 0 0 0 0-3z",
    fill: "currentColor"
  })));
};

Settings.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SingleValue = function SingleValue(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M4.5 1.5a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15zm0-1.5h15A4.5 4.5 0 0 1 24 4.5v15a4.5 4.5 0 0 1-4.5 4.5h-15A4.5 4.5 0 0 1 0 19.5v-15A4.5 4.5 0 0 1 4.5 0zm11.438 8.984l1.142-2.325a7.825 7.825 0 0 0-2.224-1.038 8.896 8.896 0 0 0-2.54-.371c-1.41 0-2.58.342-3.512 1.026-.932.684-1.398 1.677-1.398 2.98 0 .84.203 1.52.608 2.04.405.519.883.906 1.434 1.161.55.256 1.264.516 2.139.78.907.28 1.563.535 1.969.766.405.23.607.577.607 1.038 0 .412-.174.721-.522.927-.349.206-.815.31-1.398.31-.73 0-1.499-.145-2.309-.433a6.38 6.38 0 0 1-2.09-1.2l-1.094 2.25c.664.594 1.475 1.051 2.43 1.373a9.169 9.169 0 0 0 2.942.482c1.474 0 2.697-.346 3.67-1.038.972-.693 1.458-1.682 1.458-2.967 0-.874-.215-1.579-.644-2.115a4.22 4.22 0 0 0-1.52-1.211c-.583-.272-1.328-.548-2.235-.828-.86-.248-1.487-.482-1.884-.705-.397-.223-.595-.54-.595-.952 0-.396.158-.688.473-.878.316-.19.742-.284 1.277-.284.567 0 1.186.107 1.859.321a9.263 9.263 0 0 1 1.957.89z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

SingleValue.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SmallTalk = function SmallTalk(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M3.75 8.071h4.929a.321.321 0 1 1 0 .643H3.75a.321.321 0 1 1 0-.643zm0-1.5h2.357a.321.321 0 1 1 0 .643H3.75a.321.321 0 1 1 0-.643zm10.286 5.358h4.928a.321.321 0 1 1 0 .642h-4.928a.321.321 0 1 1 0-.642zm0 1.5h4.928a.321.321 0 1 1 0 .642h-4.928a.321.321 0 1 1 0-.642zm0-3h2.357a.321.321 0 1 1 0 .642h-2.357a.321.321 0 1 1 0-.642zm9.386 4.994V9.145c0-.62-.53-1.144-1.155-1.144H12.019c-.626 0-1.155.524-1.155 1.144v6.278c0 .62.529 1.144 1.155 1.144h5.398a.29.29 0 0 1 .213.094l2.386 2.599v-2.407c0-.158.13-.286.29-.286h1.96c.627 0 1.156-.524 1.156-1.144zM10.286 9.145c0-.93.794-1.717 1.733-1.717h.26V5.716c0-.62-.529-1.144-1.155-1.144h-9.39c-.627 0-1.156.524-1.156 1.144v5.421c0 .62.529 1.144 1.155 1.144h1.962c.16 0 .289.128.289.286v2.407l2.386-2.6a.29.29 0 0 1 .213-.093h3.703V9.145zm11.98-1.717c.94 0 1.734.787 1.734 1.717v6.278c0 .93-.794 1.716-1.733 1.716h-1.673V20a.286.286 0 0 1-.289.287.29.29 0 0 1-.213-.094l-2.803-3.053h-5.27c-.94 0-1.733-.786-1.733-1.716v-2.57H6.71L3.91 15.907a.29.29 0 0 1-.503-.192v-2.86H1.733c-.94 0-1.733-.787-1.733-1.717v-5.42C0 4.786.794 4 1.733 4h9.39c.94 0 1.734.786 1.734 1.716v1.712h9.41z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

SmallTalk.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Snapshot = function Snapshot(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.063 6.177c.625.631.937 1.393.937 2.285v11.307c0 .892-.313 1.654-.937 2.284A3.068 3.068 0 0 1 20.8 23H3.2a3.068 3.068 0 0 1-2.263-.947A3.127 3.127 0 0 1 0 19.77V8.462c0-.892.312-1.654.937-2.285A3.069 3.069 0 0 1 3.2 5.231H6l.638-1.716c.158-.413.447-.768.868-1.067C7.927 2.15 8.358 2 8.8 2h6.4c.442 0 .873.15 1.294.448.421.299.71.654.869 1.067L18 5.23h2.8c.884 0 1.638.315 2.263.946zM15.956 18.11c1.096-1.107 1.644-2.438 1.644-3.994 0-1.557-.548-2.888-1.644-3.995-1.095-1.106-2.414-1.66-3.956-1.66-1.542 0-2.86.554-3.956 1.66C6.948 11.228 6.4 12.56 6.4 14.116c0 1.556.548 2.888 1.644 3.994 1.096 1.106 2.414 1.66 3.956 1.66 1.542 0 2.86-.554 3.956-1.66zM12 10.48c.992 0 1.84.356 2.544 1.067a3.518 3.518 0 0 1 1.056 2.569 3.518 3.518 0 0 1-1.056 2.568c-.704.71-1.552 1.066-2.544 1.066s-1.84-.355-2.544-1.066A3.518 3.518 0 0 1 8.4 14.116c0-1.002.352-1.858 1.056-2.569.704-.71 1.552-1.066 2.544-1.066z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Snapshot.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Sorting = function Sorting(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.424 17.704c.125 0 .227.04.307.12.08.08.121.184.121.308v2.57c0 .125-.04.228-.12.308a.416.416 0 0 1-.308.12h-5.996a.417.417 0 0 1-.308-.12.416.416 0 0 1-.12-.308v-2.57c0-.124.04-.227.12-.307.08-.08.183-.12.308-.12h5.996zm-8.984.153a.45.45 0 0 1 .322.12c.085.081.127.184.127.31a.49.49 0 0 1-.14.32L5.271 23.88a.482.482 0 0 1-.322.12.519.519 0 0 1-.323-.12l-4.49-5.286c-.14-.143-.173-.3-.098-.47.075-.178.215-.267.42-.267h2.695V.429c0-.125.042-.228.126-.309A.448.448 0 0 1 3.603 0h2.694c.13 0 .238.04.322.12.085.08.127.184.127.309v17.428H9.44zM23.87 2.12c.081.08.121.183.121.308v2.57c0 .125-.04.227-.12.308a.417.417 0 0 1-.308.12H12.428a.418.418 0 0 1-.307-.12.417.417 0 0 1-.12-.308v-2.57c0-.125.04-.227.12-.308.08-.08.182-.12.307-.12h11.135c.125 0 .227.04.308.12zm-2.877 7.732c.125 0 .228.04.308.12.08.08.12.184.12.309v2.569c0 .125-.04.228-.12.308a.417.417 0 0 1-.308.12h-8.565a.417.417 0 0 1-.308-.12.417.417 0 0 1-.12-.308v-2.57c0-.124.04-.227.12-.307.08-.08.183-.12.308-.12h8.565z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Sorting.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Stop = function Stop(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12a12 12 0 0 1-12 12zm0-22C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM8 8h8v8H8V8z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Stop.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Sync = function Sync(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.398 11.99c0 5.29 4.304 9.593 9.593 9.593a9.517 9.517 0 0 0 6.773-2.819l-3.176-3.176h7.194v7.194l-2.322-2.324a11.907 11.907 0 0 1-8.47 3.523C5.38 23.981 0 18.603 0 11.991zM11.991 0c6.611 0 11.99 5.378 11.99 11.99h-2.398c0-5.288-4.303-9.592-9.592-9.592a9.52 9.52 0 0 0-6.774 2.82l3.176 3.175H1.2V1.2l2.324 2.324A11.905 11.905 0 0 1 11.99 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Sync.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Tag = function Tag(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.263 0a2.743 2.743 0 0 1 2.717 2.4l.016.171.005.167v8.96a.88.88 0 0 1-.115.433l-.064.1-.082.094L12.866 23.2a2.714 2.714 0 0 1-1.509.767l-.217.025-.218.008-.21-.008a2.714 2.714 0 0 1-1.394-.514l-.17-.135-.154-.143L.8 15.007a2.743 2.743 0 0 1-.246-3.59l.118-.144.128-.138L11.675.26a.881.881 0 0 1 .387-.225l.117-.026.124-.009h8.96zm0 1.777H12.67L2.056 12.39a.964.964 0 0 0-.148 1.171l.066.096.082.093 8.194 8.193c.18.18.42.28.68.28a.965.965 0 0 0 .488-.13l.102-.07.09-.08 10.613-10.615.001-8.591c0-.492-.372-.9-.85-.955l-.111-.006zm-3.555 2.146c.632 0 1.228.247 1.676.694.447.447.694 1.043.694 1.676s-.247 1.228-.695 1.676a2.356 2.356 0 0 1-1.675.694 2.356 2.356 0 0 1-1.676-.694 2.356 2.356 0 0 1-.694-1.676c0-.633.247-1.229.694-1.676a2.356 2.356 0 0 1 1.676-.694zm0 1.386a.975.975 0 0 0-.696.289.974.974 0 0 0-.288.695c0 .263.102.51.288.695a.974.974 0 0 0 .696.289c.263 0 .51-.102.695-.289a.976.976 0 0 0 .288-.695.974.974 0 0 0-.288-.696.975.975 0 0 0-.695-.288z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Tag.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TargetPriority = function TargetPriority(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.6 2.861c2.426 0 4.4 1.897 4.4 4.228v10.57c0 2.33-1.974 4.227-4.4 4.227H12v-2.114h6.6c1.214 0 2.2-.947 2.2-2.114V7.088c0-1.165-.986-2.113-2.2-2.113h-1.745l1.423 1.367-1.556 1.494-4.077-3.918L16.722 0l1.556 1.495-1.423 1.366H18.6zM8.7 17.658c.608 0 1.1.473 1.1 1.057v4.228C9.8 23.528 9.308 24 8.7 24H2.1c-.608 0-1.1-.472-1.1-1.057v-4.228c0-.584.492-1.057 1.1-1.057h6.6zm0-8.455c.608 0 1.1.472 1.1 1.057v4.227c0 .585-.492 1.057-1.1 1.057H2.1c-.608 0-1.1-.472-1.1-1.057V10.26c0-.585.492-1.057 1.1-1.057h6.6zM7.6 13.43v-2.114H3.2v2.114h4.4zM8.7.747c.608 0 1.1.473 1.1 1.057v4.228c0 .584-.492 1.057-1.1 1.057H2.1c-.608 0-1.1-.473-1.1-1.057V1.804C1 1.22 1.492.747 2.1.747h6.6zM7.6 4.975V2.861H3.2v2.114h4.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TargetPriority.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Targets = function Targets(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.776 10.776h-1.55c-.549-4.154-3.865-7.453-8.029-8.001v-1.55a1.225 1.225 0 0 0-2.449 0v1.55c-4.163.548-7.425 3.847-7.973 8h-1.55a1.225 1.225 0 0 0 0 2.45h1.55c.548 4.153 3.81 7.452 7.973 8v1.55a1.225 1.225 0 0 0 2.45 0v-1.55c4.163-.548 7.48-3.847 8.027-8h1.55a1.225 1.225 0 0 0 0-2.45zm-9.579 7.97v-1.358a1.225 1.225 0 0 0-2.449 0v1.357c-2.775-.507-4.986-2.72-5.493-5.52h1.357a1.225 1.225 0 0 0 0-2.45H5.255c.507-2.8 2.718-5.013 5.493-5.52v1.357a1.225 1.225 0 0 0 2.45 0V5.255a6.835 6.835 0 0 1 5.547 5.52h-1.357a1.225 1.225 0 0 0 0 2.45h1.357a6.835 6.835 0 0 1-5.548 5.52z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Targets.defaultProps = {
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Telecoms = function Telecoms(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M8.421 19.6c-.885 0-1.605.718-1.605 1.6 0 .882.72 1.6 1.605 1.6.886 0 1.606-.718 1.606-1.6 0-.882-.72-1.6-1.606-1.6zM22.87 4.8v8.4h-7.225v9.038c0 .971-.793 1.762-1.768 1.762H3.767C2.794 24 2 23.21 2 22.238V1.762C2 .791 2.793 0 3.768 0h10.11c.974 0 1.767.79 1.767 1.762V4.8h7.225zM7.217 2a.4.4 0 1 1 0-.8h1.606a.4.4 0 1 1 0 .8H7.217zm2.81 0a.4.4 0 1 1 0-.8h.401a.4.4 0 1 1 0 .8h-.401zM3.767.8a.965.965 0 0 0-.964.962V2.4h12.04v-.638A.965.965 0 0 0 13.877.8H3.767zM8.422 22a.802.802 0 0 1-.802-.8.802.802 0 0 1 1.605 0c0 .441-.36.8-.803.8zm5.457 1.2a.965.965 0 0 0 .965-.962V19.2H2.803v3.038c0 .53.433.962.965.962h10.11zm.965-4.8v-5.2H12.97L9.224 16v-2.8H7.62V4.8h7.224V3.2H2.803v15.2h12.04zm7.224-6V5.6H8.42v6.8h1.606v2l2.675-2h9.365zm-11.639-4a.4.4 0 1 1 0-.8h4.013a.4.4 0 1 1 0 .8h-4.013zm-.401 1.6a.4.4 0 0 1 .401-.4h9.632a.4.4 0 1 1 0 .8h-9.632a.4.4 0 0 1-.401-.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Telecoms.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TestSet = function TestSet(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.318 4.3H1.682C.752 4.3 0 3.561 0 2.65 0 1.739.753 1 1.682 1h20.636C23.248 1 24 1.739 24 2.65c0 .911-.753 1.65-1.682 1.65zM24 11.727c0-.912-.753-1.65-1.682-1.65H1.682c-.93 0-1.682.738-1.682 1.65 0 .911.753 1.65 1.682 1.65h20.636c.93 0 1.682-.739 1.682-1.65zm-6.545 9.078c0-.911-.548-1.65-1.224-1.65H1.223c-.675 0-1.223.739-1.223 1.65 0 .912.548 1.65 1.223 1.65h15.008c.676 0 1.224-.738 1.224-1.65z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TestSet.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TestSetEditor = function TestSetEditor(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.55 5H1.542C.69 5 0 4.33 0 3.5 0 2.671.69 2 1.542 2H19.55c.852 0 1.542.671 1.542 1.5 0 .83-.69 1.5-1.542 1.5zM9.458 13.252H1.542C.69 13.252 0 12.58 0 11.752c0-.83.69-1.5 1.542-1.5h7.916c.852 0 1.542.67 1.542 1.5 0 .829-.69 1.5-1.542 1.5zm-8.337 5.253h4.9c.62 0 1.122.671 1.122 1.5s-.502 1.5-1.122 1.5h-4.9c-.619 0-1.12-.671-1.12-1.5s.501-1.5 1.12-1.5zM20.934 7.43l2.77 2.795c.397.42.394 1.06-.005 1.46l-9.652 9.63c-.196.197-.447.3-.725.3l-2.794.015c-.28 0-.532-.104-.728-.3a1.04 1.04 0 0 1-.301-.742l.015-2.804c0-.253.098-.493.29-.712l9.666-9.646a1.048 1.048 0 0 1 1.464.004zm.163 4.061l.55-.55-1.458-1.46-.551.551 1.459 1.46zm-8.085 7.955L19.7 12.76l-1.33-1.332-6.688 6.7-.01 1.327 1.339-.009z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TestSetEditor.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TestingSimulatorColored = function TestingSimulatorColored(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.411 2h17.181c1.164 0 2.147.983 2.147 2.148v.08h-.716v-.08a1.45 1.45 0 0 0-1.431-1.432H2.412c-.777 0-1.433.656-1.433 1.432v11.811c0 .776.656 1.432 1.432 1.432H5.37c.198 0 .358.16.358.358v3.011l2.923-3.215v1.064l-3.016 3.318a.358.358 0 0 1-.623-.24v-3.58h-2.6c-1.164 0-2.147-.984-2.147-2.148V4.148C.264 2.983 1.247 2 2.41 2zm18.675 5.102l-.055-.057.434-.432.056.057c.148.15.29.307.424.466l.05.06-.466.398-.051-.061a7.373 7.373 0 0 0-.392-.431zm-1.358-1.09a7.305 7.305 0 0 0-.505-.289l-.07-.036.28-.546.07.036c.186.096.37.201.548.312l.066.042-.321.522-.068-.042zm.934.69a7.44 7.44 0 0 0-.453-.364l-.063-.046.361-.496.064.047c.168.124.333.257.492.395l.059.052-.4.465-.06-.052zm-4.131-1.764l-.08-.006a7.333 7.333 0 0 0-.58-.023h-.078v-.614h.079c.208 0 .419.008.627.024l.08.006-.048.613zm2.166.539a7.196 7.196 0 0 0-.543-.203l-.075-.025.19-.584.075.024c.197.065.395.14.59.221l.072.03-.236.568-.073-.031zm3.736 3.515l-.035-.07.546-.276.036.07c.093.187.18.381.258.577l.03.073-.567.231-.03-.074a7.509 7.509 0 0 0-.238-.531zm.693 2.218l-.011-.078.605-.09.011.079c.03.205.053.417.067.628l.005.079-.61.042-.005-.08a7.31 7.31 0 0 0-.062-.58zm-.259-1.137l-.023-.076.583-.184.024.075c.062.2.118.406.164.61l.018.078-.596.137-.018-.077a7.233 7.233 0 0 0-.152-.563zm-6 9.534l.078-.01.081.609-.077.01a7.998 7.998 0 0 1-.626.06l-.079.005-.034-.613.079-.005c.195-.011.389-.03.577-.056zm4.967-11.614l-.046-.064.497-.359.046.066c.122.171.239.349.346.527l.04.068-.523.318-.04-.068c-.101-.167-.209-.331-.32-.488zm.523 7.747l.037-.071.54.288-.036.07c-.098.186-.204.37-.315.547l-.043.067-.516-.33.042-.066c.104-.165.202-.335.291-.505zM17.673 5.133l-.077-.019A7.476 7.476 0 0 0 17.027 5l-.078-.012.096-.607.078.012c.209.034.416.075.617.124l.076.019-.143.597zm5.428 8.404l.013-.078.603.102-.013.078a8.076 8.076 0 0 1-.13.62l-.02.076-.592-.15.019-.077c.047-.187.087-.379.12-.571zm-1.365 3.188l.048-.064.488.37-.047.063a7.84 7.84 0 0 1-.397.49l-.053.06-.457-.408.051-.058c.128-.146.252-.299.367-.453zm1.469-4.43l.611.007v.079c-.003.207-.013.42-.032.631l-.007.08-.609-.056.007-.078c.017-.194.027-.39.029-.584v-.079zm-.388 2.372l.025-.075.579.198-.026.075a8.177 8.177 0 0 1-.225.59l-.031.074-.562-.244.031-.072c.075-.175.145-.359.209-.546zm-4.819 4.693l.076-.023.177.588-.076.023c-.196.06-.4.113-.608.159l-.077.017-.13-.6.077-.017c.19-.042.378-.092.561-.147zm2.97-1.76l.057-.056.425.442-.056.055a8.052 8.052 0 0 1-.468.422l-.062.05-.389-.474.06-.05c.15-.124.296-.255.433-.39zm-1.892 1.334l.072-.034.267.552-.07.035c-.188.091-.381.177-.576.254l-.074.029-.223-.572.073-.03a7.21 7.21 0 0 0 .531-.234zm.999-.591l.065-.046.35.503-.064.046a8.01 8.01 0 0 1-.528.342l-.069.04-.31-.53.068-.04c.165-.097.329-.203.488-.315zm-3.077-1.312c-.145 0-.291.09-.291.29 0 .309.343.353.495.219a.282.282 0 0 0 .089-.218c0-.201-.147-.291-.293-.291zm-.34-.55a.885.885 0 0 1 .98.198.914.914 0 0 1 0 1.285.886.886 0 0 1-.98.197.894.894 0 0 1-.563-.84c0-.374.216-.696.562-.84zm2.44-8.523l-.001 3.468h1.85l-2.07 5.308-.126-.05h-.436v-3.096H15.92l2.565-5.551v-.05l.1-.049.04.02h.471zm.953 4.083h-1.566V9.51l-1.605 3.463h2.046v1.949l1.125-2.882zm1.343-3.615a.897.897 0 0 1 .194.993.89.89 0 0 1-.832.558.889.889 0 0 1-.832-.558.898.898 0 0 1 .193-.993.894.894 0 0 1 .638-.266c.242 0 .47.094.64.266zm-.436.85c.104-.103.146-.273.004-.416a.279.279 0 0 0-.2-.09.303.303 0 0 0-.209.092c-.104.103-.146.272-.004.415.14.14.306.101.409 0zm-6.048 9.057l.106-.08.43.577-.104.079c-.613.463-1.27.7-1.912.7a2.526 2.526 0 0 1-2.423-1.787c-.852 0-1.641-.42-2.12-1.153a2.54 2.54 0 0 1-.196-2.452 2.904 2.904 0 0 1-.867-2.62 2.899 2.899 0 0 1 1.651-2.16 2.535 2.535 0 0 1 .282-2.633 2.482 2.482 0 0 1 2.428-.972c.31-.793 1.057-1.072 1.686-.995.665.084 1.36.581 1.416 1.505l.008.132-.715.043-.008-.132c-.034-.558-.455-.824-.858-.84-.4-.014-.844.216-.92.77l-.06.426-.24-.079c-.236-.078-.44-.146-.721-.146a1.79 1.79 0 0 0-1.615.99 1.813 1.813 0 0 0 .133 1.912l.298.418-.493.138a2.205 2.205 0 0 0-1.6 2.12c0 .761.307 1.322 1.025 1.874l.094.071-.093.153c-.135.221-.34.555-.34 1.074 0 .952.73 1.74 1.655 1.827a3.516 3.516 0 0 1 .176-1.48l.042-.126.68.23-.042.124c-.176.53-.17.958-.138 1.214l.044.11c.14.796.55 1.365 1.156 1.603.65.256 1.456.093 2.155-.435zm-1.93-7.952l-.117.056c-.007.003-.128.06-.317.117.19.248.299.542.324.876l.01.132-.715.055-.01-.132c-.053-.701-.695-.843-.722-.849l-.13-.027.004-.016a1.426 1.426 0 0 1-.689-.45l-.084-.1.545-.468.086.1c.442.524 1.358.126 1.397.108l.119-.053.299.651zm-.491 5.037l.021-.13c.084-.507-.245-.735-.428-.82a2.17 2.17 0 0 1-2.432.34l-.117-.059.318-.645.119.06a1.45 1.45 0 0 0 1.376-.042c.433-.25.7-.682.73-1.186l.009-.132.716.045-.009.132c-.02.32-.11.634-.26.914.298.184.83.642.686 1.511l-.022.13-.707-.118zm3.916-8.765l.315.648-.118.057c-.02.01-.822.425-1.203 1.24l-.006.011v9.45h-.717v-1.177a3.01 3.01 0 0 1-.901.579l-.124.046-.25-.676.124-.045c.007-.003.768-.304 1.15-1.07V6.727h.718v.654a3.66 3.66 0 0 1 .894-.67l.118-.059zm-6.258 4.55l.08-.106.57.438-.08.104c-.383.505-.016.926.062 1.005l.09.093-.505.509-.094-.094c-.315-.316-.745-1.13-.123-1.95zM3.2 7.01h2.449a.298.298 0 1 1 0 .596h-2.45a.299.299 0 0 1 0-.596zm0 1.582h4.559a.298.298 0 1 1 0 .597h-4.56a.299.299 0 0 1 0-.597zm0 1.583h3.24a.298.298 0 1 1 0 .596H3.2a.299.299 0 0 1 0-.596z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TestingSimulatorColored.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TextRealizer = function TextRealizer(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M21.51 6.616h-6.628V2.191C14.876.981 13.765.002 12.395 0H2.49C1.119.001.007.98 0 2.191v7.163c.001 1.214 1.115 2.198 2.49 2.2h1.066v2.285c0 .217.148.412.374.495a.665.665 0 0 0 .662-.116l3.02-2.665h1.506v4.425c0 1.215 1.115 2.199 2.49 2.2h4.78l3.02 2.665c.174.153.435.2.662.116.226-.083.374-.279.374-.495v-2.286h1.066c1.375-.001 2.489-.985 2.49-2.2V8.816c-.001-1.214-1.115-2.199-2.49-2.2zM7.36 10.472a.65.65 0 0 0-.43.156l-2.162 1.908v-1.518c0-.296-.27-.536-.606-.536H2.49c-.705 0-1.277-.505-1.278-1.128V2.19c.005-.62.576-1.12 1.278-1.12h9.905c.706 0 1.278.505 1.278 1.129v4.416h-2.068c-.859.002-1.656.394-2.11 1.04-.404.59-.377 1.113-.377 1.16v1.666l-1.758-.01zm15.428 5.506c0 .624-.572 1.13-1.278 1.13h-1.672c-.335 0-.606.239-.606.535v1.529l-2.165-1.908a.65.65 0 0 0-.43-.157h-5.03c-.705-.001-1.276-.506-1.277-1.129V8.816c0-.623.572-1.129 1.277-1.129h9.903c.706 0 1.278.506 1.278 1.129v7.162zm-6.121-2.43a.875.875 0 0 0 .882-.867.875.875 0 0 0-.882-.868.875.875 0 0 0-.882.868c0 .479.395.868.882.868zm-3.785 0a.875.875 0 0 0 .882-.867.875.875 0 0 0-.882-.868.875.875 0 0 0-.882.868c0 .479.395.868.882.868zm7.57 0a.875.875 0 0 0 .881-.867.875.875 0 0 0-.882-.868.875.875 0 0 0-.881.868c0 .479.394.868.881.868z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TextRealizer.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ThumbnailEmptyList = function ThumbnailEmptyList(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.076 5a.213.213 0 0 0-.215.212v4.873h-1.294V7.33c0-.818-.673-1.484-1.5-1.484H1.5C.673 5.846 0 6.512 0 7.33v1.699c0 .117.095.212.213.212H2.57v8.27c0 .117.096.212.214.212h1.5a1.28 1.28 0 0 0 1.284 1.268V19h10.71c.015 0 .028-.005.042-.005h6.609a.213.213 0 0 0 .214-.212v-7h.643a.213.213 0 0 0 .214-.212v-1.272a.213.213 0 0 0-.214-.212h-.643v-.424h.643A.213.213 0 0 0 24 9.45V8.178a.213.213 0 0 0-.214-.212h-.643v-.424h.643A.213.213 0 0 0 24 7.33V6.058a.213.213 0 0 0-.214-.212h-.643v-.634A.213.213 0 0 0 22.93 5h-9.853zm.213.424h7.712v8.156l-1.19.786a.212.212 0 0 0-.095.176v4.029h-2.483c.204-.225.33-.518.33-.843V11.357a1.28 1.28 0 0 0-1.284-1.272h-2.99v-4.66zm8.14 0h1.286v13.147h-2.57v-3.915l1.188-.786a.213.213 0 0 0 .097-.176v-8.27zM1.5 6.27c.59 0 1.07.476 1.07 1.06v1.487H.429V7.33c0-.584.48-1.06 1.07-1.06zm1.046 0h7.522c.59 0 1.07.476 1.07 1.06v4.885H7.71c-.043 0-.083.008-.126.012a.218.218 0 0 0-.088-.02H4.07a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h2.696c-.207.225-.337.521-.339.848H4.07a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h2.356v.849H4.07a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h2.356v.848H4.07a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h2.356v.85H2.998V7.33c0-.416-.175-.79-.453-1.06zm20.598 0h.429v.848h-.429V6.27zm-7.069.426a.213.213 0 0 0-.214.212v1.273c0 .117.096.212.214.212h3.428a.213.213 0 0 0 .214-.212V6.908a.213.213 0 0 0-.214-.212h-3.428zm-10.72.422a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h3.428a.213.213 0 0 0 .214-.212.213.213 0 0 0-.214-.212H5.354zm10.935.002h2.999v.849h-3V7.12zM4.069 8.39a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h5.998a.213.213 0 0 0 .214-.212.213.213 0 0 0-.214-.212H4.069zm19.074 0h.429v.848h-.429V8.39zM4.07 9.663a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h5.998a.213.213 0 0 0 .214-.212.213.213 0 0 0-.214-.212H4.069zm7.497.846h4.713c.472 0 .856.38.856.848v1.188a1.282 1.282 0 0 0-.856-.33h-4.713v-1.706zm11.577.002h.429v.848h-.429v-.848zm-19.074.424a.213.213 0 0 0-.214.212c0 .117.096.212.214.212h5.998a.213.213 0 0 0 .214-.212.213.213 0 0 0-.214-.212H4.069zm3.641 1.704h8.569c.472 0 .856.38.856.848v4.241a.85.85 0 0 1-.815.843h-3.244c-.008 0-.014.004-.021.005H6.527c.203-.225.327-.523.327-.848v-4.241c0-.468.384-.848.856-.848zm-2.998 5.084h1.713v.005a.853.853 0 0 1-.857.848v-.01a.853.853 0 0 1-.856-.843z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ThumbnailEmptyList.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Timeout = function Timeout(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.92 7.51C20.819 9.256 22 11.708 22 14.42 22 19.702 17.514 24 12 24S2 19.702 2 14.42c0-2.645 1.124-5.043 2.939-6.778L3.818 6.126a.58.58 0 0 1 .148-.832l1.65-1.12a.64.64 0 0 1 .869.142L7.596 5.82a10.236 10.236 0 0 1 2.827-.86V4.34c0-.395-.338-.718-.75-.718h-.415c-.412 0-.75-.324-.75-.719V.72c0-.395.338-.719.75-.719h5.484c.412 0 .75.324.75.719v2.185c0 .395-.338.719-.75.719h-.414c-.413 0-.75.323-.75.718v.618c.931.141 1.82.408 2.649.78l1.122-1.519a.64.64 0 0 1 .867-.142l1.651 1.12a.58.58 0 0 1 .149.832L18.92 7.51zM12 21.7c4.19 0 7.6-3.266 7.6-7.28 0-4.015-3.41-7.282-7.6-7.282-4.19 0-7.6 3.267-7.6 7.282 0 4.014 3.41 7.28 7.6 7.28zm0-13.284c3.439 0 6.239 2.667 6.265 5.956H11.95V8.417l.05-.001z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Timeout.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Tools = function Tools(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M6.167 7.616l-2.51 2.412L0 6.474 5.713 1H9.37l1.842 1.79L8.73 5.177l3.844 3.736-2.563 2.464-3.844-3.761zm7.502 7.342l2.562-2.465 7.075 6.9-2.536 2.465-7.101-6.9zm-5.18-2.088a1.632 1.632 0 0 1 2.136-.149l6.21-6.21.847-3.14a.733.733 0 0 1 .317-.397l3.654-1.935a.398.398 0 0 1 .44.066l1.802 1.802a.399.399 0 0 1 .066.44l-1.935 3.654a.728.728 0 0 1-.397.317l-3.14.847-6.21 6.21c.483.64.434 1.553-.149 2.135l-6.01 6.011a1.634 1.634 0 0 1-2.312 0l-1.33-1.33a1.634 1.634 0 0 1 0-2.31l6.01-6.01z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Tools.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Tooltip = function Tooltip(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M12 3a9 9 0 1 0 9 9c0-4.972-4.03-9-9-9zm0 16.532A7.531 7.531 0 0 1 4.467 12a7.532 7.532 0 1 1 15.065 0A7.532 7.532 0 0 1 12 19.532zm1.116-8.612h-2.09v.003h-.778v1.17h.778v4.18H10.2v1.119h.826v.008h2.09v-.008h.684v-1.119h-.684V10.92zm-1.324-1.44c.914 0 1.468-.644 1.468-1.442-.018-.813-.555-1.438-1.431-1.438s-1.45.624-1.45 1.438c0 .798.555 1.442 1.413 1.442z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  })));
};

Tooltip.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Trackers = function Trackers(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.285 11H24v2h-1.715c-.473 4.901-4.384 8.812-9.285 9.285V24h-2v-1.715a10.25 10.25 0 0 1-2.881-.709 4.007 4.007 0 0 0 1.08-1.727c.574.205 1.177.35 1.801.424v-2.019A6.348 6.348 0 0 1 5.746 13h-2.02c.078.643.228 1.264.444 1.853a4.007 4.007 0 0 0-1.72 1.092A10.253 10.253 0 0 1 1.715 13H0v-2h1.715C2.188 6.099 6.1 2.188 11 1.715V0h2v1.715c1.033.1 2.022.352 2.944.734A4.005 4.005 0 0 0 14.88 4.18 8.265 8.265 0 0 0 13 3.727v2.019A6.349 6.349 0 0 1 18.254 11h2.02a8.27 8.27 0 0 0-.436-1.83 4.003 4.003 0 0 0 1.739-1.05c.367.904.61 1.87.708 2.88zM11 16.216V13H7.784A4.347 4.347 0 0 0 11 16.216zM11 11V7.784A4.347 4.347 0 0 0 7.784 11H11zm0-5.254v-2.02A8.35 8.35 0 0 0 3.727 11h2.019A6.349 6.349 0 0 1 11 5.746zm2 2.038V11h3.216A4.347 4.347 0 0 0 13 7.784zM13 13v3.216A4.346 4.346 0 0 0 16.216 13H13zm0 7.273A8.35 8.35 0 0 0 20.273 13h-2.019A6.349 6.349 0 0 1 13 18.254v2.02z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Trackers.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Training = function Training(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M.4 21.862h23.2c.22 0 .4-.181.4-.405V2.405A.403.403 0 0 0 23.6 2H.4c-.22 0-.4.181-.4.405v19.052c0 .224.18.405.4.405zM.8 2.811h22.4v2.432H.8V2.81zm0 3.242h22.4v14.998H.8V6.053zM18 3.621h.8v.811H18v-.81zm1.6 0h.8v.811h-.8v-.81zm1.6 0h.8v.811h-.8v-.81zm-2.782 7.757l-.744-.707a.418.418 0 0 0-.57 0 .369.369 0 0 0 0 .541l.057.054H13.66c-2.865 0-5.496 1.552-6.771 3.975a1.618 1.618 0 0 0-.165-.009c-.844 0-1.53.652-1.53 1.453s.686 1.453 1.53 1.453 1.53-.652 1.53-1.453c0-.475-.24-.897-.613-1.162 1.152-2.13 3.482-3.492 6.019-3.492h3.502l-.056.053a.369.369 0 0 0 0 .541.413.413 0 0 0 .285.112.413.413 0 0 0 .284-.112l.744-.706a.369.369 0 0 0 0-.541zM6.496 9.034c-.844 0-1.53.652-1.53 1.453 0 .802.686 1.453 1.53 1.453.843 0 1.53-.651 1.53-1.453 0-.8-.687-1.453-1.53-1.453zm0 2.142c-.4 0-.725-.31-.725-.689 0-.38.325-.688.725-.688.4 0 .725.309.725.688 0 .38-.326.689-.725.689zm.227 6.197c-.4 0-.725-.308-.725-.688 0-.38.325-.688.725-.688.4 0 .725.309.725.688 0 .38-.325.688-.725.688zm11.641-1.263l.553-.525a.369.369 0 0 0 0-.54.418.418 0 0 0-.57 0l-.552.524-.553-.524a.418.418 0 0 0-.57 0 .369.369 0 0 0 0 .54l.553.525-.552.524a.369.369 0 0 0 0 .54.413.413 0 0 0 .285.113.413.413 0 0 0 .284-.112l.553-.525.552.525a.413.413 0 0 0 .285.112.413.413 0 0 0 .284-.112.369.369 0 0 0 0-.54l-.552-.525z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Training.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TrashBin = function TrashBin(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20.724 6.455c.49 0 .893.372.893.838v14.124c0 1.426-1.238 2.583-2.754 2.583H5.126c-1.52 0-2.754-1.162-2.754-2.583V7.293c0-.466.403-.843.9-.843.49 0 .893.377.893.843v14.13c0 .499.433.9.961.9h13.737c.533 0 .962-.406.962-.9V7.297c0-.466.402-.843.899-.843zM23.1 3.72c.497 0 .894.372.899.843 0 .46-.402.838-.899.838H.894C.402 5.4 0 5.028 0 4.563c0-.466.397-.843.894-.843h5.45v-.97C6.344 1.234 7.655 0 9.275 0h5.445c1.614 0 2.931 1.235 2.931 2.75v.97h5.45zM8.136 2.75v.97h7.723v-.97c0-.589-.512-1.069-1.14-1.069H9.276c-.627 0-1.14.48-1.14 1.068zm4.76 16.687c0 .466-.402.838-.893.838-.492 0-.894-.372-.894-.838V8.866c0-.46.402-.838.894-.838.49 0 .893.372.893.838v10.571zm-3.966 0c0 .466-.402.838-.899.838-.49 0-.893-.372-.893-.838V8.866c0-.46.397-.838.893-.838.497 0 .9.372.9.838v10.571zm7.927 0c0 .466-.402.838-.894.838-.49 0-.893-.372-.893-.838V8.866c0-.46.402-.838.893-.838.492 0 .894.372.894.838v10.571z",
    fill: "currentColor"
  })));
};

TrashBin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TrashBinFilled = function TrashBinFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M19.165 9.591c.42 0 .764.306.764.688v11.599c0 1.171-1.06 2.12-2.356 2.12H5.816c-1.3 0-2.356-.953-2.356-2.12V10.279c0-.382.344-.692.769-.692.42 0 .765.31.765.692v11.603c0 .41.37.74.822.74h11.757c.456 0 .823-.334.823-.74V10.283c0-.382.344-.692.769-.692zm-6.699 10.661c0 .382-.344.688-.765.688-.42 0-.764-.306-.764-.688v-8.68c0-.38.344-.69.764-.69.42 0 .765.307.765.69v8.68zm-3.394 0c0 .382-.344.688-.77.688-.42 0-.764-.306-.764-.688v-8.68c0-.38.34-.69.765-.69s.769.307.769.69v8.68zm6.784 0c0 .382-.345.688-.765.688-.42 0-.765-.306-.765-.688v-8.68c0-.38.345-.69.765-.69.42 0 .765.307.765.69v8.68zM18.379.582c.399-.145.823.026.96.388.129.356-.089.764-.488.91L.99 8.38c-.394.144-.822-.026-.953-.385-.13-.36.083-.767.482-.912l4.383-1.595-.273-.75c-.425-1.168.283-2.505 1.585-2.979L10.594.165c1.298-.472 2.704.095 3.13 1.264l.272.749L18.379.583zM6.07 4.214l.273.75 6.21-2.261-.272-.75c-.165-.453-.712-.674-1.216-.49L6.687 3.056c-.504.183-.78.704-.616 1.157zm12.381.72l.64 1.483c.198.457.035.99-.384 1.259l-1.029.66H9.195c1.07-1.02 1.886-1.679 2.447-1.975.84-.444 1.223-.778 2.447-.611.815.111 1.223.518 1.223 1.222l1.342-2.17a1.017 1.017 0 0 1 1.798.133zm3.176-.38l2.37 3.783c-.921.91-1.682.91-2.281 0-.6-.91-1.307-2.18-2.123-3.81l.734-.35a1.017 1.017 0 0 1 1.3.377z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TrashBinFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var TxtFile = function TxtFile(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.442 0c.308 0 .56.25.558.56v18.724c0 .136-.05.27-.14.371l-3.715 4.159a.564.564 0 0 1-.417.186H6.832a.559.559 0 0 1-.56-.558v-6.14h1.679v5.219h10.347l-.012-4.172a.62.62 0 0 1 .62-.622l3.333.003V1.401H7.951v2.243H6.273V.56A.56.56 0 0 1 6.832 0h16.61zm-3.439 13.044c0 1.035-.864 1.874-1.929 1.874H1.927C.862 14.918 0 14.08 0 13.044v-5.1C0 6.91.862 6.07 1.927 6.07h16.15c1.062 0 1.926.839 1.926 1.874v5.1zM2.256 7.59v1.208H3.92v4.4h1.464v-4.4h1.68V7.59H2.256zm5.016 0l1.864 2.752-1.992 2.856h1.712l1.168-1.736 1.192 1.736h1.752L10.96 10.27l1.848-2.68H11.08l-1.056 1.592L8.976 7.59H7.272zm5.8 0v1.208h1.664v4.4H16.2v-4.4h1.68V7.59h-4.808z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

TxtFile.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Undo = function Undo(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M13.504 1c-4.707 0-8.7 3.167-10.027 7.511l-1.66-2.919L0 6.659l3.674 6.466 6.362-3.734-1.05-1.848-3.64 2.135c.885-3.747 4.202-6.545 8.158-6.545 4.63 0 8.397 3.829 8.397 8.534S18.134 20.2 13.504 20.2v2.133C19.292 22.333 24 17.55 24 11.667 24 5.785 19.292 1 13.504 1z",
    fill: "currentColor"
  })));
};

Undo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Unlinked = function Unlinked(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M5.409 7.976c.086.086.13.197.13.331a.45.45 0 0 1-.13.332.45.45 0 0 1-.332.13H.461a.45.45 0 0 1-.331-.13.45.45 0 0 1-.13-.332c0-.134.043-.245.13-.331a.45.45 0 0 1 .331-.13h4.616c.135 0 .245.043.332.13zM15.692 18.46c.135 0 .246.044.332.13.087.087.13.197.13.332v4.615a.449.449 0 0 1-.13.332.448.448 0 0 1-.332.13.45.45 0 0 1-.331-.13.45.45 0 0 1-.13-.332v-4.615a.45.45 0 0 1 .13-.332.45.45 0 0 1 .331-.13zM6 6.461a.482.482 0 0 1-.332-.13L1.976 2.64a.481.481 0 0 1-.13-.332c0-.124.043-.235.13-.331a.52.52 0 0 1 .332-.13c.125 0 .235.044.331.13l3.693 3.692c.086.096.13.207.13.332a.48.48 0 0 1-.13.331.482.482 0 0 1-.332.13zm12 11.077a.52.52 0 0 1 .332.13l3.692 3.692c.087.096.13.207.13.332a.482.482 0 0 1-.13.332.483.483 0 0 1-.332.13.482.482 0 0 1-.331-.13l-3.692-3.693a.483.483 0 0 1-.13-.331c0-.125.043-.236.13-.332a.518.518 0 0 1 .331-.13zm-.288-3.288a4.198 4.198 0 0 1-.808.605l-.26-3.447 3.953-3.966c.269-.269.403-.596.403-.98a1.32 1.32 0 0 0-.403-.967l-2.121-2.106c-.26-.26-.586-.387-.981-.382-.395.005-.72.137-.98.397l-3.938 3.951-3.447-.26c.202-.336.404-.605.606-.807l4.817-4.832C15.351.64 16.332.23 17.495.23c1.154 0 2.13.4 2.928 1.197l2.12 2.106c.817.798 1.227 1.774 1.227 2.928 0 1.135-.404 2.115-1.212 2.942l-4.846 4.847zm6.159 1.774a.45.45 0 0 1-.332.13h-4.616a.45.45 0 0 1-.331-.13.449.449 0 0 1-.13-.332c0-.135.043-.245.13-.332a.449.449 0 0 1 .331-.13h4.616c.134 0 .245.044.332.13a.45.45 0 0 1 .129.332.45.45 0 0 1-.13.332zM5.524 20.61c.279.26.606.39.98.39.385 0 .712-.135.982-.404l3.937-3.952 3.447.26a4.192 4.192 0 0 1-.606.807l-4.817 4.832c-.798.817-1.779 1.226-2.942 1.226-1.154 0-2.13-.4-2.928-1.197l-2.12-2.106C.64 19.668.23 18.692.23 17.538c0-1.135.404-2.116 1.211-2.942L6.29 9.749c.201-.202.47-.403.807-.605l.26 3.461-3.952 3.952c-.27.27-.404.596-.404.981 0 .375.134.697.404.966l2.12 2.106zM8.308 5.538a.45.45 0 0 1-.332-.13.45.45 0 0 1-.13-.331V.462a.45.45 0 0 1 .13-.332.45.45 0 0 1 .332-.13.45.45 0 0 1 .332.13.45.45 0 0 1 .13.332v4.615a.45.45 0 0 1-.13.332.45.45 0 0 1-.332.13z",
    fill: "currentColor"
  })));
};

Unlinked.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var UpdateFromParent = function UpdateFromParent(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 24l6.314-6.385h-4.91V8.513L4.984 0 3 2.008l7.597 7.683v7.924h-4.91L12 24zM16.21 6.853L21 2.008 19.015 0l-4.791 4.845 1.985 2.008z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

UpdateFromParent.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Upload = function Upload(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M17.816 6.066a.94.94 0 0 1 .118.908c-.12.303-.384.497-.675.497h-3.037v7.682c0 .468-.331.847-.74.847h-2.963c-.41 0-.741-.38-.741-.847V7.47H6.74c-.29 0-.554-.195-.674-.497a.941.941 0 0 1 .117-.908L11.444.29A.707.707 0 0 1 12 0c.213 0 .416.107.557.29l5.26 5.776zm2.984 9.752H24v6.546c0 .905-.715 1.636-1.6 1.636H1.6C.717 24 0 23.269 0 22.364v-6.546h3.2v4.91h17.6v-4.91z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Upload.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var UploadThumbnail = function UploadThumbnail(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.45 15.205l-3.168-3.13a1.854 1.854 0 0 0-1.312-.537H13.88a.35.35 0 0 0-.353.348.35.35 0 0 0 .353.348h5.091c.308 0 .597.119.814.333l2.34 2.312h-4.986c-.693 0-1.299.476-1.44 1.13-.369 1.712-1.924 2.954-3.698 2.954s-3.33-1.242-3.698-2.954c-.141-.654-.747-1.13-1.44-1.13H1.876l2.34-2.312a1.15 1.15 0 0 1 .814-.333h5.091a.35.35 0 0 0 .353-.348.35.35 0 0 0-.353-.348H5.03c-.496 0-.962.191-1.312.537L.55 15.205c-.335.268-.55.678-.55 1.136v5.197C0 22.344.664 23 1.48 23h21.04c.816 0 1.48-.656 1.48-1.462v-5.197c0-.458-.215-.868-.55-1.136zm-.155 6.333a.771.771 0 0 1-.774.766H1.479a.771.771 0 0 1-.774-.766v-5.197c0-.177.061-.34.164-.47a.347.347 0 0 0 .03-.026l.117-.116a.776.776 0 0 1 .463-.154h5.383c.363 0 .679.244.751.58.21.977.76 1.866 1.547 2.503a4.528 4.528 0 0 0 5.68 0 4.438 4.438 0 0 0 1.547-2.504c.072-.335.388-.579.75-.579h5.384c.173 0 .333.058.463.154l.117.116.03.026c.103.13.164.293.164.47v5.197zM7.491 6.151a.353.353 0 0 1-.249-.102.345.345 0 0 1 0-.492l4.509-4.455a.385.385 0 0 1 .026-.023l.012-.01.015-.01.015-.01.015-.008.015-.007.016-.008.015-.005.018-.006.014-.004.02-.004.015-.003.018-.002A.351.351 0 0 1 11.992 1h.016l.027.002.018.002.016.003.019.004.014.004.018.006.015.005.016.008.015.007.015.009.015.009.015.01.012.01a.354.354 0 0 1 .024.021l4.51 4.457a.345.345 0 0 1 0 .492.353.353 0 0 1-.497 0l-3.908-3.86v13.038a.35.35 0 0 1-.352.348.35.35 0 0 1-.352-.348V2.188L7.74 6.048a.353.353 0 0 1-.249.103z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

UploadThumbnail.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var UserCircleOutline = function UserCircleOutline(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M11.997 12.884a3.507 3.507 0 0 0 3.512-3.517 3.507 3.507 0 0 0-3.483-3.501A3.506 3.506 0 0 0 8.491 9.36a3.507 3.507 0 0 0 3.506 3.524m.03 9.717c2.652-.05 5.007-.928 7.027-2.704.248-.218.265-.392.157-.678-1.108-2.912-4.036-4.915-7.21-4.917-3.175 0-6.097 1.998-7.208 4.916-.108.285-.094.462.155.68 2.02 1.773 4.374 2.656 7.08 2.703m-2.94-9.243c-1.18-.964-1.886-2.146-1.984-3.655-.1-1.53.41-2.831 1.507-3.882 1.897-1.818 4.82-1.827 6.745-.033.914.853 1.444 1.91 1.535 3.167.132 1.801-.56 3.25-1.974 4.405 2.541.931 4.352 2.594 5.471 5.011 2.83-3.38 3.35-9.679-.997-13.947C15.21.316 8.477.408 4.373 4.665.223 8.97.876 15.14 3.615 18.366c1.12-2.415 2.93-4.078 5.474-5.008M24 12.023C23.989 18.658 18.603 24.018 11.965 24 5.335 23.982-.023 18.588 0 11.953.023 5.338 5.393-.007 12.011 0c6.633.006 12 5.39 11.989 12.023",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

UserCircleOutline.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var UserFilled = function UserFilled(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M12 1c2.833 0 5 2.167 5 5s-2.167 5-5 5-5-2.167-5-5 2.167-5 5-5zm0 22c5.523 0 10-2.015 10-4.5s-4.477-5-10-5-10 2.515-10 5S6.477 23 12 23z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

UserFilled.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Utilities = function Utilities(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M2.108 21.58c.038-.125.922-1.188.922-5.998V12.87h6.06v1.205H3.94a.302.302 0 0 0-.304.301c0 .167.136.302.303.302h5.455a.302.302 0 0 0 .303-.302v-1.808a.302.302 0 0 0-.303-.301H2.727a.302.302 0 0 0-.303.301v3.014c0 4.714-.887 5.795-.896 5.825a.301.301 0 0 0 .29.388c.13 0 .251-.085.29-.215zm1.61-11.072c.393.357.902.553 1.433.553a.302.302 0 0 0 .304-.301.302.302 0 0 0-.304-.301c-.38 0-.743-.14-1.023-.396a.304.304 0 0 0-.428.019.3.3 0 0 0 .019.426zM2.113 7.445a.301.301 0 1 0 .003-.603h-.003a.302.302 0 0 0 0 .603zm7.879 1.206a.301.301 0 1 0 .003-.603H9.99a.302.302 0 0 0-.303.301c0 .167.136.302.303.302zM8.909 15.9c.182.32.425.223.425.223l2.256-1.122a.301.301 0 0 0 .168-.27V7.568l2.097 1.285v2.335a.302.302 0 1 0 .606 0v-2.57a.301.301 0 0 0-.23-.292l-2.473-1.38V6.58a.302.302 0 0 0-.303-.302.302.302 0 0 0-.303.302v7.967l-2.257 1.122c-.103.052.014.233.014.233zm.788-5.744c0-.609-.37-1.15-.916-1.383a1.21 1.21 0 0 0-1.934-1.085 2.134 2.134 0 0 0-1.696-.846 2.12 2.12 0 0 0-2.104 1.843 1.513 1.513 0 0 0-1.835 1.471c0 .831.68 1.507 1.515 1.507a.302.302 0 0 0 .303-.301.302.302 0 0 0-.303-.302.908.908 0 0 1-.909-.904c0-.498.408-.904.91-.904.159 0 .313.044.46.13a.304.304 0 0 0 .456-.287 1.513 1.513 0 0 1 1.508-1.65c.584 0 1.123.341 1.371.87a.303.303 0 0 0 .535.028.605.605 0 0 1 1.124.307.59.59 0 0 1-.043.216.3.3 0 0 0 .223.405.907.907 0 0 1 .729.885.908.908 0 0 1-.91.904.908.908 0 0 1-.908-.904.302.302 0 0 0-.303-.3.302.302 0 0 0-.303.3c0 .831.68 1.507 1.515 1.507.835 0 1.515-.676 1.515-1.507zM.303 22.397A.302.302 0 0 0 0 22.7c0 .166.136.301.303.301h4.848a.302.302 0 0 0 .304-.301.302.302 0 0 0-.304-.302H.303zm7.879 0a.302.302 0 0 0-.303.302c0 .166.136.301.303.301h4.242a.302.302 0 0 0 .303-.301.302.302 0 0 0-.303-.302H8.182zm-1.818 0a.302.302 0 0 0-.303.302c0 .166.135.301.303.301h.606a.302.302 0 0 0 .303-.301.302.302 0 0 0-.303-.302h-.606zm-.26-2.818a.293.293 0 0 0-.286.3c0 .165.128.3.286.3a1.577 1.577 0 0 0 1.02-.376 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.018-.375 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.02-.375 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.018-.375 1.577 1.577 0 0 0 1.02.375.293.293 0 0 0 .285-.3c0-.165-.127-.299-.285-.299a1.04 1.04 0 0 1-.803-.386.28.28 0 0 0-.217-.104.28.28 0 0 0-.216.104 1.04 1.04 0 0 1-.803.386 1.04 1.04 0 0 1-.803-.386.28.28 0 0 0-.217-.104.28.28 0 0 0-.216.104 1.04 1.04 0 0 1-.803.386 1.04 1.04 0 0 1-.803-.386.28.28 0 0 0-.217-.104.28.28 0 0 0-.216.104 1.04 1.04 0 0 1-.803.386 1.04 1.04 0 0 1-.803-.386.28.28 0 0 0-.217-.104.28.28 0 0 0-.216.104 1.04 1.04 0 0 1-.803.386zm0-1.95a.293.293 0 0 0-.286.3c0 .165.128.299.286.299a1.577 1.577 0 0 0 1.02-.376 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.018-.375 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.02-.375 1.577 1.577 0 0 0 1.02.375 1.577 1.577 0 0 0 1.018-.375 1.577 1.577 0 0 0 1.02.375.293.293 0 0 0 .285-.299c0-.165-.127-.3-.285-.3a1.04 1.04 0 0 1-.803-.386.28.28 0 0 0-.217-.103.28.28 0 0 0-.216.103 1.04 1.04 0 0 1-.803.387 1.04 1.04 0 0 1-.803-.387.28.28 0 0 0-.217-.103.28.28 0 0 0-.216.103 1.04 1.04 0 0 1-.803.387 1.04 1.04 0 0 1-.803-.387.28.28 0 0 0-.217-.103.28.28 0 0 0-.216.103 1.04 1.04 0 0 1-.803.387 1.04 1.04 0 0 1-.803-.387.28.28 0 0 0-.217-.103.28.28 0 0 0-.216.103 1.04 1.04 0 0 1-.803.387zm9.344-11.637h1.077a.29.29 0 0 1 .222.1.255.255 0 0 1 .054.226l-.593 2.417 2.526-2.743h-1.077a.29.29 0 0 1-.222-.1.255.255 0 0 1-.054-.226l.593-2.417-2.526 2.743zm.229 3.992a.296.296 0 0 1-.128-.029.262.262 0 0 1-.148-.297l.769-3.134h-1.342a.285.285 0 0 1-.257-.155.253.253 0 0 1 .044-.285l3.676-3.992a.295.295 0 0 1 .342-.063.26.26 0 0 1 .148.297l-.769 3.134h1.342c.11 0 .21.06.257.155a.253.253 0 0 1-.044.285l-3.676 3.992a.29.29 0 0 1-.214.092zm3.566 8.868h1.506v-.29h-1.506v.29zm-.041-.797h1.588a.47.47 0 0 1 .475.466v.371a.47.47 0 0 1-.475.465h-1.588a.47.47 0 0 1-.474-.465v-.371a.47.47 0 0 1 .474-.466zm-.949-.415a.414.414 0 0 0-.419-.404.414.414 0 0 0-.416.407c0 .11.045.217.126.294.08.078.19.12.302.118a.414.414 0 0 0 .407-.415zm.516.01a.925.925 0 0 1-.937.908.924.924 0 0 1-.93-.915c.001-.244.101-.478.278-.65a.946.946 0 0 1 .666-.265.924.924 0 0 1 .923.922zm3.377.405c.231 0 .418-.183.418-.41a.414.414 0 0 0-.418-.409.414.414 0 0 0-.417.41.417.417 0 0 0 .417.41zm.934-.412a.924.924 0 0 1-.934.915.924.924 0 0 1-.933-.915.927.927 0 0 1 .933-.915c.516 0 .934.41.934.915zm-5.515-1.653h2.173v-3.261h-2.173v3.26zm4.862-3.261h-2.173v3.26h2.173v-3.26zm.042-.506a.47.47 0 0 1 .474.465v3.342a.47.47 0 0 1-.474.465h-4.945a.47.47 0 0 1-.475-.465v-3.342a.47.47 0 0 1 .475-.465h4.945zm-2.215-1.876h-.516v.604h.516v-.604zm-3.749 8.083c0 .386.13 1.289 1.315 1.289h4.35c.394 0 1.314-.127 1.314-1.29v-5.683c0-1.165-.92-1.289-1.314-1.289h-4.347c-.405 0-1.315.124-1.315 1.29l-.003 5.683zm1.521 2.81h3.94l-.413-1.01H18.45l-.423 1.01zm4.144-10.289c.884 0 1.83.473 1.83 1.795v5.684c0 1.324-.946 1.794-1.83 1.794h-.062l1.214 2.28a.251.251 0 0 1-.144.33.26.26 0 0 1-.336-.142l-.672-.946h-4.347l-.663.943a.26.26 0 0 1-.335.142.252.252 0 0 1-.144-.329l1.211-2.278h-.062c-1.35 0-1.83-.927-1.83-1.794v-5.684c0-1.324.946-1.795 1.83-1.795h1.393v-.604h-.405a.255.255 0 0 1-.258-.253c0-.14.115-.252.258-.252h2.34c.143 0 .259.113.259.252 0 .14-.116.253-.258.253h-.39v.604h1.4zm-8.534 11.446h3.152a.302.302 0 0 1 0 .603h-3.152a.302.302 0 0 1-.303-.301c0-.167.136-.302.303-.302z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

Utilities.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var XPackType = function XPackType(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M.286 4h2.81l2.882 5.421L8.859 4h2.846l-4.206 7.896 4.564 8.604H9.18l-3.203-5.893L2.81 20.5H0l4.51-8.462L.286 4zm18.757 0c1.574 0 2.794.495 3.66 1.485.864.99 1.297 2.389 1.297 4.196 0 1.885-.433 3.35-1.298 4.396-.865 1.045-2.085 1.567-3.66 1.567h-2.738V20.5h-2.398V4h5.137zm-.126 8.863c.907 0 1.602-.26 2.085-.778.483-.519.725-1.289.725-2.31 0-1.006-.242-1.76-.725-2.263-.483-.503-1.178-.754-2.085-.754h-2.613v6.105h2.613z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

XPackType.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var XPacks = function XPacks(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.35 11.53L7.577 8.008c.086-.892.308-1.017.309-1.018 2.249-.062 2.78.747 2.78.747l1.365 1.764 2.035-2.456s1.057-1.316 3.438-.994c0 0 .408.373.496 1.092l-3.996 4.908 3.1 4.005c-.07.604-.394.915-.394.915-1.89.269-2.73-.831-2.73-.831l-1.625-2.064L9.892 17.1s-.67.97-3.503.895c0 0-.28-.15-.389-1.217l4.35-5.25zM4.68 2.3A2.38 2.38 0 0 0 2.3 4.68v14.64a2.38 2.38 0 0 0 2.38 2.38h14.64a2.38 2.38 0 0 0 2.38-2.38V4.68a2.38 2.38 0 0 0-2.38-2.38H4.68zM4 0h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

XPacks.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ZipFileThin = function ZipFileThin(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M23.863 6.495c.088.086.137.2.137.32v15.34C24 23.173 23.12 24 22.037 24H7.351c-1.083 0-1.963-.828-1.963-1.846V18h-3.92C.659 18 0 17.38 0 16.617V9.69c0-.763.659-1.383 1.469-1.383h3.919v-6.46C5.388.83 6.268 0 7.35 0h9.67c.134 0 .261.051.353.141l6.49 6.354zm-6.72-5.249v5.216h5.327l-5.327-5.216zM1.469 17.076h13.226c.27 0 .489-.206.489-.46V9.692c0-.254-.22-.46-.49-.46H1.47c-.27 0-.49.206-.49.46v6.926c0 .253.22.46.49.46zm21.551 5.08V7.384h-6.367c-.27 0-.49-.207-.49-.462v-6H7.351c-.543 0-.984.415-.984.926v6.459h8.328c.81 0 1.468.62 1.468 1.383v6.926c0 .762-.659 1.383-1.468 1.383H6.367v4.154c0 .51.441.923.984.923h14.686c.542 0 .983-.413.983-.922zM7.91 11.265h.85v3.965h-.85v-3.965zm-2.904 3.297H7.4v.668H3.982v-.722l2.21-2.572h-1.96v-.67H7.31v.621l-2.305 2.675zm7.542-2.85c.163.2.244.457.244.773 0 .243-.047.448-.14.614a1.107 1.107 0 0 1-.358.39 1.27 1.27 0 0 1-.44.188 5.145 5.145 0 0 1-.882.057h-.553v1.496h-.85v-3.965h1.363c.517 0 .854.02 1.01.06.242.06.443.189.606.388zm-.727 1.092a.511.511 0 0 0 .096-.308.495.495 0 0 0-.135-.357.599.599 0 0 0-.342-.176 4.337 4.337 0 0 0-.61-.027h-.411v1.125h.465c.334 0 .558-.02.671-.062a.554.554 0 0 0 .266-.195z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

ZipFileThin.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ZipFiles = function ZipFiles(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M20 0v7.29h-1.945V1.847h-10.5V7.29h-5.61v14.864h16.11v-.923H20V24H0V5.465L5.756 0H20zm-7.302 10.487v1.217L8.67 16.107h4.094v1.49H6.002v-1.206l4.028-4.413H6.144v-1.491h6.554zm3.103 0v7.111h-1.992v-7.111h1.992zm4.833 0c.973 0 1.728.218 2.265.654.537.436.806 1.05.806 1.841 0 .839-.269 1.49-.806 1.953-.537.464-1.292.695-2.265.695h-1.36v1.968H17.28v-7.111zm-.097 1.481h-1.264v2.181h1.264c.406 0 .72-.094.941-.284.222-.189.332-.463.332-.822 0-.345-.11-.61-.332-.796-.222-.186-.535-.279-.94-.279zM5.708 2.588L2.731 5.446h2.977V2.589z",
    fill: "currentColor"
  })));
};

ZipFiles.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ZoomIn = function ZoomIn(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24 10.55v2.841H13.333V24H10.61V13.391H0v-2.84h10.609V0h2.724v10.55z"
  })));
};

ZoomIn.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ZoomOut = function ZoomOut(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24 10.5v2.88H0V10.5z"
  })));
};

ZoomOut.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var glyphMap = {
  actions: Actions,
  'add-field': AddField,
  'add-map-intent': AddMapIntent,
  'add-project': AddProject,
  'angle-down': AngleDown,
  'angle-left': AngleLeft,
  'angle-right': AngleRight,
  'angle-square-down': AngleSquareDown,
  'angle-square-up': AngleSquareUp,
  'angle-up': AngleUp,
  annotations: Annotations,
  'api-input-fields': ApiInputFields,
  'api-output-fields': ApiOutputFields,
  'api-url': ApiUrl,
  'application-settings': ApplicationSettings,
  applications: Applications,
  archived: Archived,
  arrange: Arrange,
  'arrange-vertical': ArrangeVertical,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-tree': ArrowTree,
  'ask-for-field': AskForField,
  banking: Banking,
  'bargin-off': BarginOff,
  'bargin-off-filled': BarginOffFilled,
  'bargin-on': BarginOn,
  'bargin-on-filled': BarginOnFilled,
  booking: Booking,
  bookmark: Bookmark,
  bot: Bot,
  'bot-circle': BotCircle,
  branch: Branch,
  canvas: Canvas,
  'caret-down': CaretDown,
  'caret-left': CaretLeft,
  'caret-right': CaretRight,
  'caret-square-down': CaretSquareDown,
  'caret-up': CaretUp,
  check: Check,
  'check-circle': CheckCircle,
  'circle-empty': CircleEmpty,
  'circle-filled': CircleFilled,
  'clear-text': ClearText,
  clock: Clock,
  clone: Clone,
  'clone-project': CloneProject,
  'clone-project-thin': CloneProjectThin,
  close: Close,
  'close-circle': CloseCircle,
  collapse: Collapse,
  'collapse-double-arrows': CollapseDoubleArrows,
  commit: Commit,
  'configuration-locked': ConfigurationLocked,
  'context-rule-type': ContextRuleType,
  'context-rules': ContextRules,
  contexts: Contexts,
  'conversation-studio-logo': ConversationStudioLogo,
  copy: Copy,
  'create-project': CreateProject,
  'create-project-thin': CreateProjectThin,
  'csv-files': CsvFiles,
  date: Date$1,
  'debug-logs': DebugLogs,
  'default-target': DefaultTarget,
  deployment: Deployment,
  'deployment-bold': DeploymentBold,
  'deployment-filled': DeploymentFilled,
  'deployment-export': DeploymentExport,
  'dialog-error': DialogError,
  diamant: Diamant,
  dictionaries: Dictionaries,
  dock: Dock,
  download: Download,
  edit: Edit,
  'edit-info': EditInfo,
  effect: Effect,
  entities: Entities,
  'entities-fields': EntitiesFields,
  'entity-rule-type': EntityRuleType,
  environment: Environment,
  'error-403': Error403,
  'error-404': Error404,
  'error-general': ErrorGeneral,
  'exit-action': ExitAction,
  'exit-action-color': ExitActionColor,
  expand: Expand,
  'expand-double-arrows': ExpandDoubleArrows,
  'expand-elements': ExpandElements,
  'export-resources': ExportResources,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-slash': EyeSlash,
  favorite: Favorite,
  'favorite-filled': FavoriteFilled,
  fetch: Fetch,
  file: File,
  filter: Filter,
  'first-page': FirstPage,
  flow: Flow,
  folder: Folder,
  'fulfill-intent-filled': FulfillIntentFilled,
  'fulfill-intent-outline': FulfillIntentOutline,
  'get-started-colored': GetStartedColored,
  git: Git,
  'git-logo': GitLogo,
  'gitlab-logo': GitLabLogo,
  'go-to-line': GoToLine,
  'grid-view': GridView,
  handoff: Handoff,
  'handoff-color': HandoffColor,
  help: Help,
  home: Home,
  'import-merge': ImportMerge,
  'import-project': ImportProject,
  'import-project-small': ImportProjectSmall,
  'import-resources': ImportResources,
  'input-fields': InputFields,
  insurance: Insurance,
  intents: Intents,
  keyboard: Keyboard,
  'last-page': LastPage,
  link: Link,
  'link-horizontal': LinkHorizontal,
  'list-view': ListView,
  'lock-filled': LockFilled,
  'lock-outline': LockOutline,
  'log-event': LogEvent,
  'log-files': LogFiles,
  logout: Logout,
  'machine-learning': MachineLearning,
  merge: Merge,
  'methods-flow': MethodsFlow,
  'ml-training': MLTraining,
  minus: Minus,
  modified: Modified,
  'move-line-down': MoveLineDown,
  'move-line-up': MoveLineUp,
  multivalues: Multivalues,
  'next-page': NextPage,
  'nice-reaction-filled': NiceReactionFilled,
  'nice-reaction-outline': NiceReactionOutline,
  nlu: Nlu,
  'nlu-export': NluExport,
  'no-available': NoAvailable,
  'notification-bell': NotificationBell,
  'notification-error': NotificationError,
  'notification-info': NotificationInfo,
  'notification-verify': NotificationVerify,
  'notification-warning': NotificationWarning,
  numbers: Numbers,
  options: Options,
  ordering: Ordering,
  original: Original,
  'output-fields': OutputFields,
  pause: Pause,
  plus: Plus,
  'plus-circle': PlusCircle,
  'plus-square': PlusSquare,
  'previous-page': PreviousPage,
  "private": Private,
  process: Process,
  project: Project,
  "public": Public,
  quote: Quote,
  'rapid-flow': RapidFlow,
  'rapid-flow-circle': RapidFlowCircle,
  reactions: Reactions,
  redo: Redo,
  referents: Referents,
  refresh: Refresh,
  repeat: Repeat,
  'resize-window': ResizeWindow,
  resources: Resources,
  'response-type': ResponseType,
  resume: Resume,
  rollback: Rollback,
  'rule-group': RuleGroup,
  run: Run,
  save: Save,
  'save-thin': SaveThin,
  search: Search,
  'search-resources': SearchResources,
  'search-settings': SearchSettings,
  send: Send,
  settings: Settings,
  'single-value': SingleValue,
  'small-talk': SmallTalk,
  snapshot: Snapshot,
  sorting: Sorting,
  stop: Stop,
  sync: Sync,
  tag: Tag,
  'target-priority': TargetPriority,
  targets: Targets,
  telecoms: Telecoms,
  'test-set': TestSet,
  'test-set-editor': TestSetEditor,
  'testing-simulator-colored': TestingSimulatorColored,
  'text-realizer': TextRealizer,
  'thumbnail-empty-list': ThumbnailEmptyList,
  timeout: Timeout,
  tools: Tools,
  tooltip: Tooltip,
  trackers: Trackers,
  training: Training,
  'trash-bin': TrashBin,
  'trash-bin-filled': TrashBinFilled,
  'txt-file': TxtFile,
  undo: Undo,
  unlinked: Unlinked,
  'update-from-parent': UpdateFromParent,
  upload: Upload,
  'upload-thumbnail': UploadThumbnail,
  'user-circle-outline': UserCircleOutline,
  'user-filled': UserFilled,
  utilities: Utilities,
  'xpack-type': XPackType,
  xpacks: XPacks,
  'zip-file-thin': ZipFileThin,
  'zip-files': ZipFiles,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut
};
var UPCOMING_DEPRECATIONS = {
  'bargin-off-filled': 'deployment',
  'bargin-on-filled': 'bargin-on',
  'bot-circle': 'bot',
  'branch-light': 'branch',
  'clone-project-thin': 'clone-project',
  // prettier-ignore
  'copy': 'clone',
  'create-project-thin': 'create-project',
  'deployment-bold': 'deployment',
  'deployment-export': 'upload',
  'edit-info': 'modified',
  'exit-action-color': 'exit-action',
  'export-resources': 'upload',
  'fulfill-intent-filled': 'fulfill-intent-outline',
  'handoff-color': 'handoff',
  'import-merge': 'download',
  'import-project': 'download',
  'import-project-small': 'download',
  'import-resources': 'download',
  'link-horizontal': 'link',
  'lock-filled': 'lock-outline',
  'nice-reaction-filled': 'nice-reaction-outline',
  'rapid-flow-circle': 'rapid-flow',
  'save-thin': 'save',
  'search-resources': 'ask-for-field',
  'search-settings': 'settings',
  'upload-thumbnail': 'upload',
  'zip-file-thin': 'zip-files'
};

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: inline-flex;\n  font-size: 10px;\n  height: ", ";\n  justify-content: center;\n  margin: 0;\n  text-align: center;\n  width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  ", ";\n  color: ", ";\n\n  > svg {\n    ", ";\n    max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DEFAULT_SIZE = '24';

function getSize(props) {
  var length = rem("".concat(props.size, "px"), '14px');
  return "height: ".concat(length, "; width: ").concat(length, ";");
}

var SIconWrapper = styled.span(_templateObject(), getSize, function (props) {
  return props.color;
}, getSize);
var SErrorMsg = styled.p(_templateObject2(), colors.COLOR_GREY_200, colors.COLOR_ALERT_ERROR, function (_ref) {
  var size = _ref.size;
  return "".concat(size, "px");
}, function (_ref2) {
  var size = _ref2.size;
  return "".concat(size, "px");
});

var isGoingToBeDeprecated = function isGoingToBeDeprecated(glyph) {
  return Object.keys(UPCOMING_DEPRECATIONS).includes(glyph);
};

var Icon = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var glyph = _ref3.glyph,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? DEFAULT_SIZE : _ref3$size,
      _ref3$primaryColor = _ref3.primaryColor,
      primaryColor = _ref3$primaryColor === void 0 ? '#475369' : _ref3$primaryColor,
      restProps = _objectWithoutProperties(_ref3, ["glyph", "size", "primaryColor"]);

  var Glyph = glyphMap[glyph];

  if (isGoingToBeDeprecated(glyph)) {
    console.warn('Deprecation Warning for Icon component! Glyph "%s" will be deprecated soon.\n' + 'Please replace it with "%s" as soon as possible.', glyph, UPCOMING_DEPRECATIONS[glyph]);
  }

  return /*#__PURE__*/createElement(ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref4) {
      var error = _ref4.error;
      return /*#__PURE__*/createElement(SErrorMsg, {
        size: size,
        role: "alert"
      }, "Invalid\nGlyph");
    }
  }, /*#__PURE__*/createElement(SIconWrapper, _extends({
    size: size,
    color: primaryColor,
    ref: ref
  }, restProps), /*#__PURE__*/createElement(Glyph, null)));
});
Icon.displayName = 'Icon';
export default Icon;